var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRalewayBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Thu Feb  4 21:54:21 2016\n By Aleksey,,,\nCopyright (c) 2010 - 2013, Matt McInerney (matt@pixelspread.com), Pablo Impallari (impallari@gmail.com), Rodrigo Fuenzalida (hello@rfuenzalida.com) with Reserved Font Name \"Raleway\"\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Raleway-Bold",
    horizAdvX: 599
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Raleway",
    fontWeight: 700,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 8 3 3 1 1 6 0 3",
    ascent: 800,
    descent: -200,
    xHeight: 524,
    capHeight: 710,
    bbox: "-202 -229 1309 923",
    underlineThickness: 50,
    underlinePosition: -150,
    unicodeRange: "U+0020-FB06"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f",
    unicode: "ff",
    horizAdvX: 642,
    d: "M567 626q-41 0 -59.5 -28t-18.5 -65v-37h138v-102h-138v-394h-134v394h-128v-394h-134v394h-69v102h69v13q0 41 12 76.5t35 62t56 41.5t75 15q34 0 66.5 -8t62.5 -21q23 30 57.5 47.5t82.5 17.5q38 0 68.5 -10t56.5 -21l-26 -101q-14 7 -31.5 12.5t-40.5 5.5zM355 496 q0 5 0.5 16.5t1.5 24t3 23.5t4 16q-15 8 -33.5 11t-32.5 3q-38 0 -54.5 -22t-16.5 -55v-17h128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_i",
    unicode: "fi",
    horizAdvX: 568,
    d: "M93 394h-69v102h69v32q0 43 14.5 82t42 67.5t67 45.5t89.5 17q57 0 104.5 -18.5t89.5 -46.5l-53 -100q-26 23 -61 37t-71 14q-45 0 -66.5 -28t-21.5 -65v-37h281v-496h-134v394h-147v-394h-134v394z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_l",
    unicode: "fl",
    horizAdvX: 657,
    d: "M659 17q-1 -1 -12 -5t-29 -8.5t-40.5 -8t-44.5 -3.5q-32 0 -56.5 9t-41.5 24.5t-26 35.5t-9 43v413q0 22 -3.5 42t-13 35t-26 23.5t-41.5 8.5q-49 0 -68.5 -31t-20.5 -81v-18h87v-102h-87v-394h-134v394h-69v102h69v44q0 97 58 148.5t161 51.5q114 0 168 -54t54 -142 v-373q0 -10 2.5 -20.5t8.5 -19t15 -14t22 -5.5q9 0 19 2t18.5 4.5t14.5 4.5l6 2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_i",
    unicode: "ffi",
    horizAdvX: 831,
    d: "M93 394h-69v102h69v13q0 40 12 75.5t34.5 62t56 42t75.5 15.5q34 0 66.5 -8t62.5 -21q27 30 69 47.5t98 17.5q52 0 101 -18t94 -47l-53 -100q-25 22 -60.5 36.5t-68.5 14.5q-48 0 -69.5 -28t-21.5 -65v-37h282v-496h-135v394h-147v-394h-134v394h-128v-394h-134v394z M355 496q0 5 0.5 16.5t1.5 24t3 23.5t4 16q-15 8 -33.5 11t-32.5 3q-38 0 -54.5 -22.5t-16.5 -54.5v-17h128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_l",
    unicode: "ffl",
    horizAdvX: 920,
    d: "M796 -8q-31 0 -55.5 9t-42 24.5t-26.5 35.5t-9 43v417q0 21 -4 40t-13.5 33.5t-26.5 23t-43 8.5q-24 0 -40 -9t-26.5 -25t-15 -36.5t-4.5 -43.5v-16h87v-102h-87v-394h-134v394h-129v-394h-134v394h-69v102h69v13q0 41 12.5 76.5t36 62t57 41.5t74.5 15q35 0 66 -8 t61 -21q57 65 175 65q113 0 167.5 -54t54.5 -142v-373q0 -10 2.5 -20.5t8.5 -19t15 -14t22 -5.5q9 0 19 2t18.5 4.5t14.5 4.5t7 2l18 -108q-1 -1 -12 -5t-29 -8.5t-40.5 -8t-44.5 -3.5zM356 496q0 6 0.5 18t1 24.5t2 23.5t3.5 15q-15 8 -31.5 10.5t-30.5 2.5 q-37 0 -55.5 -23t-18.5 -53v-18h129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 240
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 307,
    d: "M87 267v450h134v-450h-134zM87 0v151h134v-151h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 393,
    d: "M61 499v224h114v-224h-114zM218 499v224h114v-224h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 721,
    d: "M685 424h-146l-32 -137h131v-100h-155l-46 -187h-108l47 187h-120l-45 -187h-108l46 187h-112v100h136l33 137h-122v94h145l47 192h108l-48 -192h120l46 192h108l-47 -192h122v-94zM400 287l32 137h-119l-33 -137h120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 634,
    d: "M509 524q-6 7 -22.5 17t-39 20.5t-49.5 19t-56 11.5v-173l25 -6q52 -14 94.5 -30t72 -40t45.5 -57.5t16 -82.5q0 -55 -19.5 -94t-53 -64t-78 -37.5t-93.5 -14.5v-110h-60v111q-70 5 -136.5 28.5t-120.5 61.5l61 119q8 -8 27.5 -21t47 -25.5t61 -23.5t69.5 -15v172 q-9 2 -18 4.5t-18 5.5q-51 14 -88.5 30.5t-62.5 39t-37.5 52t-12.5 70.5q0 50 17.5 89.5t48 67.5t72.5 44t90 20v102h60v-101q66 -5 121.5 -27t97.5 -51zM448 189q0 34 -28 53t-78 35v-161q106 3 106 73zM205 514q0 -34 23.5 -51.5t71.5 -31.5v162q-95 -6 -95 -79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 786,
    d: "M200 417q-35 0 -65 12t-52 32.5t-35 48t-13 59.5q0 31 13 59t35 48t52 32t65 12q34 0 64.5 -12t52.5 -32t35 -48t13 -59q0 -32 -13 -59.5t-35 -48t-52.5 -32.5t-64.5 -12zM200 484q15 0 27.5 7t22.5 18.5t15.5 27t5.5 32.5q0 35 -21 59.5t-50 24.5q-15 0 -27.5 -7 t-22.5 -18.5t-15.5 -26.5t-5.5 -32q0 -35 21 -60t50 -25zM586 -10q-35 0 -65 12t-52 32t-35 47.5t-13 59.5t13 59.5t35 48t52 32.5t65 12t65 -12t52.5 -32.5t35 -48t12.5 -59.5t-12.5 -59.5t-35 -47.5t-52.5 -32t-65 -12zM586 57q15 0 27.5 7t22.5 18.5t15.5 26.5t5.5 32 q0 18 -6 33.5t-15.5 27t-22.5 18t-27 6.5q-15 0 -27.5 -7t-22.5 -18.5t-15.5 -27t-5.5 -32.5q0 -35 21 -59.5t50 -24.5zM91 47l282 329l260 342l61 -54l-273 -323l-269 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 712,
    d: "M536 0l-56 59q-44 -34 -95 -51.5t-105 -17.5q-55 0 -99.5 17t-75.5 46t-48 67.5t-17 80.5q0 33 10 61t27.5 51.5t40 43.5t47.5 37q-43 48 -60.5 82.5t-17.5 72.5t15 69.5t41 54t61.5 34.5t77.5 12q37 0 71 -10t60 -29.5t42 -49t16 -68.5q0 -58 -34 -101.5t-87 -81.5 l136 -142q15 32 23.5 70t8.5 82h109q-1 -71 -17 -129t-45 -106l147 -154h-176zM293 95q62 0 115 41l-164 173q-35 -25 -55 -51t-20 -58q0 -21 9 -40.5t25.5 -33.5t39.5 -22.5t50 -8.5zM209 553q0 -9 3 -17.5t10 -18.5t18.5 -23t29.5 -32q38 26 58 48.5t20 49.5t-18.5 43.5 t-47.5 16.5q-32 0 -52.5 -19.5t-20.5 -47.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 235,
    d: "M61 499v224h114v-224h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 310,
    d: "M34 347q0 51 11.5 101.5t32 101.5t47.5 102.5t58 104.5l102 -43q-16 -24 -37.5 -65.5t-41 -92t-33.5 -106t-14 -106.5q0 -81 34.5 -168t88.5 -180l-98 -49q-31 46 -58.5 95.5t-47.5 100.5t-32 102t-12 102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 309,
    d: "M275 347q0 -51 -12 -102t-32 -102t-47.5 -100.5t-58.5 -95.5l-98 49q55 93 89 180t34 168q0 51 -14 106.5t-33.5 106t-41 92t-37.5 65.5l103 43q31 -53 58 -104.5t47 -102.5t31.5 -101.5t11.5 -101.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 345,
    d: "M75 520l47 71l-71 22l18 58l73 -31l-5 77h71l-5 -77l72 31l18 -58l-70 -22l47 -71l-52 -34l-45 75l-46 -75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 421,
    d: "M374 409v-108h-103v-113h-121v113h-103v108h103v113h121v-113h103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 232,
    d: "M73 -115l27 119h-42v140h116v-140l-41 -119h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 418,
    d: "M58 214v121h303v-121h-303z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 225,
    d: "M58 0v144h110v-144h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 698,
    d: "M671 710l-496 -710h-148l495 710h149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 614,
    d: "M565 293q0 -66 -19.5 -121.5t-54 -96t-82 -63t-102.5 -22.5q-56 0 -103 22.5t-81.5 63t-54 96t-19.5 121.5t19.5 121.5t54 96t81.5 63.5t103 23q55 0 102.5 -23t82 -63.5t54 -96t19.5 -121.5zM430 293q0 40 -9 73.5t-25.5 57.5t-39 37t-49.5 13q-28 0 -50.5 -13t-39 -37 t-25.5 -57.5t-9 -73.5t9 -73t25.5 -57t39 -37t50.5 -13q27 0 49.5 13t39 37t25.5 57t9 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 494,
    d: "M470 121v-121h-406v121h142v303q-9 -12 -28.5 -24.5t-42.5 -23.5t-47.5 -18t-43.5 -7v125q18 0 44 11.5t51 27.5t43.5 31.5t23.5 24.5h137v-450h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 564,
    d: "M38 0q0 45 7 81.5t24.5 67.5t48 58t77.5 53q41 22 72.5 38.5t52.5 30.5t32 28.5t11 33.5q0 30 -24 51.5t-69 21.5q-24 0 -44 -6.5t-37.5 -17.5t-32 -24.5t-26.5 -28.5l-86 99q13 14 37 30.5t56.5 31t72 24t84.5 9.5q51 0 91 -12.5t67.5 -35t42 -54t14.5 -68.5 q0 -35 -13 -62t-33 -48t-43.5 -36.5t-45.5 -27.5q-18 -10 -41 -23t-45.5 -28.5t-41.5 -32t-29 -32.5h303v-121h-482z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 558,
    d: "M381 236q62 -11 100.5 -59.5t38.5 -118.5q0 -47 -18.5 -85t-52 -64.5t-81.5 -41t-108 -14.5q-76 0 -134.5 24.5t-97.5 71.5l76 95q26 -33 62 -51t90 -18q61 0 93 24t32 74q0 52 -37 80t-112 28h-28v100h31q62 0 96 27.5t34 70.5q0 41 -28 61t-73 20q-46 0 -82.5 -21 t-59.5 -59l-84 94q15 23 40 41.5t56.5 32t68.5 21t76 7.5q51 0 93 -13t72.5 -36t47 -55.5t16.5 -72.5q0 -30 -9 -57t-26 -49t-40.5 -37t-51.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 571,
    d: "M312 -127v149h-292v119l335 430h91v-429h88v-120h-88v-149h-134zM154 142h173v226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 554,
    d: "M290 319q50 0 93 -16.5t74 -46.5t48.5 -72t17.5 -93q0 -54 -19.5 -98t-54.5 -75.5t-83 -49t-104 -17.5q-78 0 -139.5 33t-93.5 90l77 80q28 -39 70 -62t87 -23q54 0 88.5 32.5t34.5 86.5q0 52 -32.5 84t-82.5 32q-33 0 -61.5 -15t-45.5 -41h-117q0 3 4 22.5t10 50t13 68 t15 76.5q18 92 40 206h350v-122h-253l-29 -159q12 13 35.5 21t57.5 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 607,
    d: "M567 237q0 -52 -20 -97t-55 -78.5t-82.5 -52.5t-102.5 -19q-60 0 -108.5 22t-82.5 64t-52 102.5t-18 137.5q0 97 19 171.5t55 125t87 76.5t114 26q67 0 123.5 -29t95.5 -83l-77 -84q-24 38 -62 59t-82 21q-67 0 -107 -53t-42 -150q21 36 59.5 57t89.5 21q52 0 97.5 -18 t79 -50t52.5 -75.5t19 -93.5zM308 103q26 0 50 10.5t42 29t28.5 43t10.5 51.5t-10.5 50.5t-28.5 41.5t-41.5 28t-50.5 10t-51 -10t-42 -28t-28 -41.5t-10 -50.5t10.5 -51.5t28.5 -42.5t41.5 -29t50.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 561,
    d: "M351 461h-323v122h534l-352 -710h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 604,
    d: "M560 210q0 -50 -20.5 -90t-56 -69t-82.5 -44.5t-100 -15.5t-100 16.5t-82 46.5t-55 71t-20 90q0 30 10 55.5t26 46.5t35.5 37t39.5 26q-37 18 -63 54t-26 79q0 48 21.5 84.5t56 61.5t76 38t82.5 13q40 0 82.5 -12.5t76.5 -37.5t56 -61.5t22 -84.5q0 -21 -7 -41.5 t-19.5 -38t-29.5 -31.5t-36 -23q22 -11 42 -27.5t36 -38t25.5 -47.5t9.5 -57zM424 218q0 25 -10.5 45t-28 33.5t-39.5 20.5t-45 7q-24 0 -46 -7.5t-38.5 -21.5t-26.5 -33.5t-10 -43.5t10.5 -43.5t27.5 -33.5t39 -21.5t45 -7.5q24 0 46 8t39 22t27 33.5t10 42.5zM202 509 q0 -21 9 -36.5t23.5 -26t32 -16t35.5 -5.5q17 0 35 5.5t32.5 16.5t23.5 26.5t9 36.5q0 37 -29.5 59t-71.5 22q-41 0 -70 -22.5t-29 -59.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 589,
    d: "M32 324q0 52 20 97t54.5 78.5t82 52.5t102.5 19q60 0 108.5 -22t82.5 -64t52.5 -102.5t18.5 -137.5q0 -97 -19.5 -171.5t-55 -125t-86.5 -76.5t-114 -26q-67 0 -124 29t-96 83l77 84q24 -38 62 -59t83 -21q67 0 106.5 53t41.5 150q-20 -36 -59 -57t-90 -21q-53 0 -98 18 t-78 50t-52 75.5t-19 93.5zM291 458q-27 0 -50.5 -10.5t-41.5 -29t-28.5 -43t-10.5 -51.5t10.5 -50.5t28 -41.5t41.5 -28t51 -10t51 10t41.5 28t28 41.5t10.5 50.5t-10.5 51.5t-28.5 42.5t-41.5 29t-50.5 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 247,
    d: "M69 374v144h109v-144h-109zM69 0v144h109v-144h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 259,
    d: "M72 374v144h110v-144h-110zM86 -115l27 119h-42v140h117v-140l-41 -119h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 515,
    d: "M32 288l422 255v-142l-227 -142l227 -136v-150l-422 250v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 436,
    d: "M62 144v87h313v-87h-313zM62 321v87h313v-87h-313z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 515,
    d: "M483 223l-422 -250v150l227 136l-227 142v142l422 -255v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 486,
    d: "M122 233q0 49 16 88t66 68q15 9 37 20.5t43 27.5t35.5 37.5t14.5 49.5q0 21 -8 37t-21 27t-30.5 16.5t-35.5 5.5q-22 0 -40 -7.5t-32.5 -19t-26 -26t-19.5 -27.5l-87 60q13 31 34.5 55t49 40.5t59.5 25t66 8.5q38 0 75 -11t66.5 -35t48 -61.5t18.5 -89.5 q0 -32 -7.5 -56.5t-21.5 -44.5t-33 -36t-43 -31q-20 -12 -40 -23t-36.5 -24.5t-27 -31t-10.5 -42.5h-110zM124 0v138h111v-138h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 845,
    d: "M422 603q73 0 140.5 -25t119.5 -73t82.5 -119t30.5 -164q0 -14 -1.5 -37.5t-6.5 -49.5t-15 -53t-27 -49t-42.5 -35.5t-61.5 -13.5q-27 0 -44.5 7.5t-28 19.5t-15.5 26.5t-7 28.5q-31 -31 -75 -49.5t-95 -18.5q-75 0 -114 39t-39 101q0 41 16.5 69t43 45t60 24.5t67.5 7.5 q40 0 69 -7.5t44 -14.5q0 27 -5 50t-18 39t-35 25t-56 9q-41 0 -75 -12t-58 -32l-26 71q76 50 172 50q65 0 101.5 -20t54 -50.5t21.5 -67.5t4 -71v-96q0 -22 1.5 -42.5t6.5 -36t15 -25t28 -9.5q27 0 43.5 20t26 48.5t12.5 59.5t3 52q0 70 -23.5 129.5t-65.5 103t-101 68 t-131 24.5q-71 0 -129.5 -24t-101 -66.5t-66 -101t-23.5 -127.5q0 -67 22 -125.5t62.5 -102t97.5 -69t127 -25.5q48 0 83 10.5t73 27.5l16 -52q-42 -20 -86 -30t-88 -10q-75 0 -141 27t-115.5 76.5t-78 119t-28.5 153.5q0 89 31 158.5t83.5 117t121.5 72.5t144 25zM471 87 q27 13 39 32t12 42v38q-14 5 -44 13t-68 8q-47 0 -77 -18t-30 -61q0 -34 21.5 -54t59.5 -20q20 0 44 5t43 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 672,
    d: "M276 710h122l270 -710h-142l-66 177h-248l-65 -177h-142zM435 274l-98 279l-102 -279h200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 680,
    d: "M646 183q0 -45 -18 -79t-49.5 -57t-73 -35t-88.5 -12h-343v710h380q37 0 67 -16t51 -41.5t32.5 -58t11.5 -65.5q0 -52 -26 -97.5t-76 -67.5q61 -18 96.5 -64.5t35.5 -116.5zM507 209q0 19 -6.5 36.5t-17.5 30.5t-26 20.5t-33 7.5h-212v-187h205q19 0 35.5 7t28.5 19.5 t19 29.5t7 36zM212 592v-179h184q35 0 59.5 24t24.5 66q0 41 -22.5 65t-55.5 24h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 686,
    d: "M31 360q0 65 23.5 128.5t68.5 113.5t110 81t148 31q98 0 169.5 -43t106.5 -112l-106 -73q-14 30 -34 50.5t-43 32.5t-48 17.5t-49 5.5q-52 0 -90.5 -21t-64 -54.5t-38.5 -76t-13 -84.5q0 -47 15 -90.5t42.5 -76.5t66 -53t84.5 -20q24 0 50 6t49.5 19t43.5 33.5t32 49.5 l113 -65q-17 -40 -48.5 -70.5t-71 -51.5t-84.5 -32t-88 -11q-76 0 -139 32t-108.5 83.5t-71 117t-25.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 716,
    d: "M74 0v710h258q87 0 152.5 -28t109.5 -76t66 -112.5t22 -137.5q0 -81 -24.5 -146.5t-70.5 -112t-110.5 -72t-144.5 -25.5h-258zM543 356q0 51 -14 94t-41 74t-66.5 48t-89.5 17h-120v-468h120q51 0 90.5 18t66 49.5t40.5 74.5t14 93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 601,
    d: "M567 121v-121h-493v710h484v-121h-346v-171h299v-112h-299v-185h355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 574,
    d: "M74 0v710h477v-121h-339v-183h282v-112h-282v-294h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 725,
    d: "M567 80q-85 -85 -198 -85q-70 0 -131.5 28t-107 77t-72 115.5t-26.5 143.5q0 73 26.5 137.5t73 113t109.5 77t137 28.5q100 0 171.5 -42t107.5 -113l-103 -76q-27 53 -75.5 81t-105.5 28q-45 0 -82.5 -19t-64 -52t-41 -76t-14.5 -91q0 -50 16 -93.5t44 -75.5t66.5 -50.5 t83.5 -18.5q103 0 186 97v50h-143v101h257v-365h-114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 745,
    d: "M671 710v-710h-137v303h-322v-303h-138v710h138v-287h322v287h137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 286,
    d: "M74 0v710h138v-710h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 491,
    d: "M38 145q14 -10 47 -22t76 -12q42 0 67 14.5t38 44.5t17 74.5t4 104.5v361h138v-361q0 -81 -8.5 -147.5t-36 -113.5t-79.5 -73t-140 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 669,
    d: "M74 0v709h138v-337l298 338h152l-272 -315l289 -395h-155l-221 307l-91 -95v-212h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 584,
    d: "M74 0v710h138v-589h362v-121h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 865,
    d: "M653 0v470l-183 -350h-75l-183 350v-470h-138v710h148l210 -404l212 404h147v-710h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 763,
    d: "M212 455v-455h-138v710h107l370 -466v465h138v-709h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 756,
    d: "M377 -5q-78 0 -141.5 30.5t-109 81t-70.5 115.5t-25 133q0 71 26.5 136t73 115t110.5 79.5t139 29.5q77 0 140.5 -31.5t108.5 -82.5t70 -116t25 -132q0 -71 -26 -135.5t-72 -114t-110 -79t-139 -29.5zM171 355q0 -46 14 -89t40.5 -76t65 -53t87.5 -20q50 0 88.5 20.5 t65 54.5t40 76.5t13.5 86.5q0 46 -14.5 89t-41 76t-65 52.5t-86.5 19.5q-50 0 -89 -20.5t-65 -54t-39.5 -76t-13.5 -86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 623,
    d: "M74 0v710h301q49 0 90.5 -20.5t71.5 -54t47 -76t17 -85.5q0 -45 -16 -87.5t-45 -75.5t-70 -53t-90 -20h-168v-238h-138zM212 359h160q38 0 63.5 31t25.5 84q0 27 -8 48.5t-21 36.5t-30.5 22.5t-35.5 7.5h-154v-230z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 755,
    d: "M557 46q-39 -24 -84 -37.5t-96 -13.5q-78 0 -141.5 31t-109 81t-70.5 115t-25 133q0 71 26.5 136t73 115t110.5 79.5t139 29.5q77 0 140.5 -31.5t108.5 -82.5t70 -116t25 -132q0 -69 -24.5 -132t-68.5 -112l97 -109h-130zM378 117q27 0 50.5 6.5t43.5 17.5l-108 122h130 l49 -55q20 32 31 70t11 77q0 46 -14.5 89t-41 76t-65 53t-86.5 20q-50 0 -89 -20.5t-65 -54.5t-39.5 -76.5t-13.5 -86.5q0 -46 14 -89t40.5 -76t65 -53t87.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 665,
    d: "M74 0v710h314q49 0 90.5 -20.5t71.5 -54t47 -76t17 -85.5q0 -69 -34.5 -125.5t-93.5 -81.5l162 -267h-155l-145 238h-136v-238h-138zM212 359h173q19 0 35.5 9t28.5 24.5t19 36.5t7 45q0 25 -8 46t-21.5 36.5t-31 24t-35.5 8.5h-167v-230z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 613,
    d: "M497 524q-7 7 -25.5 19t-45 23.5t-57.5 19.5t-63 8q-57 0 -85 -21t-28 -59q0 -22 10.5 -36.5t30.5 -25.5t50.5 -20t70.5 -19q52 -14 94.5 -30t72 -40t45.5 -57.5t16 -82.5q0 -57 -21.5 -97.5t-58 -65.5t-84 -36.5t-99.5 -11.5q-80 0 -158 24t-140 68l61 119 q9 -9 32.5 -23.5t55.5 -29t71 -24.5t80 -10q114 0 114 73q0 23 -13 39t-37 28t-58 22t-76 22q-51 14 -88.5 30.5t-62.5 39t-37.5 52t-12.5 70.5q0 54 20 96t55.5 70t82.5 42.5t101 14.5q75 0 138 -23.5t110 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 619,
    d: "M605 589h-227v-589h-137v589h-227v121h591v-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 750,
    d: "M374 117q49 0 82.5 20t54 52t29 73.5t8.5 85.5v362h137v-362q0 -73 -17.5 -137t-55 -112t-96.5 -76t-141 -28q-85 0 -144.5 29.5t-96.5 78t-53.5 112.5t-16.5 133v362h138v-362q0 -45 8.5 -86.5t29 -73.5t53.5 -51.5t81 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 676,
    d: "M147 710l192 -537l190 537h145l-277 -710h-116l-279 710h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1053,
    d: "M319 708h127l80 -235l80 235h128l-121 -323l90 -227l201 552h150l-289 -710h-116l-123 298l-123 -298h-116l-287 710h148l202 -552l88 227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 646,
    d: "M147 710l177 -264l176 264h149l-253 -360l245 -350h-149l-168 254l-169 -254h-150l245 350l-253 360h150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 660,
    d: "M154 710l175 -342l178 342h149l-258 -462v-248h-137v250l-257 460h150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 627,
    d: "M30 104l401 485h-390v121h549v-104l-388 -485h391v-121h-563v104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 316,
    d: "M82 -40v780h187v-107h-63v-566h63v-107h-187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 637,
    d: "M176 710l435 -710h-148l-436 710h149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 316,
    d: "M46 -40v107h64v566h-64v107h188v-780h-188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 585,
    d: "M39 303l198 407h112l197 -407h-110l-143 294l-146 -294h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 475,
    d: "M54 -121v121h367v-121h-367z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 255,
    d: "M47 730h124l55 -119l-86 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 574,
    d: "M204 -10q-38 0 -71 12.5t-57 35t-37.5 52.5t-13.5 66q0 37 16.5 68.5t46 53.5t70.5 34.5t90 12.5q35 0 68.5 -6t59.5 -17v30q0 52 -29.5 80t-87.5 28q-42 0 -82 -15t-82 -44l-41 85q101 67 218 67q113 0 175.5 -55.5t62.5 -160.5v-163q0 -21 7.5 -30t24.5 -10v-114 q-34 -7 -59 -7q-38 0 -58.5 17t-25.5 45l-3 29q-35 -46 -85 -70t-107 -24zM242 88q34 0 64.5 12t47.5 32q22 17 22 38v60q-24 9 -52 14.5t-54 5.5q-52 0 -85 -23.5t-33 -59.5q0 -34 26 -56.5t64 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 634,
    d: "M359 -10q-60 0 -107 27t-74 74v-91h-117v730h134v-298q28 48 73.5 74.5t106.5 26.5q51 0 93 -22t72.5 -59t47 -87t16.5 -105q0 -57 -18.5 -106t-51.5 -85.5t-78 -57.5t-97 -21zM322 104q32 0 59 12.5t46 33.5t29.5 49t10.5 60t-10 61t-28.5 51t-43.5 35t-55 13 q-45 0 -80.5 -29.5t-54.5 -72.5v-125q7 -20 20.5 -36t30.5 -27.5t37 -18t39 -6.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 564,
    d: "M28 262q0 55 19 104t55 86t87 59t115 22q86 0 146.5 -37t90.5 -97l-131 -40q-17 29 -45 44.5t-62 15.5q-29 0 -54 -11.5t-43.5 -32t-29 -49.5t-10.5 -64t11 -64t29.5 -50t43.5 -32.5t53 -11.5q36 0 66.5 18t42.5 44l131 -40q-27 -60 -89 -98t-149 -38q-64 0 -115 22 t-87 59.5t-55.5 87t-19.5 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 645,
    d: "M278 -10q-54 0 -100 21t-79 58t-51.5 86.5t-18.5 106.5t17.5 106t48.5 86t74 58t94 21q58 0 104.5 -28t72.5 -73v298h134v-576q0 -21 7 -30t24 -10v-114q-35 -7 -57 -7q-36 0 -59 18t-26 47l-3 33q-29 -50 -78.5 -75.5t-103.5 -25.5zM313 104q19 0 39 6.5t37 18.5 t30.5 28t20.5 35v125q-8 22 -22.5 40.5t-33 32t-39 21.5t-40.5 8q-30 0 -55.5 -13t-43.5 -35.5t-28 -51.5t-10 -60q0 -33 11 -61t30 -49t45.5 -33t58.5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    d: "M304 -10q-63 0 -114 21.5t-87 58.5t-55.5 86t-19.5 103q0 56 19 105.5t55 87t87.5 59.5t115.5 22t114.5 -22t86 -59t54 -86t18.5 -102q0 -13 -0.5 -25t-2.5 -20h-405q3 -31 15 -55t31 -41t43 -26t50 -9q40 0 75.5 19.5t48.5 51.5l115 -32q-29 -60 -92.5 -98.5 t-151.5 -38.5zM440 306q-5 59 -43.5 94.5t-93.5 35.5q-27 0 -50.5 -9.5t-41.5 -26.5t-29.5 -41t-13.5 -53h272z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 370,
    d: "M93 0v394h-69v102h69v32q0 98 47 155t128 57q64 0 129 -31l-27 -101q-15 8 -35.5 13.5t-37.5 5.5q-70 0 -70 -94v-37h128v-102h-128v-394h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 634,
    d: "M266 -3q-53 0 -96 21t-74.5 57.5t-48.5 84.5t-17 102q0 57 18 106t50 86t77 58t99 21q61 0 107 -27.5t76 -73.5v92h117v-499q0 -58 -22 -104t-60.5 -78t-92 -49t-116.5 -17q-86 0 -144.5 28.5t-100.5 80.5l73 71q30 -37 75.5 -58t96.5 -21q31 0 59.5 8.5t50.5 26.5 t34.5 46t12.5 66v66q-26 -45 -73 -69.5t-101 -24.5zM311 104q22 0 42 7t37 19t30 28t20 34v125q-18 46 -56.5 74t-80.5 28q-31 0 -56 -13.5t-43 -36t-27.5 -51.5t-9.5 -60q0 -32 11 -60t30.5 -49t45.5 -33t57 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 604,
    d: "M548 0h-134v294q0 62 -23 91.5t-65 29.5q-18 0 -38 -8t-38 -22.5t-33 -34.5t-22 -44v-306h-134v730h134v-303q29 51 78.5 78.5t109.5 27.5q51 0 83 -17.5t50 -46.5t25 -66t7 -76v-327z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 255,
    d: "M61 0v524h134v-524h-134zM61 597v133h134v-133h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 261,
    d: "M18 -196q-38 0 -72 11.5t-61 35.5l58 91q11 -11 27 -16.5t32 -5.5q26 0 45 18.5t19 47.5v538h134v-528q0 -42 -14 -77.5t-38.5 -61t-58 -39.5t-71.5 -14zM66 597v133h134v-133h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 558,
    d: "M419 0l-152 227l-72 -71v-156h-134v730h134v-443l210 236h143l-195 -222l209 -301h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 317,
    d: "M60 730h134v-562q0 -29 14 -45t40 -16q12 0 26.5 4t27.5 10l18 -102q-27 -13 -63 -20t-65 -7q-63 0 -97.5 33.5t-34.5 95.5v609z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 931,
    d: "M875 0h-134v294q0 63 -21.5 92t-59.5 29q-40 0 -75 -30.5t-50 -79.5v-305h-134v294q0 63 -21.5 92t-59.5 29q-39 0 -74.5 -30t-50.5 -79v-306h-134v524h121v-97q29 51 79.5 78.5t115.5 27.5q66 0 102 -32t46 -79q32 54 81 82.5t112 28.5q48 0 79 -18t48 -47t23.5 -66 t6.5 -75v-327z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 604,
    d: "M548 0h-134v294q0 63 -22 92t-61 29q-20 0 -41 -8t-39.5 -22.5t-33.5 -34.5t-22 -44v-306h-134v524h121v-97q29 50 84 78t124 28q49 0 80 -18t48 -47t23.5 -66t6.5 -75v-327z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 606,
    d: "M303 -10q-64 0 -115 22t-86.5 59.5t-54.5 86.5t-19 103q0 55 19 104t54.5 86.5t86.5 59.5t115 22t114.5 -22t86 -59.5t54.5 -86.5t19 -104q0 -54 -19 -103t-54 -86.5t-86 -59.5t-115 -22zM166 261q0 -35 10.5 -63.5t29 -49.5t43.5 -32.5t54 -11.5t54 11.5t43.5 32.5 t29 50t10.5 64q0 34 -10.5 63t-29 50t-43.5 32.5t-54 11.5t-54 -12t-43.5 -33t-29 -50t-10.5 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 634,
    d: "M375 -10q-62 0 -108 27.5t-72 74.5v-305h-134v737h117v-90q29 46 75 72.5t106 26.5q53 0 98 -21.5t77.5 -58t51 -86t18.5 -104.5q0 -57 -17 -107t-47.5 -87t-72.5 -58t-92 -21zM330 104q30 0 55.5 13t43.5 35t28 51t10 60q0 33 -11 61.5t-30.5 49.5t-46 33t-57.5 12 q-19 0 -39 -6.5t-37 -18.5t-30.5 -28t-20.5 -35v-123q18 -45 55 -74.5t80 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 634,
    d: "M259 -10q-50 0 -92 21.5t-72.5 58.5t-47.5 86.5t-17 106.5t18.5 106t51.5 85.5t78 57.5t97 21q60 0 106 -27.5t75 -72.5v91h117v-576q0 -22 8 -30.5t28 -9.5v-114q-17 -3 -37 -4.5t-36 -1.5q-20 0 -37.5 7t-30.5 19t-21 28.5t-8 36.5v213q-29 -51 -75 -76.5t-105 -25.5z M309 104q43 0 75 24t55 62v124q-6 22 -19.5 41t-31.5 33.5t-39 22.5t-42 8q-31 0 -56.5 -13t-44 -35.5t-29 -51.5t-10.5 -60q0 -33 10.5 -61t29 -49t44.5 -33t58 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 387,
    d: "M373 408q-61 -1 -109 -23.5t-69 -67.5v-317h-134v524h123v-112q14 27 33 48.5t41 37.5t44.5 24.5t43.5 8.5h16.5t10.5 -1v-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 497,
    d: "M259 -10q-66 0 -129 21t-108 60l50 84q48 -34 93.5 -51.5t90.5 -17.5q40 0 63 15t23 43t-27 41t-88 30q-51 14 -87 27t-58 29.5t-32 38t-10 51.5q0 40 15.5 72t43.5 54.5t65.5 34.5t81.5 12q59 0 110.5 -17t94.5 -55l-54 -81q-40 30 -77.5 44t-74.5 14q-34 0 -57 -14 t-23 -45q0 -14 5.5 -23t17.5 -16t31.5 -13.5t48.5 -13.5q54 -14 92.5 -28t63 -32t36 -41.5t11.5 -56.5q0 -77 -57 -121.5t-155 -44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 384,
    d: "M375 27q-27 -12 -66 -24t-82 -12q-28 0 -52.5 7t-43 22.5t-29.5 40t-11 59.5v301h-69v103h69v170h134v-170h110v-103h-110v-256q0 -28 14.5 -39.5t35.5 -11.5t41 7t32 12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 618,
    d: "M221 -10q-81 0 -123 52t-42 154v328h134v-299q0 -121 87 -121q39 0 75.5 23.5t59.5 71.5v325h134v-370q0 -21 7.5 -30t24.5 -10v-114q-20 -4 -33.5 -5t-24.5 -1q-36 0 -58.5 16.5t-26.5 45.5l-3 42q-35 -54 -90 -81t-121 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 549,
    d: "M202 0l-193 524h138l133 -415l134 415h126l-193 -524h-145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 839,
    d: "M711 524h127l-219 -524h-110l-90 230l-89 -230h-110l-218 524h126l156 -398l64 170l-92 227h108l55 -161l56 161h108l-91 -227l63 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 531,
    d: "M144 524l113 -164l8 -18l10 18l112 164h138l-187 -263l190 -261h-138l-116 163l-9 17l-8 -17l-115 -163h-138l189 261l-186 263h137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 550,
    d: "M72 -102q17 -5 33 -7.5t27 -2.5q13 0 24 5t20 17.5t18 34.5t19 55l-207 524h138l142 -408l126 408h126l-220 -628q-19 -55 -65 -90t-114 -35q-16 0 -32.5 2.5t-34.5 8.5v116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 493,
    d: "M26 82l292 348h-280v94h421v-82l-290 -348h295v-94h-438v82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 317,
    d: "M212 633v-204q0 -20 -9 -37.5t-25 -31.5q15 -14 24.5 -31.5t9.5 -37.5v-215h55v-107h-152q-7 0 -15 6t-8 24v248q0 26 -15 44.5t-35 22.5v94q10 0 19.5 6t16 16t10.5 21t4 22v237q0 19 8.5 24.5t14.5 5.5h152v-107h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 272,
    d: "M79 -130v905h114v-905h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 317,
    d: "M50 633v107h153q5 0 14 -5.5t9 -24.5v-237q0 -11 4 -22t10.5 -21t15.5 -16t20 -6v-94q-20 -4 -35 -22.5t-15 -44.5v-248q0 -18 -8.5 -24t-14.5 -6h-153v107h55v215q0 20 9.5 37.5t25.5 31.5q-16 14 -25.5 31.5t-9.5 37.5v204h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 567,
    d: "M56 228q0 9 7 30.5t23 44t43 40t66 17.5q27 0 49.5 -8.5t43 -18.5t40.5 -18.5t43 -8.5q21 0 34.5 7.5t21 16.5t10.5 17.5t3 10.5h74q0 -5 -7 -26t-23.5 -44t-44.5 -41.5t-69 -18.5q-27 0 -50 8t-44 18t-41 18t-41 8t-33.5 -8t-19 -17.5t-9 -17.5t-2.5 -9h-74v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 240
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 305,
    d: "M220 445v-450h-134v450h134zM220 712v-151h-134v151h134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 592,
    d: "M276 -120v111q-52 4 -95.5 28.5t-75 61.5t-49 83t-17.5 94q0 51 15.5 97t46 82.5t74.5 61.5t101 33v113h60v-113q70 -2 127 -36t89 -97l-130 -40q-14 26 -37 40t-49 16v-308q27 5 53.5 20.5t34.5 38.5l131 -40q-15 -34 -41 -59.5t-57 -42.5t-63 -25.5t-58 -8.5v-110h-60z M177 258q0 -25 7 -48t20 -42t31 -33.5t41 -21.5v296q-23 -5 -41.5 -19t-31.5 -34.5t-19.5 -45.5t-6.5 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 545,
    d: "M57 381h72q-18 38 -35.5 76t-17.5 80q0 37 16 69.5t44 56.5t65.5 38t80.5 14q61 0 115.5 -28t91.5 -77l-70 -82q-25 35 -63.5 56.5t-75.5 21.5t-60.5 -23.5t-23.5 -58.5q0 -17 5.5 -34t13.5 -34.5t17.5 -36t17.5 -38.5h184v-101h-162q0 -47 -18.5 -87.5t-65.5 -88.5 q22 7 40.5 9.5t35.5 2.5q37 0 69.5 -8.5t66.5 -8.5q18 0 35 4t40 12l33 -100q-25 -14 -55.5 -22t-59.5 -8q-23 0 -45.5 4.5t-45.5 10t-46.5 10t-47.5 4.5q-26 0 -61 -6t-67 -16l-29 95q54 45 80.5 91t26.5 102h-101v101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 552,
    d: "M170 495q22 14 48.5 22t58.5 8q30 0 56.5 -7.5t48.5 -21.5l69 71l55 -55l-68 -67q31 -48 31 -108t-32 -107l69 -68l-50 -50l-72 68q-22 -14 -48.5 -21.5t-58.5 -7.5t-59.5 8t-49.5 22l-73 -69l-49 50l69 69q-31 48 -31 106q0 61 30 106l-68 69l54 55zM183 337 q0 -45 27 -73.5t67 -28.5t66.5 29t26.5 74t-26.5 73.5t-66.5 28.5t-67 -29t-27 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 712,
    d: "M505 402h73v-87h-120l-36 -67v-30h157v-87h-157v-131h-137v131h-155v87h155v32l-34 65h-120v87h74l-176 308h149l176 -342l177 342h150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 275,
    d: "M195 264v-394h-114v394h114zM195 775v-394h-114v394h114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 532,
    d: "M456 215q16 -14 25.5 -39t9.5 -63q0 -54 -22 -92.5t-55 -62.5t-72 -35t-73 -11q-40 0 -74 11t-61.5 27t-48 34t-32.5 32l86 82q30 -32 60.5 -45.5t63.5 -13.5q17 0 33 4.5t28.5 13.5t20 21.5t7.5 29.5q0 18 -7.5 28.5t-19 16t-25.5 7.5t-28 3q-100 7 -153.5 54t-53.5 124 q0 29 7 46.5t12 27.5q-14 14 -27.5 42.5t-13.5 67.5t16.5 73.5t45.5 60.5t67 41t82 15q43 0 77 -12.5t59.5 -31t44 -40t31.5 -39.5l-103 -49q-14 26 -40.5 39.5t-60.5 13.5q-36 0 -60 -18.5t-24 -50.5q0 -37 24.5 -49t59.5 -13q37 -1 75.5 -10t69.5 -28.5t50.5 -51.5 t19.5 -78q0 -29 -6.5 -50.5t-14.5 -31.5zM195 323q0 -29 15.5 -42.5t37 -18.5t45 -6.5t39.5 -7.5q8 8 13 20.5t5 24.5q0 18 -8 30.5t-20.5 20t-27 10.5t-27.5 3q-17 0 -32.5 3t-23.5 6q-7 -7 -11.5 -18.5t-4.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 457,
    d: "M77 604v119h111v-119h-111zM269 604v119h111v-119h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 841,
    d: "M417 -7q-81 0 -149.5 27.5t-118.5 76t-78 114.5t-28 144q0 77 28 143t78 114t118.5 75.5t149.5 27.5q82 0 152 -27.5t121 -75.5t79.5 -114t28.5 -143q0 -78 -28.5 -144t-79.5 -114.5t-121 -76t-152 -27.5zM417 43q69 0 128.5 22.5t104 64t69.5 98.5t25 126 q0 66 -24.5 122.5t-68.5 98.5t-104 66t-130 24q-69 0 -127.5 -24t-101.5 -66t-67.5 -98.5t-24.5 -122.5t24.5 -122.5t67 -98.5t101.5 -66t128 -24zM426 116q-56 0 -102.5 18.5t-79.5 50.5t-51.5 75.5t-18.5 94.5q0 45 15.5 88t47 76.5t78.5 53.5t109 20q80 0 137 -34.5 t84 -93.5l-130 -40q-15 31 -41 42.5t-51 11.5q-26 0 -47 -10t-35.5 -27t-22 -39.5t-7.5 -47.5q0 -30 10 -53.5t26 -39t36 -24t41 -8.5q29 0 54.5 15t39.5 41l131 -39q-12 -26 -32 -49.5t-48.5 -41.5t-64.5 -29t-78 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 444,
    d: "M160 339q-26 0 -47.5 8.5t-38 24t-25.5 36.5t-9 45q0 26 11 48t31 37.5t47.5 24.5t60.5 9q48 0 83 -16v19q0 33 -18.5 51.5t-56.5 18.5q-29 0 -55 -10t-55 -30l-30 61q69 47 149 47q78 0 121 -38t43 -112v-104q0 -15 5.5 -21.5t19.5 -7.5v-85q-13 -2 -24 -3t-20 -1 q-54 0 -62 44l-2 19q-24 -32 -57 -48.5t-71 -16.5zM189 411q20 0 39.5 7.5t30.5 19.5q14 12 14 26v39q-15 6 -32.5 9t-33.5 3q-33 0 -54 -14.5t-21 -38.5q0 -22 16.5 -36.5t40.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 649,
    d: "M35 288l264 189v-109l-157 -109l157 -103v-110l-264 177v65zM327 288l263 189v-109l-157 -109l157 -103v-110l-263 177v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 612,
    d: "M547 400v-294h-114v174h-374v120h488z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 603,
    d: "M58 214v121h488v-121h-488z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 841,
    d: "M419 -7q-81 0 -150 27.5t-119.5 76t-78.5 114.5t-28 144q0 77 28 143t78.5 114t119.5 75.5t150 27.5t150.5 -27.5t120.5 -75.5t79.5 -114t28.5 -143q0 -78 -28.5 -144t-79.5 -114.5t-120.5 -76t-150.5 -27.5zM419 42q68 0 127 23t102.5 64t68.5 98.5t25 125.5 q0 66 -24.5 123t-67.5 99t-102 66t-129 24t-128.5 -24t-101 -66t-66.5 -98.5t-24 -121.5q0 -66 24 -123t66.5 -99.5t101 -66.5t128.5 -24zM257 576h195q30 0 56 -13t44.5 -34t29 -47t10.5 -53q0 -41 -22 -77t-58 -50l103 -166h-107l-92 148h-64v-148h-95v440zM444 366 q25 0 39.5 16.5t14.5 46.5q0 32 -16.5 47.5t-39.5 15.5h-90v-126h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 419,
    d: "M60 633v83h300v-83h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 285,
    d: "M40 625q0 42 28.5 70.5t73.5 28.5t74 -28.5t29 -70.5q0 -48 -29 -77t-74 -29t-73.5 29.5t-28.5 76.5zM115 648q-10 -12 -10 -27t10 -25q14 -12 27 -12q17 0 27 12q10 10 10 25t-10 27q-5 5 -12 8t-15 3q-14 0 -27 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 472,
    d: "M59 28v108h354v-108h-354zM413 430v-107h-117v-127h-120v127h-117v107h117v127h120v-127h117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 416,
    d: "M30 389q0 41 7 71.5t22.5 53.5t40.5 40.5t61 32.5q23 9 46.5 18t42.5 20t31 25t12 34q0 26 -22 40t-64 14q-44 0 -75 -16t-48 -33l-51 58q8 10 24 22t39.5 22.5t54 17.5t68.5 7q81 0 122.5 -35.5t41.5 -97.5q0 -33 -13.5 -56t-33 -38.5t-43 -25.5t-42.5 -16 q-51 -16 -81 -36.5t-30 -43.5h231v-78h-341z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 407,
    d: "M192 383q-63 0 -106.5 20.5t-57.5 58.5l43 59q4 -9 13.5 -19t24.5 -18.5t35 -14.5t46 -6q42 0 72 13t30 39q0 29 -39.5 42t-108.5 13h-24v73h23q61 0 98 12.5t37 39.5q0 12 -8 21t-20 14.5t-27 8.5t-30 3q-40 0 -67.5 -13.5t-45.5 -36.5l-51 64q23 29 68 44.5t95 15.5 q37 0 68 -9t54 -24.5t36 -36.5t13 -46q0 -35 -25 -58t-70 -31q49 -7 77 -37.5t28 -71.5q0 -31 -15.5 -53.5t-40.5 -37t-58 -21.5t-67 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 255,
    d: "M133 585l-86 26l54 119h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 664,
    d: "M77 524h134v-299q0 -121 90 -121q37 0 73.5 23.5t59.5 71.5v325h134v-370q0 -21 8 -30t28 -10v-114q-21 -4 -36 -5t-27 -1q-37 0 -60 18t-25 48l-2 38q-9 -18 -25.5 -37t-38 -35t-47 -26t-51.5 -10q-20 0 -35 6t-26 14.5t-18.5 19t-10.5 19.5l9 -261h-134v736z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 657,
    d: "M35 456q0 121 73.5 187.5t208.5 66.5h294v-100h-70v-690h-113v288h-51v-288h-114v288q-52 0 -94 18t-72 50.5t-46 78t-16 101.5zM147 459q0 -69 34 -107.5t82 -43.5v302q-56 -3 -86 -44t-30 -107zM428 610h-51v-302h51v302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 225,
    d: "M58 242v151h110v-151h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 326,
    d: "M48 -127q12 -7 37 -13t52 -6q26 0 41 7.5t15 25.5t-14.5 25.5t-37.5 7.5q-21 0 -44.5 -4.5t-35.5 -7.5l61 120l52 -16l-35 -54q7 2 15.5 3t16.5 1q35 0 60 -16.5t25 -53.5q0 -38 -31.5 -63t-96.5 -25q-33 0 -60 6t-47 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 298,
    d: "M277 469v-79h-229v79h78v261q-5 -7 -16 -15.5t-24.5 -16.5t-27.5 -13.5t-26 -5.5v79q16 0 32.5 8.5t30 19t22.5 20t9 10.5h81v-347h70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 443,
    d: "M222 339q-44 0 -78.5 15.5t-58.5 41t-36.5 59.5t-12.5 71q0 38 12.5 72t36.5 59.5t58.5 40.5t78.5 15q43 0 77.5 -15t58.5 -40.5t37 -59.5t13 -72q0 -37 -12.5 -71t-36.5 -59.5t-58.5 -41t-78.5 -15.5zM135 525q0 -45 25 -73.5t62 -28.5t61.5 29t24.5 74t-24.5 73.5 t-61.5 28.5t-62 -28.5t-25 -74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 649,
    d: "M613 223l-264 -177v110l158 103l-158 109v109l264 -189v-65zM322 223l-264 -177v110l158 103l-158 109v109l264 -189v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 931,
    d: "M756 0v93h-221v77l246 252h54v-251h61v-78h-61v-93h-79zM612 171h147v153zM177 47l282 329l260 342l61 -54l-273 -323l-269 -348zM287 384v-78h-229v78h78v261q-5 -7 -16 -15.5t-24.5 -16.5t-27.5 -13.5t-26 -5.5v80q16 0 32.5 8.5t30 19t22.5 19.5t9 10h81v-347h70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 956,
    d: "M569 0q0 41 7 71.5t22 53.5t40 40.5t61 32.5q22 9 45 18t41.5 20t30 24.5t11.5 33.5q0 26 -21.5 40.5t-62.5 14.5q-43 0 -73.5 -16.5t-47.5 -33.5l-50 58q8 10 23.5 22t39 22.5t53.5 17.5t67 7q79 0 119.5 -35t40.5 -98q0 -32 -13 -54.5t-32 -38t-42 -25t-42 -15.5 q-51 -16 -76 -37.5t-29 -44.5h235v-78h-347zM137 47l282 329l260 342l61 -54l-273 -323l-269 -348zM286 384v-78h-229v78h78v261q-5 -7 -16 -15.5t-24.5 -16.5t-27.5 -13.5t-26 -5.5v80q16 0 32.5 8.5t30 19t22.5 19.5t9 10h81v-347h70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 939,
    d: "M203 298q-63 0 -106.5 20.5t-57.5 58.5l43 59q11 -20 41 -38.5t78 -18.5q42 0 72 12.5t30 38.5q0 29 -39.5 42.5t-108.5 13.5h-24v73h23q61 0 98 12t37 40q0 12 -8 20.5t-20 14t-27 8.5t-30 3q-40 0 -67.5 -13.5t-45.5 -35.5l-51 64q23 29 68 44t95 15q37 0 68 -9 t54 -24.5t36 -36.5t13 -46q0 -35 -25 -58t-70 -31q49 -7 77 -37t28 -71q0 -31 -15.5 -53.5t-40.5 -37.5t-58 -22t-67 -7zM763 0v93h-221v77l246 252h54v-251h61v-78h-61v-93h-79zM619 171h147v153zM207 47l282 329l260 342l61 -54l-273 -323l-269 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 479,
    d: "M360 273q0 -49 -16 -88t-66 -68q-15 -9 -37 -20.5t-43 -27.5t-35.5 -37.5t-14.5 -49.5q0 -21 8 -37t21 -27t30.5 -16.5t35.5 -5.5q22 0 40 7.5t32.5 19t26 25.5t19.5 28l87 -60q-13 -31 -34.5 -55t-49 -40.5t-59.5 -25t-66 -8.5q-38 0 -75 11t-66.5 35t-48 61.5 t-18.5 89.5q0 32 7.5 56.5t21.5 44.5t33 36t43 31q20 12 40 23t36.5 24.5t27 30.5t10.5 43h110zM358 506v-138h-111v138h111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 672,
    d: "M276 710h122l270 -710h-142l-66 177h-248l-65 -177h-142zM435 274l-98 279l-102 -279h200zM209 916h124l55 -119l-86 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 672,
    d: "M276 710h122l270 -710h-142l-66 177h-248l-65 -177h-142zM435 274l-98 279l-102 -279h200zM372 770l-86 26l54 119h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 672,
    d: "M276 710h122l270 -710h-142l-66 177h-248l-65 -177h-142zM435 274l-98 279l-102 -279h200zM182 814l106 101h97l106 -101l-69 -32l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 672,
    d: "M276 710h122l270 -710h-142l-66 177h-248l-65 -177h-142zM435 274l-98 279l-102 -279h200zM400 787q-23 0 -40 7t-31.5 15.5t-29 15.5t-30.5 7q-17 0 -26.5 -7t-14.5 -16t-6 -16.5t-1 -8.5h-74q0 9 6 30.5t19.5 43t36 38t55.5 16.5q23 0 39.5 -7.5t31 -16t29 -16 t32.5 -7.5t28.5 7t16 16t7 17t1.5 10h74q0 -7 -6 -28t-20.5 -43t-38 -39.5t-58.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 672,
    d: "M276 710h122l270 -710h-142l-66 177h-248l-65 -177h-142zM435 274l-98 279l-102 -279h200zM185 790v119h111v-119h-111zM377 790v119h111v-119h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 672,
    d: "M276 710h122l270 -710h-142l-66 177h-248l-65 -177h-142zM435 274l-98 279l-102 -279h200zM239 838q0 37 26.5 57t70.5 20t70.5 -20t26.5 -57t-26.5 -57t-70.5 -20t-70.5 20t-26.5 57zM336 874q-17 0 -28.5 -9.5t-11.5 -26.5q0 -15 11.5 -25.5t28.5 -10.5q16 0 28.5 10 t12.5 26q0 17 -12 26.5t-29 9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 966,
    d: "M418 710h505v-121h-333v-167h279v-121h-279v-180h342v-121h-478v177h-228l-105 -177h-146zM444 297v258l-159 -258h159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 684,
    d: "M285 -127q12 -7 37 -13t52 -6q26 0 41 7.5t15 25.5t-14.5 25.5t-37.5 7.5q-21 0 -44.5 -4.5t-35.5 -7.5l44 88q-69 6 -127 40t-99 84.5t-64 113t-23 126.5q0 65 23.5 128.5t68.5 113.5t110 81t148 31q98 0 169.5 -43t106.5 -112l-106 -73q-14 30 -34 50.5t-43 32.5 t-48 17.5t-49 5.5q-52 0 -90.5 -21t-64 -54.5t-38.5 -76t-13 -84.5q0 -47 15 -90.5t42.5 -76.5t66 -53t84.5 -20q24 0 50 6t49.5 19t43.5 33.5t32 49.5l113 -65q-15 -37 -43.5 -66t-64 -50t-76.5 -33t-81 -15l-24 -37q7 2 15.5 3t16.5 1q35 0 60 -16.5t25 -53.5 q0 -38 -31.5 -63t-96.5 -25q-33 0 -60 6t-47 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 601,
    d: "M567 121v-121h-493v710h484v-121h-346v-171h299v-112h-299v-185h355zM198 916h124l55 -119l-86 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 601,
    d: "M361 770l-86 26l54 119h125zM567 121v-121h-493v710h484v-121h-346v-171h299v-112h-299v-185h355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 601,
    d: "M171 814l106 101h97l106 -101l-69 -32l-85 63l-85 -63zM567 121v-121h-493v710h484v-121h-346v-171h299v-112h-299v-185h355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 601,
    d: "M174 790v119h111v-119h-111zM366 790v119h111v-119h-111zM567 121v-121h-493v710h484v-121h-346v-171h299v-112h-299v-185h355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 286,
    d: "M74 0v710h138v-710h-138zM15 916h124l55 -119l-86 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 286,
    d: "M74 0v710h138v-710h-138zM177 770l-86 26l54 119h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 286,
    d: "M74 0v710h138v-710h-138zM-12 814l106 101h97l106 -101l-69 -32l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 286,
    d: "M74 0v710h138v-710h-138zM-9 790v119h111v-119h-111zM183 790v119h111v-119h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 721,
    d: "M79 0v307h-48v100h48v303h258q87 0 152.5 -28t109.5 -76t66 -112.5t22 -137.5q0 -81 -24.5 -146.5t-70.5 -112t-110.5 -72t-144.5 -25.5h-258zM548 356q0 51 -14 94t-41 74t-66.5 48t-89.5 17h-120v-182h139v-100h-139v-186h120q51 0 90.5 18t66 49.5t40.5 74.5t14 93z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 763,
    d: "M212 455v-455h-138v710h107l370 -466v465h138v-709h-112zM444 787q-23 0 -40 7t-31.5 15.5t-29 15.5t-30.5 7q-17 0 -26.5 -7t-14.5 -16t-6 -16.5t-1 -8.5h-74q0 9 6 30.5t19.5 43t36 38t55.5 16.5q23 0 39.5 -7.5t31 -16t29 -16t32.5 -7.5t28.5 7t16 16t7 17t1.5 10h74 q0 -7 -6 -28t-20.5 -43t-38 -39.5t-58.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 756,
    d: "M377 -5q-78 0 -141.5 30.5t-109 81t-70.5 115.5t-25 133q0 71 26.5 136t73 115t110.5 79.5t139 29.5q77 0 140.5 -31.5t108.5 -82.5t70 -116t25 -132q0 -71 -26 -135.5t-72 -114t-110 -79t-139 -29.5zM171 355q0 -46 14 -89t40.5 -76t65 -53t87.5 -20q50 0 88.5 20.5 t65 54.5t40 76.5t13.5 86.5q0 46 -14.5 89t-41 76t-65 52.5t-86.5 19.5q-50 0 -89 -20.5t-65 -54t-39.5 -76t-13.5 -86.5zM254 916h124l55 -119l-86 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 756,
    d: "M418 770l-86 26l54 119h125zM377 -5q-78 0 -141.5 30.5t-109 81t-70.5 115.5t-25 133q0 71 26.5 136t73 115t110.5 79.5t139 29.5q77 0 140.5 -31.5t108.5 -82.5t70 -116t25 -132q0 -71 -26 -135.5t-72 -114t-110 -79t-139 -29.5zM171 355q0 -46 14 -89t40.5 -76t65 -53 t87.5 -20q50 0 88.5 20.5t65 54.5t40 76.5t13.5 86.5q0 46 -14.5 89t-41 76t-65 52.5t-86.5 19.5q-50 0 -89 -20.5t-65 -54t-39.5 -76t-13.5 -86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 756,
    d: "M225 814l106 101h97l106 -101l-69 -32l-85 63l-85 -63zM377 -5q-78 0 -141.5 30.5t-109 81t-70.5 115.5t-25 133q0 71 26.5 136t73 115t110.5 79.5t139 29.5q77 0 140.5 -31.5t108.5 -82.5t70 -116t25 -132q0 -71 -26 -135.5t-72 -114t-110 -79t-139 -29.5zM171 355 q0 -46 14 -89t40.5 -76t65 -53t87.5 -20q50 0 88.5 20.5t65 54.5t40 76.5t13.5 86.5q0 46 -14.5 89t-41 76t-65 52.5t-86.5 19.5q-50 0 -89 -20.5t-65 -54t-39.5 -76t-13.5 -86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 756,
    d: "M377 -5q-78 0 -141.5 30.5t-109 81t-70.5 115.5t-25 133q0 71 26.5 136t73 115t110.5 79.5t139 29.5q77 0 140.5 -31.5t108.5 -82.5t70 -116t25 -132q0 -71 -26 -135.5t-72 -114t-110 -79t-139 -29.5zM171 355q0 -46 14 -89t40.5 -76t65 -53t87.5 -20q50 0 88.5 20.5 t65 54.5t40 76.5t13.5 86.5q0 46 -14.5 89t-41 76t-65 52.5t-86.5 19.5q-50 0 -89 -20.5t-65 -54t-39.5 -76t-13.5 -86.5zM444 787q-23 0 -40 7t-31.5 15.5t-29 15.5t-30.5 7q-17 0 -26.5 -7t-14.5 -16t-6 -16.5t-1 -8.5h-74q0 9 6 30.5t19.5 43t36 38t55.5 16.5 q23 0 39.5 -7.5t31 -16t29 -16t32.5 -7.5t28.5 7t16 16t7 17t1.5 10h74q0 -7 -6 -28t-20.5 -43t-38 -39.5t-58.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 756,
    d: "M227 790v119h111v-119h-111zM419 790v119h111v-119h-111zM377 -5q-78 0 -141.5 30.5t-109 81t-70.5 115.5t-25 133q0 71 26.5 136t73 115t110.5 79.5t139 29.5q77 0 140.5 -31.5t108.5 -82.5t70 -116t25 -132q0 -71 -26 -135.5t-72 -114t-110 -79t-139 -29.5zM171 355 q0 -46 14 -89t40.5 -76t65 -53t87.5 -20q50 0 88.5 20.5t65 54.5t40 76.5t13.5 86.5q0 46 -14.5 89t-41 76t-65 52.5t-86.5 19.5q-50 0 -89 -20.5t-65 -54t-39.5 -76t-13.5 -86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 477,
    d: "M425 172l-84 -83l-103 103l-103 -103l-83 84l102 102l-98 99l84 83l98 -98l99 99l83 -84l-98 -99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 755,
    d: "M700 710l-74 -106q47 -51 72.5 -116.5t25.5 -134.5q0 -71 -26 -135.5t-72 -114t-110 -79t-139 -29.5q-42 0 -80 9t-72 26l-21 -30h-148l73 104q-47 51 -72.5 116.5t-25.5 134.5q0 71 26.5 136t73 115t110.5 79.5t139 29.5q42 0 79 -9.5t70 -26.5l22 31h149zM585 355 q0 75 -37 137l-251 -359q38 -16 81 -16q50 0 88.5 20.5t65 54.5t40 76.5t13.5 86.5zM171 355q0 -38 9 -73.5t27 -65.5l250 359q-36 17 -79 17q-50 0 -89 -20.5t-65 -54t-39.5 -76t-13.5 -86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 750,
    d: "M374 117q49 0 82.5 20t54 52t29 73.5t8.5 85.5v362h137v-362q0 -73 -17.5 -137t-55 -112t-96.5 -76t-141 -28q-85 0 -144.5 29.5t-96.5 78t-53.5 112.5t-16.5 133v362h138v-362q0 -45 8.5 -86.5t29 -73.5t53.5 -51.5t81 -19.5zM247 916h124l55 -119l-86 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 750,
    d: "M410 770l-86 26l54 119h125zM374 117q49 0 82.5 20t54 52t29 73.5t8.5 85.5v362h137v-362q0 -73 -17.5 -137t-55 -112t-96.5 -76t-141 -28q-85 0 -144.5 29.5t-96.5 78t-53.5 112.5t-16.5 133v362h138v-362q0 -45 8.5 -86.5t29 -73.5t53.5 -51.5t81 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 750,
    d: "M220 814l106 101h97l106 -101l-69 -32l-85 63l-85 -63zM374 117q49 0 82.5 20t54 52t29 73.5t8.5 85.5v362h137v-362q0 -73 -17.5 -137t-55 -112t-96.5 -76t-141 -28q-85 0 -144.5 29.5t-96.5 78t-53.5 112.5t-16.5 133v362h138v-362q0 -45 8.5 -86.5t29 -73.5 t53.5 -51.5t81 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 750,
    d: "M223 790v119h111v-119h-111zM415 790v119h111v-119h-111zM374 117q49 0 82.5 20t54 52t29 73.5t8.5 85.5v362h137v-362q0 -73 -17.5 -137t-55 -112t-96.5 -76t-141 -28q-85 0 -144.5 29.5t-96.5 78t-53.5 112.5t-16.5 133v362h138v-362q0 -45 8.5 -86.5t29 -73.5 t53.5 -51.5t81 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 660,
    d: "M154 710l175 -342l178 342h149l-258 -462v-248h-137v250l-257 460h150zM364 770l-86 26l54 119h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 604,
    d: "M358 582q49 0 90.5 -20.5t71.5 -53.5t47 -75.5t17 -86.5q0 -46 -16 -88.5t-45 -75.5t-69.5 -52.5t-89.5 -19.5h-152v-110h-138v710h138v-128h146zM357 231q19 0 35.5 9t28.5 25t19 36.5t7 44.5q0 25 -8 46t-21.5 36.5t-30.5 24t-36 8.5h-139v-230h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 558,
    d: "M247 117q31 0 57 6.5t45 20t30 33.5t11 48q0 26 -9.5 46t-25.5 34t-36.5 21t-42.5 7h-21v120h19q36 0 56.5 20.5t20.5 53.5q0 21 -8 35t-19.5 22.5t-25.5 12t-26 3.5q-24 0 -40 -9.5t-26 -24t-14 -32.5t-4 -35v-499h-127v522q0 42 17 77t46.5 60.5t70 40t88.5 14.5 q42 0 77.5 -11.5t61.5 -32.5t41 -51.5t15 -68.5q0 -26 -7 -50t-19 -43.5t-27.5 -34t-33.5 -20.5q65 -18 102 -69t37 -123q0 -57 -23.5 -97.5t-62.5 -66.5t-90 -38.5t-107 -13.5v123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 574,
    d: "M204 -10q-38 0 -71 12.5t-57 35t-37.5 52.5t-13.5 66q0 37 16.5 68.5t46 53.5t70.5 34.5t90 12.5q35 0 68.5 -6t59.5 -17v30q0 52 -29.5 80t-87.5 28q-42 0 -82 -15t-82 -44l-41 85q101 67 218 67q113 0 175.5 -55.5t62.5 -160.5v-163q0 -21 7.5 -30t24.5 -10v-114 q-34 -7 -59 -7q-38 0 -58.5 17t-25.5 45l-3 29q-35 -46 -85 -70t-107 -24zM242 88q34 0 64.5 12t47.5 32q22 17 22 38v60q-24 9 -52 14.5t-54 5.5q-52 0 -85 -23.5t-33 -59.5q0 -34 26 -56.5t64 -22.5zM145 730h124l55 -119l-86 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 574,
    d: "M204 -10q-38 0 -71 12.5t-57 35t-37.5 52.5t-13.5 66q0 37 16.5 68.5t46 53.5t70.5 34.5t90 12.5q35 0 68.5 -6t59.5 -17v30q0 52 -29.5 80t-87.5 28q-42 0 -82 -15t-82 -44l-41 85q101 67 218 67q113 0 175.5 -55.5t62.5 -160.5v-163q0 -21 7.5 -30t24.5 -10v-114 q-34 -7 -59 -7q-38 0 -58.5 17t-25.5 45l-3 29q-35 -46 -85 -70t-107 -24zM242 88q34 0 64.5 12t47.5 32q22 17 22 38v60q-24 9 -52 14.5t-54 5.5q-52 0 -85 -23.5t-33 -59.5q0 -34 26 -56.5t64 -22.5zM307 585l-86 26l54 119h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 574,
    d: "M204 -10q-38 0 -71 12.5t-57 35t-37.5 52.5t-13.5 66q0 37 16.5 68.5t46 53.5t70.5 34.5t90 12.5q35 0 68.5 -6t59.5 -17v30q0 52 -29.5 80t-87.5 28q-42 0 -82 -15t-82 -44l-41 85q101 67 218 67q113 0 175.5 -55.5t62.5 -160.5v-163q0 -21 7.5 -30t24.5 -10v-114 q-34 -7 -59 -7q-38 0 -58.5 17t-25.5 45l-3 29q-35 -46 -85 -70t-107 -24zM242 88q34 0 64.5 12t47.5 32q22 17 22 38v60q-24 9 -52 14.5t-54 5.5q-52 0 -85 -23.5t-33 -59.5q0 -34 26 -56.5t64 -22.5zM118 629l106 101h97l106 -101l-69 -32l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 574,
    d: "M204 -10q-38 0 -71 12.5t-57 35t-37.5 52.5t-13.5 66q0 37 16.5 68.5t46 53.5t70.5 34.5t90 12.5q35 0 68.5 -6t59.5 -17v30q0 52 -29.5 80t-87.5 28q-42 0 -82 -15t-82 -44l-41 85q101 67 218 67q113 0 175.5 -55.5t62.5 -160.5v-163q0 -21 7.5 -30t24.5 -10v-114 q-34 -7 -59 -7q-38 0 -58.5 17t-25.5 45l-3 29q-35 -46 -85 -70t-107 -24zM242 88q34 0 64.5 12t47.5 32q22 17 22 38v60q-24 9 -52 14.5t-54 5.5q-52 0 -85 -23.5t-33 -59.5q0 -34 26 -56.5t64 -22.5zM335 602q-23 0 -40 7t-31.5 15.5t-29 15.5t-30.5 7q-17 0 -26.5 -7 t-14.5 -16t-6 -16.5t-1 -8.5h-74q0 9 6 30.5t19.5 43t36 38t55.5 16.5q23 0 39.5 -7.5t31 -16t29 -16t32.5 -7.5t28.5 7t16 16t7 17t1.5 10h74q0 -7 -6 -28t-20.5 -43t-38 -39.5t-58.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 574,
    d: "M204 -10q-38 0 -71 12.5t-57 35t-37.5 52.5t-13.5 66q0 37 16.5 68.5t46 53.5t70.5 34.5t90 12.5q35 0 68.5 -6t59.5 -17v30q0 52 -29.5 80t-87.5 28q-42 0 -82 -15t-82 -44l-41 85q101 67 218 67q113 0 175.5 -55.5t62.5 -160.5v-163q0 -21 7.5 -30t24.5 -10v-114 q-34 -7 -59 -7q-38 0 -58.5 17t-25.5 45l-3 29q-35 -46 -85 -70t-107 -24zM242 88q34 0 64.5 12t47.5 32q22 17 22 38v60q-24 9 -52 14.5t-54 5.5q-52 0 -85 -23.5t-33 -59.5q0 -34 26 -56.5t64 -22.5zM121 604v119h111v-119h-111zM313 604v119h111v-119h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 574,
    d: "M204 -10q-38 0 -71 12.5t-57 35t-37.5 52.5t-13.5 66q0 37 16.5 68.5t46 53.5t70.5 34.5t90 12.5q35 0 68.5 -6t59.5 -17v30q0 52 -29.5 80t-87.5 28q-42 0 -82 -15t-82 -44l-41 85q101 67 218 67q113 0 175.5 -55.5t62.5 -160.5v-163q0 -21 7.5 -30t24.5 -10v-114 q-34 -7 -59 -7q-38 0 -58.5 17t-25.5 45l-3 29q-35 -46 -85 -70t-107 -24zM242 88q34 0 64.5 12t47.5 32q22 17 22 38v60q-24 9 -52 14.5t-54 5.5q-52 0 -85 -23.5t-33 -59.5q0 -34 26 -56.5t64 -22.5zM175 653q0 37 26.5 57t70.5 20t70.5 -20t26.5 -57t-26.5 -57t-70.5 -20 t-70.5 20t-26.5 57zM272 689q-17 0 -28.5 -9.5t-11.5 -26.5q0 -15 11.5 -25.5t28.5 -10.5q16 0 28.5 10t12.5 26q0 17 -12 26.5t-29 9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 937,
    d: "M204 -10q-38 0 -71 12.5t-57 35t-37.5 52.5t-13.5 66q0 37 16.5 68.5t46 53.5t70.5 34.5t90 12.5q32 0 63 -5t55 -15q1 9 3 22.5t5 21.5q-9 91 -115 91q-42 0 -82 -15t-83 -44l-41 85q103 67 219 67q62 0 108 -19.5t75 -54.5q33 34 80 54t106 20q64 0 115 -22t86.5 -59 t54.5 -86t19 -104q0 -11 -1 -23t-2 -20h-410q5 -62 46.5 -96.5t97.5 -34.5q40 0 75.5 19.5t48.5 51.5l115 -32q-29 -60 -93 -98.5t-151 -38.5q-75 0 -132.5 29.5t-92.5 78.5q-18 -29 -43 -49t-53.5 -33.5t-59 -19.5t-57.5 -6zM242 88q34 0 64 12t48 32q10 8 16 17.5t6 18.5 q-2 4 -4 13t-3 18.5l-2 19t-1 14.5q-22 8 -47.5 12.5t-48.5 4.5q-52 0 -85.5 -23.5t-33.5 -59.5q0 -34 26.5 -56.5t64.5 -22.5zM778 302q-5 60 -43.5 97t-95.5 37t-95 -37t-43 -97h277z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 564,
    d: "M225 -127q12 -7 37 -13t52 -6q26 0 41 7.5t15 25.5t-14.5 25.5t-37.5 7.5q-21 0 -44.5 -4.5t-35.5 -7.5l42 83q-59 4 -105.5 27.5t-79 60.5t-50 84t-17.5 99q0 55 19 104t55 86t87 59t115 22q86 0 146.5 -37t90.5 -97l-131 -40q-17 29 -45 44.5t-62 15.5q-29 0 -54 -11.5 t-43.5 -32t-29 -49.5t-10.5 -64t11 -64t29.5 -50t43.5 -32.5t53 -11.5q36 0 66.5 18t42.5 44l131 -40q-25 -54 -78 -90.5t-128 -43.5l-21 -34q7 2 15.5 3t16.5 1q35 0 60 -16.5t25 -53.5q0 -38 -31.5 -63t-96.5 -25q-33 0 -60 6t-47 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    d: "M304 -10q-63 0 -114 21.5t-87 58.5t-55.5 86t-19.5 103q0 56 19 105.5t55 87t87.5 59.5t115.5 22t114.5 -22t86 -59t54 -86t18.5 -102q0 -13 -0.5 -25t-2.5 -20h-405q3 -31 15 -55t31 -41t43 -26t50 -9q40 0 75.5 19.5t48.5 51.5l115 -32q-29 -60 -92.5 -98.5 t-151.5 -38.5zM440 306q-5 59 -43.5 94.5t-93.5 35.5q-27 0 -50.5 -9.5t-41.5 -26.5t-29.5 -41t-13.5 -53h272zM175 730h124l55 -119l-86 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    d: "M337 585l-86 26l54 119h125zM304 -10q-63 0 -114 21.5t-87 58.5t-55.5 86t-19.5 103q0 56 19 105.5t55 87t87.5 59.5t115.5 22t114.5 -22t86 -59t54 -86t18.5 -102q0 -13 -0.5 -25t-2.5 -20h-405q3 -31 15 -55t31 -41t43 -26t50 -9q40 0 75.5 19.5t48.5 51.5l115 -32 q-29 -60 -92.5 -98.5t-151.5 -38.5zM440 306q-5 59 -43.5 94.5t-93.5 35.5q-27 0 -50.5 -9.5t-41.5 -26.5t-29.5 -41t-13.5 -53h272z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    d: "M148 629l106 101h97l106 -101l-69 -32l-85 63l-85 -63zM304 -10q-63 0 -114 21.5t-87 58.5t-55.5 86t-19.5 103q0 56 19 105.5t55 87t87.5 59.5t115.5 22t114.5 -22t86 -59t54 -86t18.5 -102q0 -13 -0.5 -25t-2.5 -20h-405q3 -31 15 -55t31 -41t43 -26t50 -9 q40 0 75.5 19.5t48.5 51.5l115 -32q-29 -60 -92.5 -98.5t-151.5 -38.5zM440 306q-5 59 -43.5 94.5t-93.5 35.5q-27 0 -50.5 -9.5t-41.5 -26.5t-29.5 -41t-13.5 -53h272z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    d: "M151 604v119h111v-119h-111zM343 604v119h111v-119h-111zM304 -10q-63 0 -114 21.5t-87 58.5t-55.5 86t-19.5 103q0 56 19 105.5t55 87t87.5 59.5t115.5 22t114.5 -22t86 -59t54 -86t18.5 -102q0 -13 -0.5 -25t-2.5 -20h-405q3 -31 15 -55t31 -41t43 -26t50 -9 q40 0 75.5 19.5t48.5 51.5l115 -32q-29 -60 -92.5 -98.5t-151.5 -38.5zM440 306q-5 59 -43.5 94.5t-93.5 35.5q-27 0 -50.5 -9.5t-41.5 -26.5t-29.5 -41t-13.5 -53h272z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 255,
    d: "M61 0v524h134v-524h-134zM0 730h124l55 -119l-86 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 255,
    d: "M162 585l-86 26l54 119h125zM61 0v524h134v-524h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 255,
    d: "M-27 629l106 101h97l106 -101l-69 -32l-85 63l-85 -63zM61 0v524h134v-524h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 255,
    d: "M-24 604v119h111v-119h-111zM168 604v119h111v-119h-111zM61 0v524h134v-524h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 613,
    d: "M526 660l-71 -39q63 -73 94 -160.5t31 -170.5q0 -70 -21 -125.5t-57.5 -94.5t-87.5 -59.5t-111 -20.5q-58 0 -107.5 18.5t-86 51t-57.5 77t-21 96.5q0 49 19 93t51.5 76t76.5 51t95 19q52 0 97 -21.5t73 -56.5q-11 48 -32 93t-58 87l-93 -52l-39 52l85 47q-32 28 -71 55 t-89 54h172q48 -26 90 -62l79 45zM169 234q0 -28 10.5 -51.5t28.5 -41t43 -27.5t54 -10q30 0 55 10.5t43.5 28.5t29 42t10.5 52t-10.5 51t-28.5 40t-43 26.5t-54 9.5q-30 0 -55 -10t-43.5 -27.5t-29 -41t-10.5 -51.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 604,
    d: "M548 0h-134v294q0 63 -22 92t-61 29q-20 0 -41 -8t-39.5 -22.5t-33.5 -34.5t-22 -44v-306h-134v524h121v-97q29 50 84 78t124 28q49 0 80 -18t48 -47t23.5 -66t6.5 -75v-327zM379 602q-23 0 -40 7t-31.5 15.5t-29 15.5t-30.5 7q-17 0 -26.5 -7t-14.5 -16t-6 -16.5 t-1 -8.5h-74q0 9 6 30.5t19.5 43t36 38t55.5 16.5q23 0 39.5 -7.5t31 -16t29 -16t32.5 -7.5t28.5 7t16 16t7 17t1.5 10h74q0 -7 -6 -28t-20.5 -43t-38 -39.5t-58.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 606,
    d: "M303 -10q-64 0 -115 22t-86.5 59.5t-54.5 86.5t-19 103q0 55 19 104t54.5 86.5t86.5 59.5t115 22t114.5 -22t86 -59.5t54.5 -86.5t19 -104q0 -54 -19 -103t-54 -86.5t-86 -59.5t-115 -22zM166 261q0 -35 10.5 -63.5t29 -49.5t43.5 -32.5t54 -11.5t54 11.5t43.5 32.5 t29 50t10.5 64q0 34 -10.5 63t-29 50t-43.5 32.5t-54 11.5t-54 -12t-43.5 -33t-29 -50t-10.5 -63zM176 730h124l55 -119l-86 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 606,
    d: "M337 585l-86 26l54 119h125zM303 -10q-64 0 -115 22t-86.5 59.5t-54.5 86.5t-19 103q0 55 19 104t54.5 86.5t86.5 59.5t115 22t114.5 -22t86 -59.5t54.5 -86.5t19 -104q0 -54 -19 -103t-54 -86.5t-86 -59.5t-115 -22zM166 261q0 -35 10.5 -63.5t29 -49.5t43.5 -32.5 t54 -11.5t54 11.5t43.5 32.5t29 50t10.5 64q0 34 -10.5 63t-29 50t-43.5 32.5t-54 11.5t-54 -12t-43.5 -33t-29 -50t-10.5 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 606,
    d: "M148 629l106 101h97l106 -101l-69 -32l-85 63l-85 -63zM303 -10q-64 0 -115 22t-86.5 59.5t-54.5 86.5t-19 103q0 55 19 104t54.5 86.5t86.5 59.5t115 22t114.5 -22t86 -59.5t54.5 -86.5t19 -104q0 -54 -19 -103t-54 -86.5t-86 -59.5t-115 -22zM166 261q0 -35 10.5 -63.5 t29 -49.5t43.5 -32.5t54 -11.5t54 11.5t43.5 32.5t29 50t10.5 64q0 34 -10.5 63t-29 50t-43.5 32.5t-54 11.5t-54 -12t-43.5 -33t-29 -50t-10.5 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 606,
    d: "M303 -10q-64 0 -115 22t-86.5 59.5t-54.5 86.5t-19 103q0 55 19 104t54.5 86.5t86.5 59.5t115 22t114.5 -22t86 -59.5t54.5 -86.5t19 -104q0 -54 -19 -103t-54 -86.5t-86 -59.5t-115 -22zM166 261q0 -35 10.5 -63.5t29 -49.5t43.5 -32.5t54 -11.5t54 11.5t43.5 32.5 t29 50t10.5 64q0 34 -10.5 63t-29 50t-43.5 32.5t-54 11.5t-54 -12t-43.5 -33t-29 -50t-10.5 -63zM366 602q-23 0 -40 7t-31.5 15.5t-29 15.5t-30.5 7q-17 0 -26.5 -7t-14.5 -16t-6 -16.5t-1 -8.5h-74q0 9 6 30.5t19.5 43t36 38t55.5 16.5q23 0 39.5 -7.5t31 -16t29 -16 t32.5 -7.5t28.5 7t16 16t7 17t1.5 10h74q0 -7 -6 -28t-20.5 -43t-38 -39.5t-58.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 606,
    d: "M151 604v119h111v-119h-111zM343 604v119h111v-119h-111zM303 -10q-64 0 -115 22t-86.5 59.5t-54.5 86.5t-19 103q0 55 19 104t54.5 86.5t86.5 59.5t115 22t114.5 -22t86 -59.5t54.5 -86.5t19 -104q0 -54 -19 -103t-54 -86.5t-86 -59.5t-115 -22zM166 261 q0 -35 10.5 -63.5t29 -49.5t43.5 -32.5t54 -11.5t54 11.5t43.5 32.5t29 50t10.5 64q0 34 -10.5 63t-29 50t-43.5 32.5t-54 11.5t-54 -12t-43.5 -33t-29 -50t-10.5 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 511,
    d: "M200 419v128h113v-128h-113zM200 48v129h113v-129h-113zM54 244v107h404v-107h-404z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 606,
    d: "M50 -4l58 68q-39 38 -59.5 89t-20.5 108q0 55 19 104t54.5 86.5t86.5 59.5t115 22q42 0 78 -10t66 -27l27 32h76l-56 -67q40 -38 61.5 -89.5t21.5 -110.5q0 -54 -19 -103t-54 -86.5t-86 -59.5t-115 -22q-44 0 -81 10t-68 29l-28 -33h-76zM303 104q29 0 54 11.5t43.5 32.5 t29 50t10.5 64q0 29 -7.5 54.5t-21.5 45.5l-181 -236q33 -22 73 -22zM166 261q0 -57 27 -98l179 236q-31 20 -69 20q-29 0 -54 -12t-43.5 -33t-29 -50t-10.5 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 618,
    d: "M221 -10q-81 0 -123 52t-42 154v328h134v-299q0 -121 87 -121q39 0 75.5 23.5t59.5 71.5v325h134v-370q0 -21 7.5 -30t24.5 -10v-114q-20 -4 -33.5 -5t-24.5 -1q-36 0 -58.5 16.5t-26.5 45.5l-3 42q-35 -54 -90 -81t-121 -27zM173 730h124l55 -119l-86 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 618,
    d: "M335 585l-86 26l54 119h125zM221 -10q-81 0 -123 52t-42 154v328h134v-299q0 -121 87 -121q39 0 75.5 23.5t59.5 71.5v325h134v-370q0 -21 7.5 -30t24.5 -10v-114q-20 -4 -33.5 -5t-24.5 -1q-36 0 -58.5 16.5t-26.5 45.5l-3 42q-35 -54 -90 -81t-121 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 618,
    d: "M146 629l106 101h97l106 -101l-69 -32l-85 63l-85 -63zM221 -10q-81 0 -123 52t-42 154v328h134v-299q0 -121 87 -121q39 0 75.5 23.5t59.5 71.5v325h134v-370q0 -21 7.5 -30t24.5 -10v-114q-20 -4 -33.5 -5t-24.5 -1q-36 0 -58.5 16.5t-26.5 45.5l-3 42q-35 -54 -90 -81 t-121 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 618,
    d: "M149 604v119h111v-119h-111zM341 604v119h111v-119h-111zM221 -10q-81 0 -123 52t-42 154v328h134v-299q0 -121 87 -121q39 0 75.5 23.5t59.5 71.5v325h134v-370q0 -21 7.5 -30t24.5 -10v-114q-20 -4 -33.5 -5t-24.5 -1q-36 0 -58.5 16.5t-26.5 45.5l-3 42 q-35 -54 -90 -81t-121 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 550,
    d: "M72 -102q17 -5 33 -7.5t27 -2.5q13 0 24 5t20 17.5t18 34.5t19 55l-207 524h138l142 -408l126 408h126l-220 -628q-19 -55 -65 -90t-114 -35q-16 0 -32.5 2.5t-34.5 8.5v116zM321 585l-86 26l54 119h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 601,
    d: "M574 256q0 -56 -21 -106.5t-57 -89t-83.5 -61.5t-101.5 -23q-46 0 -74 17t-39 34v-240h-137v923h137v-227q14 19 41.5 37.5t79.5 18.5q58 0 105.5 -25t80.5 -65.5t51 -91t18 -101.5zM437 258q0 32 -8.5 61t-25 51t-40 35t-52.5 13q-41 0 -68 -23.5t-45 -58.5v-160 q0 -14 10 -28t25.5 -25.5t35 -18.5t38.5 -7q28 0 52 13t41 34.5t27 51t10 62.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 550,
    d: "M72 -102q17 -5 33 -7.5t27 -2.5q13 0 24 5t20 17.5t18 34.5t19 55l-207 524h138l142 -408l126 408h126l-220 -628q-19 -55 -65 -90t-114 -35q-16 0 -32.5 2.5t-34.5 8.5v116zM135 604v119h111v-119h-111zM327 604v119h111v-119h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 672,
    d: "M276 710h122l270 -710h-142l-66 177h-248l-65 -177h-142zM435 274l-98 279l-102 -279h200zM188 818v83h300v-83h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 574,
    d: "M204 -10q-38 0 -71 12.5t-57 35t-37.5 52.5t-13.5 66q0 37 16.5 68.5t46 53.5t70.5 34.5t90 12.5q35 0 68.5 -6t59.5 -17v30q0 52 -29.5 80t-87.5 28q-42 0 -82 -15t-82 -44l-41 85q101 67 218 67q113 0 175.5 -55.5t62.5 -160.5v-163q0 -21 7.5 -30t24.5 -10v-114 q-34 -7 -59 -7q-38 0 -58.5 17t-25.5 45l-3 29q-35 -46 -85 -70t-107 -24zM242 88q34 0 64.5 12t47.5 32q22 17 22 38v60q-24 9 -52 14.5t-54 5.5q-52 0 -85 -23.5t-33 -59.5q0 -34 26 -56.5t64 -22.5zM123 633v83h300v-83h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 672,
    d: "M276 710h122l270 -710h-142l-66 177h-248l-65 -177h-142zM435 274l-98 279l-102 -279h200zM337 841q23 0 40 21t20 53h71q0 -29 -10 -53.5t-27 -42.5t-41.5 -28t-52.5 -10q-29 0 -53 10t-41 28t-27 42.5t-10 53.5h72q0 -30 18 -52t41 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 574,
    d: "M204 -10q-38 0 -71 12.5t-57 35t-37.5 52.5t-13.5 66q0 37 16.5 68.5t46 53.5t70.5 34.5t90 12.5q35 0 68.5 -6t59.5 -17v30q0 52 -29.5 80t-87.5 28q-42 0 -82 -15t-82 -44l-41 85q101 67 218 67q113 0 175.5 -55.5t62.5 -160.5v-163q0 -21 7.5 -30t24.5 -10v-114 q-34 -7 -59 -7q-38 0 -58.5 17t-25.5 45l-3 29q-35 -46 -85 -70t-107 -24zM242 88q34 0 64.5 12t47.5 32q22 17 22 38v60q-24 9 -52 14.5t-54 5.5q-52 0 -85 -23.5t-33 -59.5q0 -34 26 -56.5t64 -22.5zM272 656q23 0 40 21t20 53h71q0 -29 -10 -53.5t-27 -42.5t-41.5 -28 t-52.5 -10q-29 0 -53 10t-41 28t-27 42.5t-10 53.5h72q0 -30 18 -52t41 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 678,
    d: "M625 -196q-58 8 -86.5 32t-28.5 55q0 58 81 109h-65l-66 177h-248l-65 -177h-142l271 710h122l270 -710q-77 -46 -77 -85q0 -37 62 -41zM435 274l-98 279l-102 -279h200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 575,
    d: "M499 -196q-58 8 -86.5 32t-28.5 55q0 55 74 104q-51 11 -59 60l-3 29q-35 -46 -85 -70t-107 -24q-38 0 -71 12.5t-57 35t-37.5 52.5t-13.5 66q0 37 16.5 68.5t46 53.5t70.5 34.5t90 12.5q35 0 68.5 -6t59.5 -17v30q0 52 -29.5 80t-87.5 28q-42 0 -82 -15t-82 -44l-41 85 q101 67 218 67q113 0 175.5 -55.5t62.5 -160.5v-163q0 -21 7.5 -30t24.5 -10v-114q-77 -46 -77 -85q0 -37 62 -41zM242 88q34 0 64.5 12t47.5 32q22 17 22 38v60q-24 9 -52 14.5t-54 5.5q-52 0 -85 -23.5t-33 -59.5q0 -34 26 -56.5t64 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 686,
    d: "M417 770l-86 26l54 119h125zM31 360q0 65 23.5 128.5t68.5 113.5t110 81t148 31q98 0 169.5 -43t106.5 -112l-106 -73q-14 30 -34 50.5t-43 32.5t-48 17.5t-49 5.5q-52 0 -90.5 -21t-64 -54.5t-38.5 -76t-13 -84.5q0 -47 15 -90.5t42.5 -76.5t66 -53t84.5 -20q24 0 50 6 t49.5 19t43.5 33.5t32 49.5l113 -65q-17 -40 -48.5 -70.5t-71 -51.5t-84.5 -32t-88 -11q-76 0 -139 32t-108.5 83.5t-71 117t-25.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 564,
    d: "M338 585l-86 26l54 119h125zM28 262q0 55 19 104t55 86t87 59t115 22q86 0 146.5 -37t90.5 -97l-131 -40q-17 29 -45 44.5t-62 15.5q-29 0 -54 -11.5t-43.5 -32t-29 -49.5t-10.5 -64t11 -64t29.5 -50t43.5 -32.5t53 -11.5q36 0 66.5 18t42.5 44l131 -40q-27 -60 -89 -98 t-149 -38q-64 0 -115 22t-87 59.5t-55.5 87t-19.5 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 686,
    d: "M224 814l106 101h97l106 -101l-69 -32l-85 63l-85 -63zM31 360q0 65 23.5 128.5t68.5 113.5t110 81t148 31q98 0 169.5 -43t106.5 -112l-106 -73q-14 30 -34 50.5t-43 32.5t-48 17.5t-49 5.5q-52 0 -90.5 -21t-64 -54.5t-38.5 -76t-13 -84.5q0 -47 15 -90.5t42.5 -76.5 t66 -53t84.5 -20q24 0 50 6t49.5 19t43.5 33.5t32 49.5l113 -65q-17 -40 -48.5 -70.5t-71 -51.5t-84.5 -32t-88 -11q-76 0 -139 32t-108.5 83.5t-71 117t-25.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 564,
    d: "M149 629l106 101h97l106 -101l-69 -32l-85 63l-85 -63zM28 262q0 55 19 104t55 86t87 59t115 22q86 0 146.5 -37t90.5 -97l-131 -40q-17 29 -45 44.5t-62 15.5q-29 0 -54 -11.5t-43.5 -32t-29 -49.5t-10.5 -64t11 -64t29.5 -50t43.5 -32.5t53 -11.5q36 0 66.5 18t42.5 44 l131 -40q-27 -60 -89 -98t-149 -38q-64 0 -115 22t-87 59.5t-55.5 87t-19.5 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 686,
    d: "M31 360q0 65 23.5 128.5t68.5 113.5t110 81t148 31q98 0 169.5 -43t106.5 -112l-106 -73q-14 30 -34 50.5t-43 32.5t-48 17.5t-49 5.5q-52 0 -90.5 -21t-64 -54.5t-38.5 -76t-13 -84.5q0 -47 15 -90.5t42.5 -76.5t66 -53t84.5 -20q24 0 50 6t49.5 19t43.5 33.5t32 49.5 l113 -65q-17 -40 -48.5 -70.5t-71 -51.5t-84.5 -32t-88 -11q-76 0 -139 32t-108.5 83.5t-71 117t-25.5 133.5zM322 789v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 564,
    d: "M28 262q0 55 19 104t55 86t87 59t115 22q86 0 146.5 -37t90.5 -97l-131 -40q-17 29 -45 44.5t-62 15.5q-29 0 -54 -11.5t-43.5 -32t-29 -49.5t-10.5 -64t11 -64t29.5 -50t43.5 -32.5t53 -11.5q36 0 66.5 18t42.5 44l131 -40q-27 -60 -89 -98t-149 -38q-64 0 -115 22 t-87 59.5t-55.5 87t-19.5 103.5zM243 604v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 686,
    d: "M300 915l85 -63l85 63l69 -32l-106 -101h-97l-106 101zM31 360q0 65 23.5 128.5t68.5 113.5t110 81t148 31q98 0 169.5 -43t106.5 -112l-106 -73q-14 30 -34 50.5t-43 32.5t-48 17.5t-49 5.5q-52 0 -90.5 -21t-64 -54.5t-38.5 -76t-13 -84.5q0 -47 15 -90.5t42.5 -76.5 t66 -53t84.5 -20q24 0 50 6t49.5 19t43.5 33.5t32 49.5l113 -65q-17 -40 -48.5 -70.5t-71 -51.5t-84.5 -32t-88 -11q-76 0 -139 32t-108.5 83.5t-71 117t-25.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 564,
    d: "M219 730l85 -63l85 63l69 -32l-106 -101h-97l-106 101zM28 262q0 55 19 104t55 86t87 59t115 22q86 0 146.5 -37t90.5 -97l-131 -40q-17 29 -45 44.5t-62 15.5q-29 0 -54 -11.5t-43.5 -32t-29 -49.5t-10.5 -64t11 -64t29.5 -50t43.5 -32.5t53 -11.5q36 0 66.5 18t42.5 44 l131 -40q-27 -60 -89 -98t-149 -38q-64 0 -115 22t-87 59.5t-55.5 87t-19.5 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 716,
    d: "M245 915l85 -63l85 63l69 -32l-106 -101h-97l-106 101zM74 0v710h258q87 0 152.5 -28t109.5 -76t66 -112.5t22 -137.5q0 -81 -24.5 -146.5t-70.5 -112t-110.5 -72t-144.5 -25.5h-258zM543 356q0 51 -14 94t-41 74t-66.5 48t-89.5 17h-120v-468h120q51 0 90.5 18t66 49.5 t40.5 74.5t14 93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 645,
    d: "M687 585l-86 26l54 119h125zM278 -10q-54 0 -100 21t-79 58t-51.5 86.5t-18.5 106.5t17.5 106t48.5 86t74 58t94 21q58 0 104.5 -28t72.5 -73v298h134v-576q0 -21 7 -30t24 -10v-114q-35 -7 -57 -7q-36 0 -59 18t-26 47l-3 33q-29 -50 -78.5 -75.5t-103.5 -25.5zM313 104 q19 0 39 6.5t37 18.5t30.5 28t20.5 35v125q-8 22 -22.5 40.5t-33 32t-39 21.5t-40.5 8q-30 0 -55.5 -13t-43.5 -35.5t-28 -51.5t-10 -60q0 -33 11 -61t30 -49t45.5 -33t58.5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 721,
    d: "M79 0v307h-48v100h48v303h258q87 0 152.5 -28t109.5 -76t66 -112.5t22 -137.5q0 -81 -24.5 -146.5t-70.5 -112t-110.5 -72t-144.5 -25.5h-258zM548 356q0 51 -14 94t-41 74t-66.5 48t-89.5 17h-120v-182h139v-100h-139v-186h120q51 0 90.5 18t66 49.5t40.5 74.5t14 93z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 645,
    d: "M278 -10q-54 0 -100 21t-79 58t-51.5 86.5t-18.5 106.5t17.5 106t48.5 86t74 58t94 21q58 0 104.5 -28t72.5 -73v165h-100v79h100v54h134v-54h63v-79h-63v-443q0 -21 7 -30t24 -10v-114q-35 -7 -57 -7q-36 0 -59 18t-26 47l-3 33q-29 -50 -78.5 -75.5t-103.5 -25.5z M313 104q19 0 39 6.5t37 18.5t30.5 28t20.5 35v125q-8 22 -22.5 40.5t-33 32t-39 21.5t-40.5 8q-30 0 -55.5 -13t-43.5 -35.5t-28 -51.5t-10 -60q0 -33 11 -61t30 -49t45.5 -33t58.5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 601,
    d: "M567 121v-121h-493v710h484v-121h-346v-171h299v-112h-299v-185h355zM177 818v83h300v-83h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    d: "M304 -10q-63 0 -114 21.5t-87 58.5t-55.5 86t-19.5 103q0 56 19 105.5t55 87t87.5 59.5t115.5 22t114.5 -22t86 -59t54 -86t18.5 -102q0 -13 -0.5 -25t-2.5 -20h-405q3 -31 15 -55t31 -41t43 -26t50 -9q40 0 75.5 19.5t48.5 51.5l115 -32q-29 -60 -92.5 -98.5 t-151.5 -38.5zM440 306q-5 59 -43.5 94.5t-93.5 35.5q-27 0 -50.5 -9.5t-41.5 -26.5t-29.5 -41t-13.5 -53h272zM153 633v83h300v-83h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 601,
    d: "M567 121v-121h-493v710h484v-121h-346v-171h299v-112h-299v-185h355zM326 841q23 0 40 21t20 53h71q0 -29 -10 -53.5t-27 -42.5t-41.5 -28t-52.5 -10q-29 0 -53 10t-41 28t-27 42.5t-10 53.5h72q0 -30 18 -52t41 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    d: "M304 -10q-63 0 -114 21.5t-87 58.5t-55.5 86t-19.5 103q0 56 19 105.5t55 87t87.5 59.5t115.5 22t114.5 -22t86 -59t54 -86t18.5 -102q0 -13 -0.5 -25t-2.5 -20h-405q3 -31 15 -55t31 -41t43 -26t50 -9q40 0 75.5 19.5t48.5 51.5l115 -32q-29 -60 -92.5 -98.5 t-151.5 -38.5zM440 306q-5 59 -43.5 94.5t-93.5 35.5q-27 0 -50.5 -9.5t-41.5 -26.5t-29.5 -41t-13.5 -53h272zM302 656q23 0 40 21t20 53h71q0 -29 -10 -53.5t-27 -42.5t-41.5 -28t-52.5 -10q-29 0 -53 10t-41 28t-27 42.5t-10 53.5h72q0 -30 18 -52t41 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 601,
    d: "M567 121v-121h-493v710h484v-121h-346v-171h299v-112h-299v-185h355zM266 789v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    d: "M304 -10q-63 0 -114 21.5t-87 58.5t-55.5 86t-19.5 103q0 56 19 105.5t55 87t87.5 59.5t115.5 22t114.5 -22t86 -59t54 -86t18.5 -102q0 -13 -0.5 -25t-2.5 -20h-405q3 -31 15 -55t31 -41t43 -26t50 -9q40 0 75.5 19.5t48.5 51.5l115 -32q-29 -60 -92.5 -98.5 t-151.5 -38.5zM440 306q-5 59 -43.5 94.5t-93.5 35.5q-27 0 -50.5 -9.5t-41.5 -26.5t-29.5 -41t-13.5 -53h272zM242 604v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 602,
    d: "M567 121v-121q-77 -46 -77 -85q0 -37 62 -41l-28 -70q-58 8 -86.5 32t-28.5 55q0 58 81 109h-416v710h484v-121h-346v-171h299v-112h-299v-185h355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    d: "M333 -198q-58 8 -86.5 32t-28.5 55q0 53 70 102q-60 3 -108 25t-82 58.5t-52 84t-18 100.5q0 56 19 105.5t55 87t87.5 59.5t115.5 22t114.5 -22t86 -59t54 -86t18.5 -102q0 -13 -0.5 -25t-2.5 -20h-405q3 -31 15 -55t31 -41t43 -26t50 -9q40 0 75.5 19.5t48.5 51.5 l115 -32q-23 -48 -67.5 -82t-105.5 -47q-76 -46 -76 -85q0 -37 62 -41zM440 306q-5 59 -43.5 94.5t-93.5 35.5q-27 0 -50.5 -9.5t-41.5 -26.5t-29.5 -41t-13.5 -53h272z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 601,
    d: "M241 915l85 -63l85 63l69 -32l-106 -101h-97l-106 101zM567 121v-121h-493v710h484v-121h-346v-171h299v-112h-299v-185h355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    d: "M218 730l85 -63l85 63l69 -32l-106 -101h-97l-106 101zM304 -10q-63 0 -114 21.5t-87 58.5t-55.5 86t-19.5 103q0 56 19 105.5t55 87t87.5 59.5t115.5 22t114.5 -22t86 -59t54 -86t18.5 -102q0 -13 -0.5 -25t-2.5 -20h-405q3 -31 15 -55t31 -41t43 -26t50 -9 q40 0 75.5 19.5t48.5 51.5l115 -32q-29 -60 -92.5 -98.5t-151.5 -38.5zM440 306q-5 59 -43.5 94.5t-93.5 35.5q-27 0 -50.5 -9.5t-41.5 -26.5t-29.5 -41t-13.5 -53h272z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 725,
    d: "M223 814l106 101h97l106 -101l-69 -32l-85 63l-85 -63zM567 80q-85 -85 -198 -85q-70 0 -131.5 28t-107 77t-72 115.5t-26.5 143.5q0 73 26.5 137.5t73 113t109.5 77t137 28.5q100 0 171.5 -42t107.5 -113l-103 -76q-27 53 -75.5 81t-105.5 28q-45 0 -82.5 -19t-64 -52 t-41 -76t-14.5 -91q0 -50 16 -93.5t44 -75.5t66.5 -50.5t83.5 -18.5q103 0 186 97v50h-143v101h257v-365h-114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 634,
    d: "M186 629l106 101h97l106 -101l-69 -32l-85 63l-85 -63zM265 -3q-53 0 -96 21t-74.5 57.5t-48.5 84.5t-17 102q0 57 18 106t50 86t77 58t99 21q61 0 107 -27.5t76 -73.5v92h117v-499q0 -58 -22 -104t-60.5 -78t-92 -49t-116.5 -17q-86 0 -144.5 28.5t-100.5 80.5l73 71 q30 -37 75.5 -58t96.5 -21q31 0 59.5 8.5t50.5 26.5t34.5 46t12.5 66v66q-26 -45 -73 -69.5t-101 -24.5zM310 104q22 0 42 7t37 19t30 28t20 34v125q-18 46 -56.5 74t-80.5 28q-31 0 -56 -13.5t-43 -36t-27.5 -51.5t-9.5 -60q0 -32 11 -60t30.5 -49t45.5 -33t57 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 725,
    d: "M567 80q-85 -85 -198 -85q-70 0 -131.5 28t-107 77t-72 115.5t-26.5 143.5q0 73 26.5 137.5t73 113t109.5 77t137 28.5q100 0 171.5 -42t107.5 -113l-103 -76q-27 53 -75.5 81t-105.5 28q-45 0 -82.5 -19t-64 -52t-41 -76t-14.5 -91q0 -50 16 -93.5t44 -75.5t66.5 -50.5 t83.5 -18.5q103 0 186 97v50h-143v101h257v-365h-114v80zM378 841q23 0 40 21t20 53h71q0 -29 -10 -53.5t-27 -42.5t-41.5 -28t-52.5 -10q-29 0 -53 10t-41 28t-27 42.5t-10 53.5h72q0 -30 18 -52t41 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 634,
    d: "M265 -3q-53 0 -96 21t-74.5 57.5t-48.5 84.5t-17 102q0 57 18 106t50 86t77 58t99 21q61 0 107 -27.5t76 -73.5v92h117v-499q0 -58 -22 -104t-60.5 -78t-92 -49t-116.5 -17q-86 0 -144.5 28.5t-100.5 80.5l73 71q30 -37 75.5 -58t96.5 -21q31 0 59.5 8.5t50.5 26.5 t34.5 46t12.5 66v66q-26 -45 -73 -69.5t-101 -24.5zM310 104q22 0 42 7t37 19t30 28t20 34v125q-18 46 -56.5 74t-80.5 28q-31 0 -56 -13.5t-43 -36t-27.5 -51.5t-9.5 -60q0 -32 11 -60t30.5 -49t45.5 -33t57 -12zM340 656q23 0 40 21t20 53h71q0 -29 -10 -53.5t-27 -42.5 t-41.5 -28t-52.5 -10q-29 0 -53 10t-41 28t-27 42.5t-10 53.5h72q0 -30 18 -52t41 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 725,
    d: "M567 80q-85 -85 -198 -85q-70 0 -131.5 28t-107 77t-72 115.5t-26.5 143.5q0 73 26.5 137.5t73 113t109.5 77t137 28.5q100 0 171.5 -42t107.5 -113l-103 -76q-27 53 -75.5 81t-105.5 28q-45 0 -82.5 -19t-64 -52t-41 -76t-14.5 -91q0 -50 16 -93.5t44 -75.5t66.5 -50.5 t83.5 -18.5q103 0 186 97v50h-143v101h257v-365h-114v80zM319 789v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 634,
    d: "M265 -3q-53 0 -96 21t-74.5 57.5t-48.5 84.5t-17 102q0 57 18 106t50 86t77 58t99 21q61 0 107 -27.5t76 -73.5v92h117v-499q0 -58 -22 -104t-60.5 -78t-92 -49t-116.5 -17q-86 0 -144.5 28.5t-100.5 80.5l73 71q30 -37 75.5 -58t96.5 -21q31 0 59.5 8.5t50.5 26.5 t34.5 46t12.5 66v66q-26 -45 -73 -69.5t-101 -24.5zM310 104q22 0 42 7t37 19t30 28t20 34v125q-18 46 -56.5 74t-80.5 28q-31 0 -56 -13.5t-43 -36t-27.5 -51.5t-9.5 -60q0 -32 11 -60t30.5 -49t45.5 -33t57 -12zM280 604v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 725,
    d: "M326 -213l27 72h-39v94h113v-94l-40 -72h-61zM567 80q-85 -85 -198 -85q-70 0 -131.5 28t-107 77t-72 115.5t-26.5 143.5q0 73 26.5 137.5t73 113t109.5 77t137 28.5q100 0 171.5 -42t107.5 -113l-103 -76q-27 53 -75.5 81t-105.5 28q-45 0 -82.5 -19t-64 -52t-41 -76 t-14.5 -91q0 -50 16 -93.5t44 -75.5t66.5 -50.5t83.5 -18.5q103 0 186 97v50h-143v101h257v-365h-114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    horizAdvX: 634,
    d: "M369 747l-27 -72h39v-94h-113v94l40 72h61zM265 -3q-53 0 -96 21t-74.5 57.5t-48.5 84.5t-17 102q0 57 18 106t50 86t77 58t99 21q61 0 107 -27.5t76 -73.5v92h117v-499q0 -58 -22 -104t-60.5 -78t-92 -49t-116.5 -17q-86 0 -144.5 28.5t-100.5 80.5l73 71 q30 -37 75.5 -58t96.5 -21q31 0 59.5 8.5t50.5 26.5t34.5 46t12.5 66v66q-26 -45 -73 -69.5t-101 -24.5zM310 104q22 0 42 7t37 19t30 28t20 34v125q-18 46 -56.5 74t-80.5 28q-31 0 -56 -13.5t-43 -36t-27.5 -51.5t-9.5 -60q0 -32 11 -60t30.5 -49t45.5 -33t57 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 745,
    d: "M221 814l106 101h97l106 -101l-69 -32l-85 63l-85 -63zM671 710v-710h-137v303h-322v-303h-138v710h138v-287h322v287h137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 604,
    d: "M244 630l93 98h86l93 -98l-61 -32l-75 62l-74 -62zM548 0h-134v294q0 62 -23 91.5t-65 29.5q-18 0 -38 -8t-38 -22.5t-33 -34.5t-22 -44v-306h-134v730h134v-303q29 51 78.5 78.5t109.5 27.5q51 0 83 -17.5t50 -46.5t25 -66t7 -76v-327z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 753,
    d: "M675 710v-101h50v-66h-50v-543h-137v303h-322v-303h-138v543h-50v66h50v101h138v-101h322v101h137zM538 423v120h-322v-120h322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 604,
    d: "M548 0h-134v294q0 62 -23 91.5t-65 29.5q-18 0 -38 -8t-38 -22.5t-33 -34.5t-22 -44v-306h-134v597h-45v79h45v54h134v-54h118v-79h-118v-170q29 51 78.5 78.5t109.5 27.5q51 0 83 -17.5t50 -46.5t25 -66t7 -76v-327z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 286,
    d: "M74 0v710h138v-710h-138zM206 787q-23 0 -40 7t-31.5 15.5t-29 15.5t-30.5 7q-17 0 -26.5 -7t-14.5 -16t-6 -16.5t-1 -8.5h-74q0 9 6 30.5t19.5 43t36 38t55.5 16.5q23 0 39.5 -7.5t31 -16t29 -16t32.5 -7.5t28.5 7t16 16t7 17t1.5 10h74q0 -7 -6 -28t-20.5 -43 t-38 -39.5t-58.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 255,
    d: "M61 0v524h134v-524h-134zM191 602q-23 0 -40 7t-31.5 15.5t-29 15.5t-30.5 7q-17 0 -26.5 -7t-14.5 -16t-6 -16.5t-1 -8.5h-74q0 9 6 30.5t19.5 43t36 38t55.5 16.5q23 0 39.5 -7.5t31 -16t29 -16t32.5 -7.5t28.5 7t16 16t7 17t1.5 10h74q0 -7 -6 -28t-20.5 -43 t-38 -39.5t-58.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 286,
    d: "M74 0v710h138v-710h-138zM-6 818v83h300v-83h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 255,
    d: "M61 0v524h134v-524h-134zM-21 633v83h300v-83h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 286,
    d: "M74 0v710h138v-710h-138zM142 841q23 0 40 21t20 53h71q0 -29 -10 -53.5t-27 -42.5t-41.5 -28t-52.5 -10q-29 0 -53 10t-41 28t-27 42.5t-10 53.5h72q0 -30 18 -52t41 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 255,
    d: "M61 0v524h134v-524h-134zM127 656q23 0 40 21t20 53h71q0 -29 -10 -53.5t-27 -42.5t-41.5 -28t-52.5 -10q-29 0 -53 10t-41 28t-27 42.5t-10 53.5h72q0 -30 18 -52t41 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 286,
    d: "M169 -196q-58 8 -86.5 32t-28.5 55q0 58 81 109h-61v710h138v-710q-77 -46 -77 -85q0 -37 62 -41l-28 -70v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 255,
    d: "M152 -196q-58 8 -86.5 32t-28.5 55q0 58 81 109h-57v524h134v-524q-77 -46 -77 -85q0 -37 62 -41zM61 597v133h134v-133h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 286,
    d: "M74 0v710h138v-710h-138zM82 789v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 255,
    d: "M61 0v524h134v-524h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 777,
    d: "M74 0v710h138v-710h-138zM324 145q14 -10 47 -22t76 -12q42 0 67 14.5t38 44.5t17 74.5t4 104.5v361h138v-361q0 -81 -8.5 -147.5t-36 -113.5t-79.5 -73t-140 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 516,
    d: "M61 0v524h134v-524h-134zM61 597v133h134v-133h-134zM273 -196q-38 0 -72 11.5t-61 35.5l58 91q11 -11 27 -16.5t32 -5.5q26 0 45 18.5t19 47.5v538h134v-528q0 -42 -14 -77.5t-38.5 -61t-58 -39.5t-71.5 -14zM321 597v133h134v-133h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 491,
    d: "M203 814l106 101h97l106 -101l-69 -32l-85 63l-85 -63zM38 145q14 -10 47 -22t76 -12q42 0 67 14.5t38 44.5t17 74.5t4 104.5v361h138v-361q0 -81 -8.5 -147.5t-36 -113.5t-79.5 -73t-140 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 255,
    d: "M13 -196q-38 0 -72 11.5t-61 35.5l57 91q12 -11 27.5 -16.5t31.5 -5.5q26 0 45.5 18.5t19.5 47.5v538h134v-528q0 -42 -14 -77.5t-39 -61t-58 -39.5t-71 -14zM-27 629l106 101h97l106 -101l-69 -32l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 669,
    d: "M304 -213l27 72h-39v94h113v-94l-40 -72h-61zM74 0v709h138v-337l298 338h152l-272 -315l289 -395h-155l-221 307l-91 -95v-212h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 558,
    d: "M241 -213l27 72h-39v94h113v-94l-40 -72h-61zM419 0l-152 227l-72 -71v-156h-134v730h134v-443l210 236h143l-195 -222l209 -301h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 558,
    d: "M419 0l-152 227l-72 -71v-156h-134v524h134v-237l210 236h143l-195 -222l209 -301h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 584,
    d: "M393 770l-86 26l54 119h125zM74 0v710h138v-589h362v-121h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 317,
    d: "M158 764l-86 26l54 119h125zM60 730h134v-562q0 -29 14 -45t40 -16q12 0 26.5 4t27.5 10l18 -102q-27 -13 -63 -20t-65 -7q-63 0 -97.5 33.5t-34.5 95.5v609z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 584,
    d: "M288 -213l27 72h-39v94h113v-94l-40 -72h-61zM74 0v710h138v-589h362v-121h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 317,
    d: "M142 -213l27 72h-39v94h113v-94l-40 -72h-61zM60 730h134v-562q0 -29 14 -45t40 -16q12 0 26.5 4t27.5 10l18 -102q-27 -13 -63 -20t-65 -7q-63 0 -97.5 33.5t-34.5 95.5v609z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 584,
    d: "M413 585l-86 26l54 119h125zM74 0v710h138v-589h362v-121h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 317,
    d: "M320 585l-86 26l54 119h125zM60 730h134v-562q0 -29 14 -45t40 -16q12 0 26.5 4t27.5 10l18 -102q-27 -13 -63 -20t-65 -7q-63 0 -97.5 33.5t-34.5 95.5v609z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 584,
    d: "M74 0v710h138v-589h362v-121h-500zM365 331v151h110v-151h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 397,
    d: "M60 730h134v-562q0 -29 14 -45t40 -16q12 0 26.5 4t27.5 10l18 -102q-27 -13 -63 -20t-65 -7q-63 0 -97.5 33.5t-34.5 95.5v609zM270 283v151h110v-151h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 594,
    d: "M83 0v275l-52 -33l-33 73l85 53v342h138v-255l110 70l33 -73l-143 -90v-241h362v-121h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 344,
    d: "M84 299l-51 -30l-34 72l85 51v338h134v-258l86 52l34 -72l-120 -72v-212q0 -29 14 -45t40 -16q12 0 26.5 4t27.5 10l18 -102q-27 -13 -63 -20t-65 -7q-63 0 -97.5 33.5t-34.5 95.5v178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 763,
    d: "M416 770l-86 26l54 119h125zM212 455v-455h-138v710h107l370 -466v465h138v-709h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 604,
    d: "M351 585l-86 26l54 119h125zM548 0h-134v294q0 63 -22 92t-61 29q-20 0 -41 -8t-39.5 -22.5t-33.5 -34.5t-22 -44v-306h-134v524h121v-97q29 50 84 78t124 28q49 0 80 -18t48 -47t23.5 -66t6.5 -75v-327z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 763,
    d: "M333 -213l27 72h-39v94h113v-94l-40 -72h-61zM212 455v-455h-138v710h107l370 -466v465h138v-709h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 604,
    d: "M253 -213l27 72h-39v94h113v-94l-40 -72h-61zM548 0h-134v294q0 63 -22 92t-61 29q-20 0 -41 -8t-39.5 -22.5t-33.5 -34.5t-22 -44v-306h-134v524h121v-97q29 50 84 78t124 28q49 0 80 -18t48 -47t23.5 -66t6.5 -75v-327z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 763,
    d: "M297 915l85 -63l85 63l69 -32l-106 -101h-97l-106 101zM212 455v-455h-138v710h107l370 -466v465h138v-709h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 604,
    d: "M232 730l85 -63l85 63l69 -32l-106 -101h-97l-106 101zM548 0h-134v294q0 63 -22 92t-61 29q-20 0 -41 -8t-39.5 -22.5t-33.5 -34.5t-22 -44v-306h-134v524h121v-97q29 50 84 78t124 28q49 0 80 -18t48 -47t23.5 -66t6.5 -75v-327z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 604,
    d: "M62 585l-86 26l35 73l-7 46h151zM548 0h-134v294q0 63 -22 92t-61 29q-20 0 -41 -8t-39.5 -22.5t-33.5 -34.5t-22 -44v-306h-134v524h121v-97q29 50 84 78t124 28q49 0 80 -18t48 -47t23.5 -66t6.5 -75v-327z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 750,
    d: "M212 451v-451h-138v710h106l358 -460v459h137v-718q0 -42 -14.5 -76.5t-39.5 -59t-58 -38t-70 -13.5q-38 0 -72 11.5t-61 35.5l58 91q11 -11 26.5 -16.5t31.5 -5.5q26 0 45.5 18.5t19.5 47.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 604,
    d: "M366 -196q-38 0 -72 11.5t-61 35.5l57 91q12 -11 27.5 -16.5t31.5 -5.5q26 0 45.5 18.5t19.5 47.5v308q0 63 -22 92t-61 29q-20 0 -41 -8t-39.5 -22.5t-33.5 -34.5t-22 -44v-306h-134v524h121v-97q29 50 84 78t124 28q49 0 79.5 -18t48 -47t23.5 -66t6 -75v-331 q0 -42 -14 -77.5t-39 -61t-58 -39.5t-70 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 756,
    d: "M231 818v83h300v-83h-300zM377 -5q-78 0 -141.5 30.5t-109 81t-70.5 115.5t-25 133q0 71 26.5 136t73 115t110.5 79.5t139 29.5q77 0 140.5 -31.5t108.5 -82.5t70 -116t25 -132q0 -71 -26 -135.5t-72 -114t-110 -79t-139 -29.5zM171 355q0 -46 14 -89t40.5 -76t65 -53 t87.5 -20q50 0 88.5 20.5t65 54.5t40 76.5t13.5 86.5q0 46 -14.5 89t-41 76t-65 52.5t-86.5 19.5q-50 0 -89 -20.5t-65 -54t-39.5 -76t-13.5 -86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 606,
    d: "M154 633v83h300v-83h-300zM303 -10q-64 0 -115 22t-86.5 59.5t-54.5 86.5t-19 103q0 55 19 104t54.5 86.5t86.5 59.5t115 22t114.5 -22t86 -59.5t54.5 -86.5t19 -104q0 -54 -19 -103t-54 -86.5t-86 -59.5t-115 -22zM166 261q0 -35 10.5 -63.5t29 -49.5t43.5 -32.5 t54 -11.5t54 11.5t43.5 32.5t29 50t10.5 64q0 34 -10.5 63t-29 50t-43.5 32.5t-54 11.5t-54 -12t-43.5 -33t-29 -50t-10.5 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 756,
    d: "M377 -5q-78 0 -141.5 30.5t-109 81t-70.5 115.5t-25 133q0 71 26.5 136t73 115t110.5 79.5t139 29.5q77 0 140.5 -31.5t108.5 -82.5t70 -116t25 -132q0 -71 -26 -135.5t-72 -114t-110 -79t-139 -29.5zM171 355q0 -46 14 -89t40.5 -76t65 -53t87.5 -20q50 0 88.5 20.5 t65 54.5t40 76.5t13.5 86.5q0 46 -14.5 89t-41 76t-65 52.5t-86.5 19.5q-50 0 -89 -20.5t-65 -54t-39.5 -76t-13.5 -86.5zM381 841q23 0 40 21t20 53h71q0 -29 -10 -53.5t-27 -42.5t-41.5 -28t-52.5 -10q-29 0 -53 10t-41 28t-27 42.5t-10 53.5h72q0 -30 18 -52t41 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 606,
    d: "M303 -10q-64 0 -115 22t-86.5 59.5t-54.5 86.5t-19 103q0 55 19 104t54.5 86.5t86.5 59.5t115 22t114.5 -22t86 -59.5t54.5 -86.5t19 -104q0 -54 -19 -103t-54 -86.5t-86 -59.5t-115 -22zM166 261q0 -35 10.5 -63.5t29 -49.5t43.5 -32.5t54 -11.5t54 11.5t43.5 32.5 t29 50t10.5 64q0 34 -10.5 63t-29 50t-43.5 32.5t-54 11.5t-54 -12t-43.5 -33t-29 -50t-10.5 -63zM302 656q23 0 40 21t20 53h71q0 -29 -10 -53.5t-27 -42.5t-41.5 -28t-52.5 -10q-29 0 -53 10t-41 28t-27 42.5t-10 53.5h72q0 -30 18 -52t41 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 756,
    d: "M318 771l-66 26l48 119h104zM478 771l-65 26l47 119h105zM377 -5q-78 0 -141.5 30.5t-109 81t-70.5 115.5t-25 133q0 71 26.5 136t73 115t110.5 79.5t139 29.5q77 0 140.5 -31.5t108.5 -82.5t70 -116t25 -132q0 -71 -26 -135.5t-72 -114t-110 -79t-139 -29.5zM171 355 q0 -46 14 -89t40.5 -76t65 -53t87.5 -20q50 0 88.5 20.5t65 54.5t40 76.5t13.5 86.5q0 46 -14.5 89t-41 76t-65 52.5t-86.5 19.5q-50 0 -89 -20.5t-65 -54t-39.5 -76t-13.5 -86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 606,
    d: "M240 585l-66 26l48 119h104zM400 585l-65 26l47 119h105zM303 -10q-64 0 -115 22t-86.5 59.5t-54.5 86.5t-19 103q0 55 19 104t54.5 86.5t86.5 59.5t115 22t114.5 -22t86 -59.5t54.5 -86.5t19 -104q0 -54 -19 -103t-54 -86.5t-86 -59.5t-115 -22zM166 261 q0 -35 10.5 -63.5t29 -49.5t43.5 -32.5t54 -11.5t54 11.5t43.5 32.5t29 50t10.5 64q0 34 -10.5 63t-29 50t-43.5 32.5t-54 11.5t-54 -12t-43.5 -33t-29 -50t-10.5 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1085,
    d: "M1052 121v-121h-480v105q-34 -48 -87 -79t-117 -31q-75 0 -137.5 30.5t-106.5 81t-68.5 115.5t-24.5 133q0 71 25.5 136t71 115t107.5 79.5t135 29.5q66 0 117.5 -31t84.5 -78v104h471v-121h-333v-167h279v-121h-279v-180h342zM369 117q48 0 85 20.5t61.5 54.5t37.5 77 t13 87q0 46 -13.5 88.5t-39 75.5t-62 53t-82.5 20q-48 0 -85 -20.5t-62 -54.5t-38 -76.5t-13 -86.5q0 -46 13.5 -89t39 -76t62 -53t83.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 1011,
    d: "M301 -10q-59 0 -109 20.5t-86.5 56.5t-57 85.5t-20.5 108.5t20.5 109t57 86t86.5 56.5t109 20.5q68 0 120 -31.5t87 -90.5q75 122 210 122q58 0 107.5 -19.5t85.5 -55.5t56.5 -86t22.5 -110q0 -11 -0.5 -23t-2.5 -20h-404q2 -29 14 -53.5t31 -42.5t44 -28t54 -10 q42 0 77.5 21t48.5 53l111 -32q-15 -32 -39.5 -57t-56 -43t-69 -27.5t-77.5 -9.5q-63 0 -115 30t-97 88q-46 -60 -95.5 -89t-112.5 -29zM303 104q30 0 55 12t43 33t28.5 49.5t10.5 62.5t-10.5 63t-28.5 50t-43 33t-55 12q-29 0 -54 -12t-43.5 -33.5t-29 -50.5t-10.5 -63 t10.5 -62.5t28.5 -49.5t43 -32.5t55 -11.5zM853 302q-3 30 -14.5 54.5t-30 42.5t-43 27.5t-51.5 9.5q-56 0 -93.5 -37t-41.5 -97h274z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 665,
    d: "M354 771l-86 26l54 119h125zM74 0v710h314q49 0 90.5 -20.5t71.5 -54t47 -76t17 -85.5q0 -69 -34.5 -125.5t-93.5 -81.5l162 -267h-155l-145 238h-136v-238h-138zM212 359h173q19 0 35.5 9t28.5 24.5t19 36.5t7 45q0 25 -8 46t-21.5 36.5t-31 24t-35.5 8.5h-167v-230z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 387,
    d: "M267 585l-86 26l54 119h125zM373 408q-61 -1 -109 -23.5t-69 -67.5v-317h-134v524h123v-112q14 27 33 48.5t41 37.5t44.5 24.5t43.5 8.5h16.5t10.5 -1v-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 665,
    d: "M294 -213l27 72h-39v94h113v-94l-40 -72h-61zM74 0v710h314q49 0 90.5 -20.5t71.5 -54t47 -76t17 -85.5q0 -69 -34.5 -125.5t-93.5 -81.5l162 -267h-155l-145 238h-136v-238h-138zM212 359h173q19 0 35.5 9t28.5 24.5t19 36.5t7 45q0 25 -8 46t-21.5 36.5t-31 24 t-35.5 8.5h-167v-230z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 387,
    d: "M75 -213l27 72h-39v94h113v-94l-40 -72h-61zM373 408q-61 -1 -109 -23.5t-69 -67.5v-317h-134v524h123v-112q14 27 33 48.5t41 37.5t44.5 24.5t43.5 8.5h16.5t10.5 -1v-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 665,
    d: "M234 916l85 -63l85 63l69 -32l-106 -101h-97l-106 101zM74 0v710h314q49 0 90.5 -20.5t71.5 -54t47 -76t17 -85.5q0 -69 -34.5 -125.5t-93.5 -81.5l162 -267h-155l-145 238h-136v-238h-138zM212 359h173q19 0 35.5 9t28.5 24.5t19 36.5t7 45q0 25 -8 46t-21.5 36.5 t-31 24t-35.5 8.5h-167v-230z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 387,
    d: "M148 730l85 -63l85 63l69 -32l-106 -101h-97l-106 101zM373 408q-61 -1 -109 -23.5t-69 -67.5v-317h-134v524h123v-112q14 27 33 48.5t41 37.5t44.5 24.5t43.5 8.5h16.5t10.5 -1v-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 613,
    d: "M356 778l-86 26l54 119h125zM497 524q-7 7 -25.5 19t-45 23.5t-57.5 19.5t-63 8q-57 0 -85 -21t-28 -59q0 -22 10.5 -36.5t30.5 -25.5t50.5 -20t70.5 -19q52 -14 94.5 -30t72 -40t45.5 -57.5t16 -82.5q0 -57 -21.5 -97.5t-58 -65.5t-84 -36.5t-99.5 -11.5q-80 0 -158 24 t-140 68l61 119q9 -9 32.5 -23.5t55.5 -29t71 -24.5t80 -10q114 0 114 73q0 23 -13 39t-37 28t-58 22t-76 22q-51 14 -88.5 30.5t-62.5 39t-37.5 52t-12.5 70.5q0 54 20 96t55.5 70t82.5 42.5t101 14.5q75 0 138 -23.5t110 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 497,
    d: "M280 585l-86 26l54 119h125zM259 -10q-66 0 -129 21t-108 60l50 84q48 -34 93.5 -51.5t90.5 -17.5q40 0 63 15t23 43t-27 41t-88 30q-51 14 -87 27t-58 29.5t-32 38t-10 51.5q0 40 15.5 72t43.5 54.5t65.5 34.5t81.5 12q59 0 110.5 -17t94.5 -55l-54 -81q-40 30 -77.5 44 t-74.5 14q-34 0 -57 -14t-23 -45q0 -14 5.5 -23t17.5 -16t31.5 -13.5t48.5 -13.5q54 -14 92.5 -28t63 -32t36 -41.5t11.5 -56.5q0 -77 -57 -121.5t-155 -44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 613,
    d: "M166 822l106 101h97l106 -101l-69 -32l-85 63l-85 -63zM497 524q-7 7 -25.5 19t-45 23.5t-57.5 19.5t-63 8q-57 0 -85 -21t-28 -59q0 -22 10.5 -36.5t30.5 -25.5t50.5 -20t70.5 -19q52 -14 94.5 -30t72 -40t45.5 -57.5t16 -82.5q0 -57 -21.5 -97.5t-58 -65.5t-84 -36.5 t-99.5 -11.5q-80 0 -158 24t-140 68l61 119q9 -9 32.5 -23.5t55.5 -29t71 -24.5t80 -10q114 0 114 73q0 23 -13 39t-37 28t-58 22t-76 22q-51 14 -88.5 30.5t-62.5 39t-37.5 52t-12.5 70.5q0 54 20 96t55.5 70t82.5 42.5t101 14.5q75 0 138 -23.5t110 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 497,
    d: "M91 629l106 101h97l106 -101l-69 -32l-85 63l-85 -63zM259 -10q-66 0 -129 21t-108 60l50 84q48 -34 93.5 -51.5t90.5 -17.5q40 0 63 15t23 43t-27 41t-88 30q-51 14 -87 27t-58 29.5t-32 38t-10 51.5q0 40 15.5 72t43.5 54.5t65.5 34.5t81.5 12q59 0 110.5 -17t94.5 -55 l-54 -81q-40 30 -77.5 44t-74.5 14q-34 0 -57 -14t-23 -45q0 -14 5.5 -23t17.5 -16t31.5 -13.5t48.5 -13.5q54 -14 92.5 -28t63 -32t36 -41.5t11.5 -56.5q0 -77 -57 -121.5t-155 -44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015E",
    unicode: "\u015E",
    horizAdvX: 613,
    d: "M239 -127q12 -7 37 -13t52 -6q26 0 41 7.5t15 25.5t-14.5 25.5t-37.5 7.5q-21 0 -44.5 -4.5t-35.5 -7.5l43 85q-74 4 -145 27t-128 64l61 119q9 -9 32.5 -23.5t55.5 -29t71 -24.5t80 -10q114 0 114 73q0 23 -13 39t-37 28t-58 22t-76 22q-51 14 -88.5 30.5t-62.5 39 t-37.5 52t-12.5 70.5q0 54 20 96t55.5 70t82.5 42.5t101 14.5q75 0 138 -23.5t110 -55.5l-61 -112q-7 7 -25.5 19t-45 23.5t-57.5 19.5t-63 8q-57 0 -85 -21t-28 -59q0 -22 10.5 -36.5t30.5 -25.5t50.5 -20t70.5 -19q52 -14 94.5 -30t72 -40t45.5 -57.5t16 -82.5 q0 -53 -18.5 -91t-50 -63.5t-73 -39t-88.5 -16.5l-23 -35q7 2 15.5 3t16.5 1q35 0 60 -16.5t25 -53.5q0 -38 -31.5 -63t-96.5 -25q-33 0 -60 6t-47 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015F",
    unicode: "\u015F",
    horizAdvX: 497,
    d: "M179 -127q12 -7 37 -13t52 -6q26 0 41 7.5t15 25.5t-14.5 25.5t-37.5 7.5q-21 0 -44.5 -4.5t-35.5 -7.5l42 83q-60 4 -116 24.5t-96 55.5l50 84q48 -34 93.5 -51.5t90.5 -17.5q40 0 63 15t23 43t-27 41t-88 30q-51 14 -87 27t-58 29.5t-32 38t-10 51.5q0 40 15.5 72 t43.5 54.5t65.5 34.5t81.5 12q59 0 110.5 -17t94.5 -55l-54 -81q-40 30 -77.5 44t-74.5 14q-34 0 -57 -14t-23 -45q0 -14 5.5 -23t17.5 -16t31.5 -13.5t48.5 -13.5q54 -14 92.5 -28t63 -32t36 -41.5t11.5 -56.5q0 -70 -48 -113.5t-132 -50.5l-21 -34q7 2 15.5 3t16.5 1 q35 0 60 -16.5t25 -53.5q0 -38 -31.5 -63t-96.5 -25q-33 0 -60 6t-47 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 613,
    d: "M236 923l85 -63l85 63l69 -32l-106 -101h-97l-106 101zM497 524q-7 7 -25.5 19t-45 23.5t-57.5 19.5t-63 8q-57 0 -85 -21t-28 -59q0 -22 10.5 -36.5t30.5 -25.5t50.5 -20t70.5 -19q52 -14 94.5 -30t72 -40t45.5 -57.5t16 -82.5q0 -57 -21.5 -97.5t-58 -65.5t-84 -36.5 t-99.5 -11.5q-80 0 -158 24t-140 68l61 119q9 -9 32.5 -23.5t55.5 -29t71 -24.5t80 -10q114 0 114 73q0 23 -13 39t-37 28t-58 22t-76 22q-51 14 -88.5 30.5t-62.5 39t-37.5 52t-12.5 70.5q0 54 20 96t55.5 70t82.5 42.5t101 14.5q75 0 138 -23.5t110 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 497,
    d: "M161 730l85 -63l85 63l69 -32l-106 -101h-97l-106 101zM259 -10q-66 0 -129 21t-108 60l50 84q48 -34 93.5 -51.5t90.5 -17.5q40 0 63 15t23 43t-27 41t-88 30q-51 14 -87 27t-58 29.5t-32 38t-10 51.5q0 40 15.5 72t43.5 54.5t65.5 34.5t81.5 12q59 0 110.5 -17 t94.5 -55l-54 -81q-40 30 -77.5 44t-74.5 14q-34 0 -57 -14t-23 -45q0 -14 5.5 -23t17.5 -16t31.5 -13.5t48.5 -13.5q54 -14 92.5 -28t63 -32t36 -41.5t11.5 -56.5q0 -77 -57 -121.5t-155 -44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 618,
    d: "M234 -127q12 -7 37 -13t52 -6q26 0 41 7.5t15 25.5t-14.5 25.5t-37.5 7.5q-21 0 -44.5 -4.5t-35.5 -7.5l47 92h-54v589h-227v121h591v-121h-227v-589h-25l-27 -42q7 2 15.5 3t16.5 1q35 0 60 -16.5t25 -53.5q0 -38 -31.5 -63t-96.5 -25q-33 0 -60 6t-47 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 384,
    d: "M147 -127q12 -7 37 -13t52 -6q26 0 41 7.5t15 25.5t-14.5 25.5t-37.5 7.5q-21 0 -44.5 -4.5t-35.5 -7.5l43 84q-47 6 -79.5 36t-32.5 92v301h-69v103h69v170h134v-170h110v-103h-110v-256q0 -28 14.5 -39.5t35.5 -11.5t41 7t32 12l27 -106q-22 -10 -51.5 -19.5 t-63.5 -14.5l-22 -35q7 2 15.5 3t16.5 1q35 0 60 -16.5t25 -53.5q0 -38 -31.5 -63t-96.5 -25q-33 0 -60 6t-47 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 619,
    d: "M230 915l85 -63l85 63l69 -32l-106 -101h-97l-106 101zM605 589h-227v-589h-137v589h-227v121h591v-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 384,
    d: "M357 585l-86 26l54 119h125zM375 27q-27 -12 -66 -24t-82 -12q-28 0 -52.5 7t-43 22.5t-29.5 40t-11 59.5v301h-69v103h69v170h134v-170h110v-103h-110v-256q0 -28 14.5 -39.5t35.5 -11.5t41 7t32 12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 644,
    d: "M618 589h-227v-210h190v-66h-190v-313h-137v313h-191v66h191v210h-227v121h591v-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 385,
    d: "M376 27q-27 -12 -66 -24t-82 -12q-28 0 -52.5 7t-43 22.5t-29.5 40t-11 59.5v144h-69v80h69v77h-69v103h69v170h134v-170h110v-103h-110v-77h110v-80h-110v-99q0 -28 14.5 -39.5t35.5 -11.5t41 7t32 12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 750,
    d: "M374 117q49 0 82.5 20t54 52t29 73.5t8.5 85.5v362h137v-362q0 -73 -17.5 -137t-55 -112t-96.5 -76t-141 -28q-85 0 -144.5 29.5t-96.5 78t-53.5 112.5t-16.5 133v362h138v-362q0 -45 8.5 -86.5t29 -73.5t53.5 -51.5t81 -19.5zM438 787q-23 0 -40 7t-31.5 15.5t-29 15.5 t-30.5 7q-17 0 -26.5 -7t-14.5 -16t-6 -16.5t-1 -8.5h-74q0 9 6 30.5t19.5 43t36 38t55.5 16.5q23 0 39.5 -7.5t31 -16t29 -16t32.5 -7.5t28.5 7t16 16t7 17t1.5 10h74q0 -7 -6 -28t-20.5 -43t-38 -39.5t-58.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 618,
    d: "M221 -10q-81 0 -123 52t-42 154v328h134v-299q0 -121 87 -121q39 0 75.5 23.5t59.5 71.5v325h134v-370q0 -21 7.5 -30t24.5 -10v-114q-20 -4 -33.5 -5t-24.5 -1q-36 0 -58.5 16.5t-26.5 45.5l-3 42q-35 -54 -90 -81t-121 -27zM364 602q-23 0 -40 7t-31.5 15.5t-29 15.5 t-30.5 7q-17 0 -26.5 -7t-14.5 -16t-6 -16.5t-1 -8.5h-74q0 9 6 30.5t19.5 43t36 38t55.5 16.5q23 0 39.5 -7.5t31 -16t29 -16t32.5 -7.5t28.5 7t16 16t7 17t1.5 10h74q0 -7 -6 -28t-20.5 -43t-38 -39.5t-58.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 750,
    d: "M374 117q49 0 82.5 20t54 52t29 73.5t8.5 85.5v362h137v-362q0 -73 -17.5 -137t-55 -112t-96.5 -76t-141 -28q-85 0 -144.5 29.5t-96.5 78t-53.5 112.5t-16.5 133v362h138v-362q0 -45 8.5 -86.5t29 -73.5t53.5 -51.5t81 -19.5zM226 818v83h300v-83h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 618,
    d: "M221 -10q-81 0 -123 52t-42 154v328h134v-299q0 -121 87 -121q39 0 75.5 23.5t59.5 71.5v325h134v-370q0 -21 7.5 -30t24.5 -10v-114q-20 -4 -33.5 -5t-24.5 -1q-36 0 -58.5 16.5t-26.5 45.5l-3 42q-35 -54 -90 -81t-121 -27zM152 633v83h300v-83h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 750,
    d: "M374 117q49 0 82.5 20t54 52t29 73.5t8.5 85.5v362h137v-362q0 -73 -17.5 -137t-55 -112t-96.5 -76t-141 -28q-85 0 -144.5 29.5t-96.5 78t-53.5 112.5t-16.5 133v362h138v-362q0 -45 8.5 -86.5t29 -73.5t53.5 -51.5t81 -19.5zM375 841q23 0 40 21t20 53h71 q0 -29 -10 -53.5t-27 -42.5t-41.5 -28t-52.5 -10q-29 0 -53 10t-41 28t-27 42.5t-10 53.5h72q0 -30 18 -52t41 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 618,
    d: "M221 -10q-81 0 -123 52t-42 154v328h134v-299q0 -121 87 -121q39 0 75.5 23.5t59.5 71.5v325h134v-370q0 -21 7.5 -30t24.5 -10v-114q-20 -4 -33.5 -5t-24.5 -1q-36 0 -58.5 16.5t-26.5 45.5l-3 42q-35 -54 -90 -81t-121 -27zM300 656q23 0 40 21t20 53h71 q0 -29 -10 -53.5t-27 -42.5t-41.5 -28t-52.5 -10q-29 0 -53 10t-41 28t-27 42.5t-10 53.5h72q0 -30 18 -52t41 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 750,
    d: "M277 838q0 37 26.5 57t70.5 20t70.5 -20t26.5 -57t-26.5 -57t-70.5 -20t-70.5 20t-26.5 57zM374 874q-17 0 -28.5 -9.5t-11.5 -26.5q0 -15 11.5 -25.5t28.5 -10.5q16 0 28.5 10t12.5 26q0 17 -12 26.5t-29 9.5zM374 117q49 0 82.5 20t54 52t29 73.5t8.5 85.5v362h137 v-362q0 -73 -17.5 -137t-55 -112t-96.5 -76t-141 -28q-85 0 -144.5 29.5t-96.5 78t-53.5 112.5t-16.5 133v362h138v-362q0 -45 8.5 -86.5t29 -73.5t53.5 -51.5t81 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 618,
    d: "M203 653q0 37 26.5 57t70.5 20t70.5 -20t26.5 -57t-26.5 -57t-70.5 -20t-70.5 20t-26.5 57zM300 689q-17 0 -28.5 -9.5t-11.5 -26.5q0 -15 11.5 -25.5t28.5 -10.5q16 0 28.5 10t12.5 26q0 17 -12 26.5t-29 9.5zM221 -10q-81 0 -123 52t-42 154v328h134v-299 q0 -121 87 -121q39 0 75.5 23.5t59.5 71.5v325h134v-370q0 -21 7.5 -30t24.5 -10v-114q-20 -4 -33.5 -5t-24.5 -1q-36 0 -58.5 16.5t-26.5 45.5l-3 42q-35 -54 -90 -81t-121 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 750,
    d: "M374 117q49 0 82.5 20t54 52t29 73.5t8.5 85.5v362h137v-362q0 -73 -17.5 -137t-55 -112t-96.5 -76t-141 -28q-85 0 -144.5 29.5t-96.5 78t-53.5 112.5t-16.5 133v362h138v-362q0 -45 8.5 -86.5t29 -73.5t53.5 -51.5t81 -19.5zM311 771l-66 26l48 119h104zM471 771 l-65 26l47 119h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 618,
    d: "M221 -10q-81 0 -123 52t-42 154v328h134v-299q0 -121 87 -121q39 0 75.5 23.5t59.5 71.5v325h134v-370q0 -21 7.5 -30t24.5 -10v-114q-20 -4 -33.5 -5t-24.5 -1q-36 0 -58.5 16.5t-26.5 45.5l-3 42q-35 -54 -90 -81t-121 -27zM237 585l-66 26l48 119h104zM397 585l-65 26 l47 119h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 750,
    d: "M374 117q49 0 82.5 20t54 52t29 73.5t8.5 85.5v362h137v-362q0 -69 -16 -131t-50 -109t-87 -77t-126 -35q-72 -44 -72 -82q0 -37 62 -41l-28 -70q-58 8 -86.5 32t-28.5 55q0 27 19.5 54.5t59.5 53.5q-73 7 -124 38.5t-83 79.5t-46.5 107.5t-14.5 124.5v362h138v-362 q0 -45 8.5 -86.5t29 -73.5t53.5 -51.5t81 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 618,
    d: "M221 -10q-81 0 -123 52t-42 154v328h134v-299q0 -121 87 -121q39 0 75.5 23.5t59.5 71.5v325h134v-370q0 -21 7.5 -30t24.5 -10v-114q-77 -46 -77 -85q0 -37 62 -41l-28 -70q-58 8 -86.5 32t-28.5 55q0 26 18.5 53t56.5 52q-26 5 -41.5 20.5t-18.5 39.5l-3 42 q-35 -54 -90 -81t-121 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 1053,
    d: "M371 814l106 101h97l106 -101l-69 -32l-85 63l-85 -63zM319 708h127l80 -235l80 235h128l-121 -323l90 -227l201 552h150l-289 -710h-116l-123 298l-123 -298h-116l-287 710h148l202 -552l88 227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 839,
    d: "M265 629l106 101h97l106 -101l-69 -32l-85 63l-85 -63zM711 524h127l-219 -524h-110l-90 230l-89 -230h-110l-218 524h126l156 -398l64 170l-92 227h108l55 -161l56 161h108l-91 -227l63 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 660,
    d: "M154 710l175 -342l178 342h149l-258 -462v-248h-137v250l-257 460h150zM175 814l106 101h97l106 -101l-69 -32l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 550,
    d: "M72 -102q17 -5 33 -7.5t27 -2.5q13 0 24 5t20 17.5t18 34.5t19 55l-207 524h138l142 -408l126 408h126l-220 -628q-19 -55 -65 -90t-114 -35q-16 0 -32.5 2.5t-34.5 8.5v116zM132 629l106 101h97l106 -101l-69 -32l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 660,
    d: "M154 710l175 -342l178 342h149l-258 -462v-248h-137v250l-257 460h150zM178 790v119h111v-119h-111zM370 790v119h111v-119h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 627,
    d: "M361 770l-86 26l54 119h125zM30 104l401 485h-390v121h549v-104l-388 -485h391v-121h-563v104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 493,
    d: "M284 585l-86 26l54 119h125zM26 82l292 348h-280v94h421v-82l-290 -348h295v-94h-438v82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 627,
    d: "M30 104l401 485h-390v121h549v-104l-388 -485h391v-121h-563v104zM266 789v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 493,
    d: "M26 82l292 348h-280v94h421v-82l-290 -348h295v-94h-438v82zM189 604v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 627,
    d: "M242 915l85 -63l85 63l69 -32l-106 -101h-97l-106 101zM30 104l401 485h-390v121h549v-104l-388 -485h391v-121h-563v104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 493,
    d: "M165 730l85 -63l85 63l69 -32l-106 -101h-97l-106 101zM26 82l292 348h-280v94h421v-82l-290 -348h295v-94h-438v82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Schwa",
    unicode: "\u018F",
    horizAdvX: 746,
    d: "M369 -5q-78 0 -142.5 30t-110.5 79t-71 112t-25 128q0 34 5 57h539q-5 44 -22 79.5t-43.5 60t-60.5 38t-71 13.5q-29 0 -56 -8t-49.5 -22t-39 -34.5t-23.5 -44.5l-139 47q20 41 51.5 75t71.5 58.5t87.5 38t100.5 13.5q77 0 140 -30t108 -79.5t70 -114t25 -132.5 q0 -72 -24.5 -137.5t-69.5 -116t-109 -80.5t-142 -30zM371 116q39 0 72 13t58.5 36.5t41.5 56t19 71.5h-391q4 -39 20.5 -71.5t43.5 -56t61.5 -36.5t74.5 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 548,
    d: "M162 -196q-37 0 -71.5 11.5t-61.5 35.5l58 91q11 -11 27 -16.5t32 -5.5q26 0 45 18.5t19 47.5v374h-68v103h68v65q0 98 47.5 155t127.5 57q64 0 129 -31l-27 -101q-15 8 -35.5 13.5t-37.5 5.5q-70 0 -70 -94v-70h128v-103h-128v-371q0 -41 -14.5 -75t-39 -58.5t-58 -38 t-70.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C4",
    unicode: "\u01C4",
    horizAdvX: 1343,
    d: "M958 915l85 -63l85 63l69 -32l-106 -101h-97l-106 101zM746 104l401 485h-390v121h549v-104l-388 -485h391v-121h-563v104zM74 0v710h258q87 0 152.5 -28t109.5 -76t66 -112.5t22 -137.5q0 -81 -24.5 -146.5t-70.5 -112t-110.5 -72t-144.5 -25.5h-258zM543 356 q0 51 -14 94t-41 74t-66.5 48t-89.5 17h-120v-468h120q51 0 90.5 18t66 49.5t40.5 74.5t14 93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C5",
    unicode: "\u01C5",
    horizAdvX: 1209,
    d: "M881 730l85 -63l85 63l69 -32l-106 -101h-97l-106 101zM742 82l292 348h-280v94h421v-82l-290 -348h295v-94h-438v82zM74 0v710h258q87 0 152.5 -28t109.5 -76t66 -112.5t22 -137.5q0 -81 -24.5 -146.5t-70.5 -112t-110.5 -72t-144.5 -25.5h-258zM543 356q0 51 -14 94 t-41 74t-66.5 48t-89.5 17h-120v-468h120q51 0 90.5 18t66 49.5t40.5 74.5t14 93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C6",
    unicode: "\u01C6",
    horizAdvX: 1139,
    d: "M810 730l85 -63l85 63l69 -32l-106 -101h-97l-106 101zM671 82l292 348h-280v94h421v-82l-290 -348h295v-94h-438v82zM278 -10q-54 0 -100 21t-79 58t-51.5 86.5t-18.5 106.5t17.5 106t48.5 86t74 58t94 21q58 0 104.5 -28t72.5 -73v298h134v-576q0 -21 7 -30t24 -10 v-114q-35 -7 -57 -7q-36 0 -59 18t-26 47l-3 33q-29 -50 -78.5 -75.5t-103.5 -25.5zM313 104q19 0 39 6.5t37 18.5t30.5 28t20.5 35v125q-8 22 -22.5 40.5t-33 32t-39 21.5t-40.5 8q-30 0 -55.5 -13t-43.5 -35.5t-28 -51.5t-10 -60q0 -33 11 -61t30 -49t45.5 -33t58.5 -12z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C7",
    unicode: "\u01C7",
    horizAdvX: 1075,
    d: "M622 145q14 -10 47 -22t76 -12q42 0 67 14.5t38 44.5t17 74.5t4 104.5v361h138v-361q0 -81 -8.5 -147.5t-36 -113.5t-79.5 -73t-140 -26q-90 0 -154 44zM74 0v710h138v-589h362v-121h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C8",
    unicode: "\u01C8",
    horizAdvX: 845,
    d: "M602 -196q-38 0 -72 11.5t-61 35.5l58 91q11 -11 27 -16.5t32 -5.5q26 0 45 18.5t19 47.5v538h134v-528q0 -42 -14 -77.5t-38.5 -61t-58 -39.5t-71.5 -14zM650 597v133h134v-133h-134zM74 0v710h138v-589h362v-121h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C9",
    unicode: "\u01C9",
    horizAdvX: 578,
    d: "M335 -196q-38 0 -72 11.5t-61 35.5l58 91q11 -11 27 -16.5t32 -5.5q26 0 45 18.5t19 47.5v538h134v-528q0 -42 -14 -77.5t-38.5 -61t-58 -39.5t-71.5 -14zM383 597v133h134v-133h-134zM60 730h134v-562q0 -29 14 -45t40 -16q12 0 26.5 4t27.5 10l18 -102q-27 -13 -63 -20 t-65 -7q-63 0 -97.5 33.5t-34.5 95.5v609z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CA",
    unicode: "\u01CA",
    horizAdvX: 1254,
    d: "M801 145q14 -10 47 -22t76 -12q42 0 67 14.5t38 44.5t17 74.5t4 104.5v361h138v-361q0 -81 -8.5 -147.5t-36 -113.5t-79.5 -73t-140 -26q-90 0 -154 44zM212 455v-455h-138v710h107l370 -466v465h138v-709h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CB",
    unicode: "\u01CB",
    horizAdvX: 1024,
    d: "M781 -196q-38 0 -72 11.5t-61 35.5l58 91q11 -11 27 -16.5t32 -5.5q26 0 45 18.5t19 47.5v538h134v-528q0 -42 -14 -77.5t-38.5 -61t-58 -39.5t-71.5 -14zM829 597v133h134v-133h-134zM212 455v-455h-138v710h107l370 -466v465h138v-709h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CC",
    unicode: "\u01CC",
    horizAdvX: 865,
    d: "M622 -196q-38 0 -72 11.5t-61 35.5l58 91q11 -11 27 -16.5t32 -5.5q26 0 45 18.5t19 47.5v538h134v-528q0 -42 -14 -77.5t-38.5 -61t-58 -39.5t-71.5 -14zM670 597v133h134v-133h-134zM548 0h-134v294q0 63 -22 92t-61 29q-20 0 -41 -8t-39.5 -22.5t-33.5 -34.5t-22 -44 v-306h-134v524h121v-97q29 50 84 78t124 28q49 0 80 -18t48 -47t23.5 -66t6.5 -75v-327z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oogonek",
    unicode: "\u01EA",
    horizAdvX: 756,
    d: "M367 -197q-58 8 -86.5 32t-28.5 55q0 27 19.5 54.5t60.5 53.5q-68 9 -123.5 42t-95 82t-61 109.5t-21.5 123.5q0 71 26.5 136t73 115t110.5 79.5t139 29.5q77 0 140.5 -31.5t108.5 -82.5t70 -116t25 -132t-23.5 -129t-66 -110.5t-101 -79.5t-128.5 -37q-72 -44 -72 -83 q0 -37 62 -41zM171 355q0 -46 14 -89t40.5 -76t65 -53t87.5 -20q50 0 88.5 20.5t65 54.5t40 76.5t13.5 86.5q0 46 -14.5 89t-41 76t-65 52.5t-86.5 19.5q-50 0 -89 -20.5t-65 -54t-39.5 -76t-13.5 -86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oogonek",
    unicode: "\u01EB",
    horizAdvX: 606,
    d: "M327 -199q-58 8 -86.5 32t-28.5 55q0 26 17.5 52t53.5 51q-60 3 -107 26t-80 60t-50.5 84.5t-17.5 99.5q0 55 19 104t54.5 86.5t86.5 59.5t115 22t114.5 -22t86 -59.5t54.5 -86.5t19 -104q0 -47 -14 -90t-40.5 -78t-65 -60.5t-87.5 -35.5q-77 -46 -77 -85q0 -37 62 -41z M166 261q0 -35 10.5 -63.5t29 -49.5t43.5 -32.5t54 -11.5t54 11.5t43.5 32.5t29 50t10.5 64q0 34 -10.5 63t-29 50t-43.5 32.5t-54 11.5t-54 -12t-43.5 -33t-29 -50t-10.5 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F1",
    unicode: "\u01F1",
    horizAdvX: 1332,
    d: "M735 104l401 485h-390v121h549v-104l-388 -485h391v-121h-563v104zM74 0v710h258q87 0 152.5 -28t109.5 -76t66 -112.5t22 -137.5q0 -81 -24.5 -146.5t-70.5 -112t-110.5 -72t-144.5 -25.5h-258zM543 356q0 51 -14 94t-41 74t-66.5 48t-89.5 17h-120v-468h120 q51 0 90.5 18t66 49.5t40.5 74.5t14 93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F2",
    unicode: "\u01F2",
    horizAdvX: 1207,
    d: "M739 82l292 348h-280v94h421v-82l-290 -348h295v-94h-438v82zM74 0v710h258q87 0 152.5 -28t109.5 -76t66 -112.5t22 -137.5q0 -81 -24.5 -146.5t-70.5 -112t-110.5 -72t-144.5 -25.5h-258zM543 356q0 51 -14 94t-41 74t-66.5 48t-89.5 17h-120v-468h120q51 0 90.5 18 t66 49.5t40.5 74.5t14 93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F3",
    unicode: "\u01F3",
    horizAdvX: 1139,
    d: "M671 82l292 348h-280v94h421v-82l-290 -348h295v-94h-438v82zM278 -10q-54 0 -100 21t-79 58t-51.5 86.5t-18.5 106.5t17.5 106t48.5 86t74 58t94 21q58 0 104.5 -28t72.5 -73v298h134v-576q0 -21 7 -30t24 -10v-114q-35 -7 -57 -7q-36 0 -59 18t-26 47l-3 33 q-29 -50 -78.5 -75.5t-103.5 -25.5zM313 104q19 0 39 6.5t37 18.5t30.5 28t20.5 35v125q-8 22 -22.5 40.5t-33 32t-39 21.5t-40.5 8q-30 0 -55.5 -13t-43.5 -35.5t-28 -51.5t-10 -60q0 -33 11 -61t30 -49t45.5 -33t58.5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gacute",
    unicode: "\u01F4",
    horizAdvX: 725,
    d: "M417 770l-86 26l54 119h125zM567 80q-85 -85 -198 -85q-70 0 -131.5 28t-107 77t-72 115.5t-26.5 143.5q0 73 26.5 137.5t73 113t109.5 77t137 28.5q100 0 171.5 -42t107.5 -113l-103 -76q-27 53 -75.5 81t-105.5 28q-45 0 -82.5 -19t-64 -52t-41 -76t-14.5 -91 q0 -50 16 -93.5t44 -75.5t66.5 -50.5t83.5 -18.5q103 0 186 97v50h-143v101h257v-365h-114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gacute",
    unicode: "\u01F5",
    horizAdvX: 634,
    d: "M349 585l-86 26l54 119h125zM265 -3q-53 0 -96 21t-74.5 57.5t-48.5 84.5t-17 102q0 57 18 106t50 86t77 58t99 21q61 0 107 -27.5t76 -73.5v92h117v-499q0 -58 -22 -104t-60.5 -78t-92 -49t-116.5 -17q-86 0 -144.5 28.5t-100.5 80.5l73 71q30 -37 75.5 -58t96.5 -21 q31 0 59.5 8.5t50.5 26.5t34.5 46t12.5 66v66q-26 -45 -73 -69.5t-101 -24.5zM310 104q22 0 42 7t37 19t30 28t20 34v125q-18 46 -56.5 74t-80.5 28q-31 0 -56 -13.5t-43 -36t-27.5 -51.5t-9.5 -60q0 -32 11 -60t30.5 -49t45.5 -33t57 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    horizAdvX: 672,
    d: "M398 808q35 -21 35 -62q0 -37 -27 -58l262 -688h-142l-66 177h-248l-65 -177h-142l262 688q-28 20 -28 58q0 31 19.5 50.5t52.5 24.5l39 97h125zM435 274l-98 279l-102 -279h200zM336 782q-17 0 -28.5 -9.5t-11.5 -26.5q0 -15 11.5 -25.5t28.5 -10.5q16 0 28.5 10 t12.5 26q0 17 -12 26.5t-29 9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    horizAdvX: 574,
    d: "M204 -10q-38 0 -71 12.5t-57 35t-37.5 52.5t-13.5 66q0 37 16.5 68.5t46 53.5t70.5 34.5t90 12.5q35 0 68.5 -6t59.5 -17v30q0 52 -29.5 80t-87.5 28q-42 0 -82 -15t-82 -44l-41 85q101 67 218 67q113 0 175.5 -55.5t62.5 -160.5v-163q0 -21 7.5 -30t24.5 -10v-114 q-34 -7 -59 -7q-38 0 -58.5 17t-25.5 45l-3 29q-35 -46 -85 -70t-107 -24zM242 88q34 0 64.5 12t47.5 32q22 17 22 38v60q-24 9 -52 14.5t-54 5.5q-52 0 -85 -23.5t-33 -59.5q0 -34 26 -56.5t64 -22.5zM307 755l-86 26l54 119h125zM175 653q0 37 26.5 57t70.5 20t70.5 -20 t26.5 -57t-26.5 -57t-70.5 -20t-70.5 20t-26.5 57zM272 689q-17 0 -28.5 -9.5t-11.5 -26.5q0 -15 11.5 -25.5t28.5 -10.5q16 0 28.5 10t12.5 26q0 17 -12 26.5t-29 9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 966,
    d: "M609 770l-86 26l54 119h125zM418 710h505v-121h-333v-167h279v-121h-279v-180h342v-121h-478v177h-228l-105 -177h-146zM444 297v258l-159 -258h159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 937,
    d: "M489 585l-86 26l54 119h125zM204 -10q-38 0 -71 12.5t-57 35t-37.5 52.5t-13.5 66q0 37 16.5 68.5t46 53.5t70.5 34.5t90 12.5q32 0 63 -5t55 -15q1 9 3 22.5t5 21.5q-9 91 -115 91q-42 0 -82 -15t-83 -44l-41 85q103 67 219 67q62 0 108 -19.5t75 -54.5q33 34 80 54 t106 20q64 0 115 -22t86.5 -59t54.5 -86t19 -104q0 -11 -1 -23t-2 -20h-410q5 -62 46.5 -96.5t97.5 -34.5q40 0 75.5 19.5t48.5 51.5l115 -32q-29 -60 -93 -98.5t-151 -38.5q-75 0 -132.5 29.5t-92.5 78.5q-18 -29 -43 -49t-53.5 -33.5t-59 -19.5t-57.5 -6zM242 88 q34 0 64 12t48 32q10 8 16 17.5t6 18.5q-2 4 -4 13t-3 18.5l-2 19t-1 14.5q-22 8 -47.5 12.5t-48.5 4.5q-52 0 -85.5 -23.5t-33.5 -59.5q0 -34 26.5 -56.5t64.5 -22.5zM778 302q-5 60 -43.5 97t-95.5 37t-95 -37t-43 -97h277z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 755,
    d: "M700 710l-74 -106q47 -51 72.5 -116.5t25.5 -134.5q0 -71 -26 -135.5t-72 -114t-110 -79t-139 -29.5q-42 0 -80 9t-72 26l-21 -30h-148l73 104q-47 51 -72.5 116.5t-25.5 134.5q0 71 26.5 136t73 115t110.5 79.5t139 29.5q42 0 79 -9.5t70 -26.5l22 31h149zM585 355 q0 75 -37 137l-251 -359q38 -16 81 -16q50 0 88.5 20.5t65 54.5t40 76.5t13.5 86.5zM171 355q0 -38 9 -73.5t27 -65.5l250 359q-36 17 -79 17q-50 0 -89 -20.5t-65 -54t-39.5 -76t-13.5 -86.5zM412 770l-86 26l54 119h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    horizAdvX: 606,
    d: "M50 -4l58 68q-39 38 -59.5 89t-20.5 108q0 55 19 104t54.5 86.5t86.5 59.5t115 22q42 0 78 -10t66 -27l27 32h76l-56 -67q40 -38 61.5 -89.5t21.5 -110.5q0 -54 -19 -103t-54 -86.5t-86 -59.5t-115 -22q-44 0 -81 10t-68 29l-28 -33h-76zM303 104q29 0 54 11.5t43.5 32.5 t29 50t10.5 64q0 29 -7.5 54.5t-21.5 45.5l-181 -236q33 -22 73 -22zM166 261q0 -57 27 -98l179 236q-31 20 -69 20q-29 0 -54 -12t-43.5 -33t-29 -50t-10.5 -63zM337 585l-86 26l54 119h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adblgrave",
    unicode: "\u0200",
    horizAdvX: 672,
    d: "M276 710h122l270 -710h-142l-66 177h-248l-65 -177h-142zM435 274l-98 279l-102 -279h200zM314 917h105l47 -119l-66 -26zM154 917h104l48 -119l-66 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adblgrave",
    unicode: "\u0201",
    horizAdvX: 574,
    d: "M204 -10q-38 0 -71 12.5t-57 35t-37.5 52.5t-13.5 66q0 37 16.5 68.5t46 53.5t70.5 34.5t90 12.5q35 0 68.5 -6t59.5 -17v30q0 52 -29.5 80t-87.5 28q-42 0 -82 -15t-82 -44l-41 85q101 67 218 67q113 0 175.5 -55.5t62.5 -160.5v-163q0 -21 7.5 -30t24.5 -10v-114 q-34 -7 -59 -7q-38 0 -58.5 17t-25.5 45l-3 29q-35 -46 -85 -70t-107 -24zM242 88q34 0 64.5 12t47.5 32q22 17 22 38v60q-24 9 -52 14.5t-54 5.5q-52 0 -85 -23.5t-33 -59.5q0 -34 26 -56.5t64 -22.5zM256 730h105l47 -119l-66 -26zM96 730h104l48 -119l-66 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ainvertedbreve",
    unicode: "\u0202",
    horizAdvX: 672,
    d: "M276 710h122l270 -710h-142l-66 177h-248l-65 -177h-142zM435 274l-98 279l-102 -279h200zM337 855q-23 0 -41 -22t-18 -52h-72q0 29 10 53.5t27 42.5t41 28t53 10q28 0 52.5 -10t41.5 -28t27 -42.5t10 -53.5h-71q-3 32 -20 53t-40 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ainvertedbreve",
    unicode: "\u0203",
    horizAdvX: 574,
    d: "M204 -10q-38 0 -71 12.5t-57 35t-37.5 52.5t-13.5 66q0 37 16.5 68.5t46 53.5t70.5 34.5t90 12.5q35 0 68.5 -6t59.5 -17v30q0 52 -29.5 80t-87.5 28q-42 0 -82 -15t-82 -44l-41 85q101 67 218 67q113 0 175.5 -55.5t62.5 -160.5v-163q0 -21 7.5 -30t24.5 -10v-114 q-34 -7 -59 -7q-38 0 -58.5 17t-25.5 45l-3 29q-35 -46 -85 -70t-107 -24zM242 88q34 0 64.5 12t47.5 32q22 17 22 38v60q-24 9 -52 14.5t-54 5.5q-52 0 -85 -23.5t-33 -59.5q0 -34 26 -56.5t64 -22.5zM282 670q-23 0 -41 -22t-18 -52h-72q0 29 10 53.5t27 42.5t41 28t53 10 q28 0 52.5 -10t41.5 -28t27 -42.5t10 -53.5h-71q-3 32 -20 53t-40 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edblgrave",
    unicode: "\u0204",
    horizAdvX: 601,
    d: "M299 917h105l47 -119l-66 -26zM139 917h104l48 -119l-66 -26zM567 121v-121h-493v710h484v-121h-346v-171h299v-112h-299v-185h355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edblgrave",
    unicode: "\u0205",
    d: "M285 730h105l47 -119l-66 -26zM125 730h104l48 -119l-66 -26zM304 -10q-63 0 -114 21.5t-87 58.5t-55.5 86t-19.5 103q0 56 19 105.5t55 87t87.5 59.5t115.5 22t114.5 -22t86 -59t54 -86t18.5 -102q0 -13 -0.5 -25t-2.5 -20h-405q3 -31 15 -55t31 -41t43 -26t50 -9 q40 0 75.5 19.5t48.5 51.5l115 -32q-29 -60 -92.5 -98.5t-151.5 -38.5zM440 306q-5 59 -43.5 94.5t-93.5 35.5q-27 0 -50.5 -9.5t-41.5 -26.5t-29.5 -41t-13.5 -53h272z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Einvertedbreve",
    unicode: "\u0206",
    horizAdvX: 601,
    d: "M324 855q-23 0 -41 -22t-18 -52h-72q0 29 10 53.5t27 42.5t41 28t53 10q28 0 52.5 -10t41.5 -28t27 -42.5t10 -53.5h-71q-3 32 -20 53t-40 21zM567 121v-121h-493v710h484v-121h-346v-171h299v-112h-299v-185h355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "einvertedbreve",
    unicode: "\u0207",
    d: "M306 670q-23 0 -41 -22t-18 -52h-72q0 29 10 53.5t27 42.5t41 28t53 10q28 0 52.5 -10t41.5 -28t27 -42.5t10 -53.5h-71q-3 32 -20 53t-40 21zM304 -10q-63 0 -114 21.5t-87 58.5t-55.5 86t-19.5 103q0 56 19 105.5t55 87t87.5 59.5t115.5 22t114.5 -22t86 -59t54 -86 t18.5 -102q0 -13 -0.5 -25t-2.5 -20h-405q3 -31 15 -55t31 -41t43 -26t50 -9q40 0 75.5 19.5t48.5 51.5l115 -32q-29 -60 -92.5 -98.5t-151.5 -38.5zM440 306q-5 59 -43.5 94.5t-93.5 35.5q-27 0 -50.5 -9.5t-41.5 -26.5t-29.5 -41t-13.5 -53h272z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idblgrave",
    unicode: "\u0208",
    horizAdvX: 286,
    d: "M74 0v710h138v-710h-138zM128 917h105l47 -119l-66 -26zM-32 917h104l48 -119l-66 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idblgrave",
    unicode: "\u0209",
    horizAdvX: 255,
    d: "M116 730h105l47 -119l-66 -26zM-44 730h104l48 -119l-66 -26zM61 0v524h134v-524h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iinvertedbreve",
    unicode: "\u020A",
    horizAdvX: 286,
    d: "M74 0v710h138v-710h-138zM141 855q-23 0 -41 -22t-18 -52h-72q0 29 10 53.5t27 42.5t41 28t53 10q28 0 52.5 -10t41.5 -28t27 -42.5t10 -53.5h-71q-3 32 -20 53t-40 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iinvertedbreve",
    unicode: "\u020B",
    horizAdvX: 255,
    d: "M128 670q-23 0 -41 -22t-18 -52h-72q0 29 10 53.5t27 42.5t41 28t53 10q28 0 52.5 -10t41.5 -28t27 -42.5t10 -53.5h-71q-3 32 -20 53t-40 21zM61 0v524h134v-524h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odblgrave",
    unicode: "\u020C",
    horizAdvX: 756,
    d: "M352 917h105l47 -119l-66 -26zM192 917h104l48 -119l-66 -26zM377 -5q-78 0 -141.5 30.5t-109 81t-70.5 115.5t-25 133q0 71 26.5 136t73 115t110.5 79.5t139 29.5q77 0 140.5 -31.5t108.5 -82.5t70 -116t25 -132q0 -71 -26 -135.5t-72 -114t-110 -79t-139 -29.5z M171 355q0 -46 14 -89t40.5 -76t65 -53t87.5 -20q50 0 88.5 20.5t65 54.5t40 76.5t13.5 86.5q0 46 -14.5 89t-41 76t-65 52.5t-86.5 19.5q-50 0 -89 -20.5t-65 -54t-39.5 -76t-13.5 -86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odblgrave",
    unicode: "\u020D",
    horizAdvX: 606,
    d: "M282 730h105l47 -119l-66 -26zM122 730h104l48 -119l-66 -26zM303 -10q-64 0 -115 22t-86.5 59.5t-54.5 86.5t-19 103q0 55 19 104t54.5 86.5t86.5 59.5t115 22t114.5 -22t86 -59.5t54.5 -86.5t19 -104q0 -54 -19 -103t-54 -86.5t-86 -59.5t-115 -22zM166 261 q0 -35 10.5 -63.5t29 -49.5t43.5 -32.5t54 -11.5t54 11.5t43.5 32.5t29 50t10.5 64q0 34 -10.5 63t-29 50t-43.5 32.5t-54 11.5t-54 -12t-43.5 -33t-29 -50t-10.5 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oinvertedbreve",
    unicode: "\u020E",
    horizAdvX: 756,
    d: "M379 855q-23 0 -41 -22t-18 -52h-72q0 29 10 53.5t27 42.5t41 28t53 10q28 0 52.5 -10t41.5 -28t27 -42.5t10 -53.5h-71q-3 32 -20 53t-40 21zM377 -5q-78 0 -141.5 30.5t-109 81t-70.5 115.5t-25 133q0 71 26.5 136t73 115t110.5 79.5t139 29.5q77 0 140.5 -31.5 t108.5 -82.5t70 -116t25 -132q0 -71 -26 -135.5t-72 -114t-110 -79t-139 -29.5zM171 355q0 -46 14 -89t40.5 -76t65 -53t87.5 -20q50 0 88.5 20.5t65 54.5t40 76.5t13.5 86.5q0 46 -14.5 89t-41 76t-65 52.5t-86.5 19.5q-50 0 -89 -20.5t-65 -54t-39.5 -76t-13.5 -86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oinvertedbreve",
    unicode: "\u020F",
    horizAdvX: 606,
    d: "M302 670q-23 0 -41 -22t-18 -52h-72q0 29 10 53.5t27 42.5t41 28t53 10q28 0 52.5 -10t41.5 -28t27 -42.5t10 -53.5h-71q-3 32 -20 53t-40 21zM303 -10q-64 0 -115 22t-86.5 59.5t-54.5 86.5t-19 103q0 55 19 104t54.5 86.5t86.5 59.5t115 22t114.5 -22t86 -59.5 t54.5 -86.5t19 -104q0 -54 -19 -103t-54 -86.5t-86 -59.5t-115 -22zM166 261q0 -35 10.5 -63.5t29 -49.5t43.5 -32.5t54 -11.5t54 11.5t43.5 32.5t29 50t10.5 64q0 34 -10.5 63t-29 50t-43.5 32.5t-54 11.5t-54 -12t-43.5 -33t-29 -50t-10.5 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdblgrave",
    unicode: "\u0210",
    horizAdvX: 665,
    d: "M294 917h105l47 -119l-66 -26zM134 917h104l48 -119l-66 -26zM74 0v710h314q49 0 90.5 -20.5t71.5 -54t47 -76t17 -85.5q0 -69 -34.5 -125.5t-93.5 -81.5l162 -267h-155l-145 238h-136v-238h-138zM212 359h173q19 0 35.5 9t28.5 24.5t19 36.5t7 45q0 25 -8 46t-21.5 36.5 t-31 24t-35.5 8.5h-167v-230z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdblgrave",
    unicode: "\u0211",
    horizAdvX: 387,
    d: "M202 730h105l47 -119l-66 -26zM42 730h104l48 -119l-66 -26zM373 408q-61 -1 -109 -23.5t-69 -67.5v-317h-134v524h123v-112q14 27 33 48.5t41 37.5t44.5 24.5t43.5 8.5h16.5t10.5 -1v-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rinvertedbreve",
    unicode: "\u0212",
    horizAdvX: 665,
    d: "M322 855q-23 0 -41 -22t-18 -52h-72q0 29 10 53.5t27 42.5t41 28t53 10q28 0 52.5 -10t41.5 -28t27 -42.5t10 -53.5h-71q-3 32 -20 53t-40 21zM74 0v710h314q49 0 90.5 -20.5t71.5 -54t47 -76t17 -85.5q0 -69 -34.5 -125.5t-93.5 -81.5l162 -267h-155l-145 238h-136v-238 h-138zM212 359h173q19 0 35.5 9t28.5 24.5t19 36.5t7 45q0 25 -8 46t-21.5 36.5t-31 24t-35.5 8.5h-167v-230z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rinvertedbreve",
    unicode: "\u0213",
    horizAdvX: 387,
    d: "M215 670q-23 0 -41 -22t-18 -52h-72q0 29 10 53.5t27 42.5t41 28t53 10q28 0 52.5 -10t41.5 -28t27 -42.5t10 -53.5h-71q-3 32 -20 53t-40 21zM373 408q-61 -1 -109 -23.5t-69 -67.5v-317h-134v524h123v-112q14 27 33 48.5t41 37.5t44.5 24.5t43.5 8.5h16.5t10.5 -1v-122 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udblgrave",
    unicode: "\u0214",
    horizAdvX: 750,
    d: "M352 917h105l47 -119l-66 -26zM192 917h104l48 -119l-66 -26zM374 117q49 0 82.5 20t54 52t29 73.5t8.5 85.5v362h137v-362q0 -73 -17.5 -137t-55 -112t-96.5 -76t-141 -28q-85 0 -144.5 29.5t-96.5 78t-53.5 112.5t-16.5 133v362h138v-362q0 -45 8.5 -86.5t29 -73.5 t53.5 -51.5t81 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udblgrave",
    unicode: "\u0215",
    horizAdvX: 618,
    d: "M283 730h105l47 -119l-66 -26zM123 730h104l48 -119l-66 -26zM221 -10q-81 0 -123 52t-42 154v328h134v-299q0 -121 87 -121q39 0 75.5 23.5t59.5 71.5v325h134v-370q0 -21 7.5 -30t24.5 -10v-114q-20 -4 -33.5 -5t-24.5 -1q-36 0 -58.5 16.5t-26.5 45.5l-3 42 q-35 -54 -90 -81t-121 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uinvertedbreve",
    unicode: "\u0216",
    horizAdvX: 750,
    d: "M374 855q-23 0 -41 -22t-18 -52h-72q0 29 10 53.5t27 42.5t41 28t53 10q28 0 52.5 -10t41.5 -28t27 -42.5t10 -53.5h-71q-3 32 -20 53t-40 21zM374 117q49 0 82.5 20t54 52t29 73.5t8.5 85.5v362h137v-362q0 -73 -17.5 -137t-55 -112t-96.5 -76t-141 -28 q-85 0 -144.5 29.5t-96.5 78t-53.5 112.5t-16.5 133v362h138v-362q0 -45 8.5 -86.5t29 -73.5t53.5 -51.5t81 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uinvertedbreve",
    unicode: "\u0217",
    horizAdvX: 618,
    d: "M298 670q-23 0 -41 -22t-18 -52h-72q0 29 10 53.5t27 42.5t41 28t53 10q28 0 52.5 -10t41.5 -28t27 -42.5t10 -53.5h-71q-3 32 -20 53t-40 21zM221 -10q-81 0 -123 52t-42 154v328h134v-299q0 -121 87 -121q39 0 75.5 23.5t59.5 71.5v325h134v-370q0 -21 7.5 -30 t24.5 -10v-114q-20 -4 -33.5 -5t-24.5 -1q-36 0 -58.5 16.5t-26.5 45.5l-3 42q-35 -54 -90 -81t-121 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 613,
    d: "M275 -213l27 72h-39v94h113v-94l-40 -72h-61zM497 524q-7 7 -25.5 19t-45 23.5t-57.5 19.5t-63 8q-57 0 -85 -21t-28 -59q0 -22 10.5 -36.5t30.5 -25.5t50.5 -20t70.5 -19q52 -14 94.5 -30t72 -40t45.5 -57.5t16 -82.5q0 -57 -21.5 -97.5t-58 -65.5t-84 -36.5 t-99.5 -11.5q-80 0 -158 24t-140 68l61 119q9 -9 32.5 -23.5t55.5 -29t71 -24.5t80 -10q114 0 114 73q0 23 -13 39t-37 28t-58 22t-76 22q-51 14 -88.5 30.5t-62.5 39t-37.5 52t-12.5 70.5q0 54 20 96t55.5 70t82.5 42.5t101 14.5q75 0 138 -23.5t110 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 497,
    d: "M211 -213l27 72h-39v94h113v-94l-40 -72h-61zM259 -10q-66 0 -129 21t-108 60l50 84q48 -34 93.5 -51.5t90.5 -17.5q40 0 63 15t23 43t-27 41t-88 30q-51 14 -87 27t-58 29.5t-32 38t-10 51.5q0 40 15.5 72t43.5 54.5t65.5 34.5t81.5 12q59 0 110.5 -17t94.5 -55l-54 -81 q-40 30 -77.5 44t-74.5 14q-34 0 -57 -14t-23 -45q0 -14 5.5 -23t17.5 -16t31.5 -13.5t48.5 -13.5q54 -14 92.5 -28t63 -32t36 -41.5t11.5 -56.5q0 -77 -57 -121.5t-155 -44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 619,
    d: "M267 -213l27 72h-39v94h113v-94l-40 -72h-61zM605 589h-227v-589h-137v589h-227v121h591v-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 384,
    d: "M178 -213l27 72h-39v94h113v-94l-40 -72h-61zM375 27q-27 -12 -66 -24t-82 -12q-28 0 -52.5 7t-43 22.5t-29.5 40t-11 59.5v301h-69v103h69v170h134v-170h110v-103h-110v-256q0 -28 14.5 -39.5t35.5 -11.5t41 7t32 12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 255,
    d: "M13 -196q-38 0 -72 11.5t-61 35.5l57 91q12 -11 27.5 -16.5t31.5 -5.5q26 0 45.5 18.5t19.5 47.5v538h134v-528q0 -42 -14 -77.5t-39 -61t-58 -39.5t-71 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "schwa",
    unicode: "\u0259",
    d: "M297 -10q-64 0 -115 22t-86.5 59t-55 86t-19.5 104q0 11 1 23t2 20h405q-3 31 -15 55t-31 41t-42.5 26t-49.5 9q-41 0 -76.5 -19.5t-48.5 -51.5l-114 32q29 60 92 98.5t151 38.5q63 0 114 -21.5t87 -58.5t55.5 -86t19.5 -104q0 -56 -19 -105.5t-54.5 -86.5t-86 -59 t-114.5 -22zM298 87q55 0 92 37t42 97h-272q2 -30 14 -54.5t30.5 -42.5t42.5 -27.5t51 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "apostrophe",
    unicode: "\u02BC",
    horizAdvX: 532,
    d: "M272 585l-86 26l35 73l-7 46h151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 369,
    d: "M30 629l106 101h97l106 -101l-69 -32l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 369,
    d: "M100 730l85 -63l85 63l69 -32l-106 -101h-97l-106 101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 419,
    d: "M60 633v83h300v-83h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 328,
    d: "M164 656q23 0 40 21t20 53h71q0 -29 -10 -53.5t-27 -42.5t-41.5 -28t-52.5 -10q-29 0 -53 10t-41 28t-27 42.5t-10 53.5h72q0 -30 18 -52t41 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 221,
    d: "M50 604v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 262,
    d: "M34 653q0 37 26.5 57t70.5 20t70.5 -20t26.5 -57t-26.5 -57t-70.5 -20t-70.5 20t-26.5 57zM131 689q-17 0 -28.5 -9.5t-11.5 -26.5q0 -15 11.5 -25.5t28.5 -10.5q16 0 28.5 10t12.5 26q0 17 -12 26.5t-29 9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 290,
    d: "M180 -196q-58 8 -86.5 32t-28.5 55q0 33 29.5 66.5t89.5 63.5l39 -21q-77 -46 -77 -85q0 -37 62 -41l-28 -70v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 437,
    d: "M284 602q-23 0 -40 7t-31.5 15.5t-29 15.5t-30.5 7q-17 0 -26.5 -7t-14.5 -16t-6 -16.5t-1 -8.5h-74q0 9 6 30.5t19.5 43t36 38t55.5 16.5q23 0 39.5 -7.5t31 -16t29 -16t32.5 -7.5t28.5 7t16 16t7 17t1.5 10h74q0 -7 -6 -28t-20.5 -43t-38 -39.5t-58.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 366,
    d: "M99 585l-66 26l48 119h104zM259 585l-65 26l47 119h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030F",
    unicode: "\u030F",
    horizAdvX: 366,
    d: "M180 730h105l47 -119l-66 -26zM20 730h104l48 -119l-66 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0311",
    unicode: "\u0311",
    horizAdvX: 328,
    d: "M164 670q-23 0 -41 -22t-18 -52h-72q0 29 10 53.5t27 42.5t41 28t53 10q28 0 52.5 -10t41.5 -28t27 -42.5t10 -53.5h-71q-3 32 -20 53t-40 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0394",
    unicode: "\u0394",
    horizAdvX: 652,
    d: "M633 104v-104h-615v104l253 606h112zM497 121l-170 436l-168 -436h338z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03A9",
    unicode: "\u03A9",
    horizAdvX: 774,
    d: "M38 102h165q-72 41 -113.5 110.5t-41.5 157.5q0 68 25.5 130.5t71 110t107.5 76t135 28.5t135 -28.5t107.5 -76t71.5 -110t26 -130.5q0 -88 -42 -157.5t-114 -110.5h166v-102h-307v102q37 13 66.5 41t50.5 64t32.5 78.5t11.5 84.5q0 41 -14 81t-40.5 71.5t-64.5 50.5 t-85 19t-85 -19t-64 -50.5t-40 -71.5t-14 -81q0 -42 11 -84.5t32 -78.5t51 -64t67 -41v-102h-307v102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03BC",
    unicode: "\u03BC",
    horizAdvX: 628,
    d: "M61 524h134v-299q0 -121 90 -121q37 0 73.5 23.5t59.5 71.5v325h134v-370q0 -21 8 -30t28 -10v-114q-21 -4 -36 -5t-27 -1q-37 0 -60 18t-25 48l-2 38q-9 -18 -25.5 -37t-38 -35t-47 -26t-51.5 -10q-20 0 -35 6t-26 14.5t-18.5 19t-10.5 19.5l9 -261h-134v736z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 642,
    d: "M233 406v-406h-132v406h-75v116h567v-116h-96v-238q0 -61 54 -61q12 0 26.5 4t26.5 10l19 -102q-28 -13 -63.5 -20t-65.5 -7q-61 0 -95.5 33.5t-34.5 95.5v285h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0400",
    unicode: "\u0400",
    horizAdvX: 604,
    d: "M570 121v-121h-493v710h484v-121h-346v-171h299v-112h-299v-185h355zM201 916h124l55 -119l-86 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0401",
    unicode: "\u0401",
    horizAdvX: 604,
    d: "M177 790v119h111v-119h-111zM369 790v119h111v-119h-111zM570 121v-121h-493v710h484v-121h-346v-171h299v-112h-299v-185h355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0402",
    unicode: "\u0402",
    horizAdvX: 735,
    d: "M170 592h-156v118h565v-118h-274v-192q34 28 78.5 43t95.5 15q112 0 175.5 -63t63.5 -174q0 -110 -59 -170.5t-171 -60.5q-65 0 -125 22l37 113q45 -21 80 -21q47 0 73.5 28t26.5 89q0 121 -113 121q-89 0 -162 -66v-276h-135v592z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0403",
    unicode: "\u0403",
    horizAdvX: 523,
    d: "M327 770l-86 26l54 119h125zM510 589h-296v-589h-137v710h433v-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0404",
    unicode: "\u0404",
    horizAdvX: 698,
    d: "M679 159q-17 -40 -47.5 -70.5t-70.5 -51.5t-86 -32t-94 -11q-79 0 -143.5 32t-110 83.5t-70.5 117t-25 133.5q0 65 23.5 128.5t68.5 113.5t111 81t152 31q104 0 175 -43t106 -112l-106 -73q-14 30 -34.5 50.5t-44.5 32.5t-50 17.5t-50 5.5q-45 0 -80 -14.5t-60 -38.5 t-40.5 -55.5t-22.5 -65.5h284v-111h-288q6 -39 23.5 -74t44.5 -61t62.5 -41t78.5 -15q25 0 51.5 6t51 19t45 33.5t33.5 49.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0405",
    unicode: "\u0405",
    horizAdvX: 613,
    d: "M497 524q-7 7 -25.5 19t-45 23.5t-57.5 19.5t-63 8q-57 0 -85 -21t-28 -59q0 -22 10.5 -36.5t30.5 -25.5t50.5 -20t70.5 -19q52 -14 94.5 -30t72 -40t45.5 -57.5t16 -82.5q0 -57 -21.5 -97.5t-58 -65.5t-84 -36.5t-99.5 -11.5q-80 0 -158 24t-140 68l61 119 q9 -9 32.5 -23.5t55.5 -29t71 -24.5t80 -10q114 0 114 73q0 23 -13 39t-37 28t-58 22t-76 22q-51 14 -88.5 30.5t-62.5 39t-37.5 52t-12.5 70.5q0 54 20 96t55.5 70t82.5 42.5t101 14.5q75 0 138 -23.5t110 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0406",
    unicode: "\u0406",
    horizAdvX: 292,
    d: "M77 0v710h138v-710h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0407",
    unicode: "\u0407",
    horizAdvX: 292,
    d: "M77 0v710h138v-710h-138zM-6 790v119h111v-119h-111zM186 790v119h111v-119h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0408",
    unicode: "\u0408",
    horizAdvX: 493,
    d: "M38 145q14 -10 47 -22t76 -12q42 0 67 14.5t38 44.5t17 74.5t4 104.5v361h138v-361q0 -81 -8.5 -147.5t-36 -113.5t-79.5 -73t-140 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0409",
    unicode: "\u0409",
    horizAdvX: 1044,
    d: "M10 117q34 3 59.5 17t44 55t31.5 117.5t24 203.5l17 200h430v-275h174q51 0 93 -14.5t73 -42t48 -67.5t17 -92q0 -53 -17 -93.5t-47 -68.5t-71.5 -42.5t-90.5 -14.5h-316v589h-168l-9 -108q-11 -136 -30 -229.5t-52 -151t-82 -82.5t-120 -25zM782 117q49 0 74 27.5 t25 75.5q0 46 -25 74.5t-74 28.5h-166v-206h166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040A",
    unicode: "\u040A",
    horizAdvX: 1074,
    d: "M77 710h137v-278h295v278h137v-275h174q51 0 93 -14.5t73 -42t48 -67.5t17 -92q0 -53 -17 -93.5t-47 -68.5t-71.5 -42.5t-90.5 -14.5h-316v311h-295v-311h-137v710zM812 117q48 0 73.5 25t25.5 74q0 47 -25.5 72.5t-73.5 25.5h-166v-197h166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040B",
    unicode: "\u040B",
    horizAdvX: 734,
    d: "M564 192q0 72 -26 105.5t-87 33.5q-42 0 -79 -13t-67 -36v-282h-135v592h-156v118h556v-118h-265v-181q34 22 79 34t96 12q50 0 90.5 -13t69 -39.5t44 -67.5t15.5 -96v-241h-135v192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040C",
    unicode: "\u040C",
    horizAdvX: 653,
    d: "M372 770l-86 26l54 119h125zM214 418h56l216 292h156l-255 -343l278 -367h-154l-228 294h-69v-294h-137v710h137v-292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040D",
    unicode: "\u040D",
    horizAdvX: 744,
    d: "M262 916h124l55 -119l-86 -26zM214 212l362 498h105v-710h-137v487l-357 -487h-110v710h137v-498z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040E",
    unicode: "\u040E",
    horizAdvX: 636,
    d: "M192 -7q-11 0 -24 1.5t-27 4.5t-27.5 8t-23.5 12l18 114q11 -6 31 -13.5t40 -7.5q29 0 50.5 16.5t37.5 59.5l-261 522h149l174 -383l162 383h145l-250 -540q-22 -48 -43 -81.5t-43.5 -55t-48.5 -31t-59 -9.5zM327 779q-39 0 -72 9.5t-56 27.5t-36.5 43.5t-13.5 56.5h82 q0 -13 7.5 -25t21 -21t30.5 -14t37 -5q38 0 64.5 18.5t31.5 46.5h81q0 -31 -13.5 -56.5t-36.5 -43.5t-55.5 -27.5t-71.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040F",
    unicode: "\u040F",
    horizAdvX: 711,
    d: "M77 710h138v-589h281v589h137v-710h-213v-176h-131v176h-212v710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0410",
    unicode: "\u0410",
    horizAdvX: 672,
    d: "M276 710h122l270 -710h-142l-66 177h-248l-65 -177h-142zM435 274l-98 279l-102 -279h200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0411",
    unicode: "\u0411",
    horizAdvX: 668,
    d: "M77 710h519v-121h-382v-163h196q52 0 94.5 -14t73 -41t47 -66t16.5 -90q0 -104 -61.5 -159.5t-164.5 -55.5h-338v710zM402 117q49 0 74 26.5t25 72.5q0 44 -25 71t-74 27h-188v-197h188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0412",
    unicode: "\u0412",
    horizAdvX: 682,
    d: "M638 183q0 -45 -18 -79t-49.5 -57t-73 -35t-88.5 -12h-343v710h380q37 0 67 -16t51 -41.5t32.5 -58t11.5 -65.5q0 -52 -26 -97.5t-76 -67.5q61 -18 96.5 -64.5t35.5 -116.5zM499 209q0 19 -6.5 36.5t-17.5 30.5t-26 20.5t-33 7.5h-212v-187h205q19 0 35.5 7t28.5 19.5 t19 29.5t7 36zM204 592v-179h184q35 0 59.5 24t24.5 66q0 41 -22.5 65t-55.5 24h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0413",
    unicode: "\u0413",
    horizAdvX: 523,
    d: "M510 589h-296v-589h-137v710h433v-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0414",
    unicode: "\u0414",
    horizAdvX: 757,
    d: "M17 121h25q29 1 51 17t39 59t30 118.5t24 194.5l18 200h430v-589h105v-298h-129v177h-463v-177h-130v298zM496 121v468h-167l-10 -108q-12 -139 -33.5 -226t-55.5 -134h266z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0415",
    unicode: "\u0415",
    horizAdvX: 604,
    d: "M570 121v-121h-493v710h484v-121h-346v-171h299v-112h-299v-185h355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0416",
    unicode: "\u0416",
    horizAdvX: 1010,
    d: "M247 367l-233 343h155l192 -292h73v292h143v-292h72l192 292h156l-233 -343l256 -367h-155l-200 294h-88v-294h-143v294h-88l-201 -294h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0417",
    unicode: "\u0417",
    horizAdvX: 549,
    d: "M33 619q43 48 99 72.5t134 24.5q102 0 161.5 -45t59.5 -132q0 -54 -26.5 -97.5t-83.5 -61.5q66 -13 102 -58.5t36 -112.5q0 -50 -19.5 -89.5t-53.5 -67t-81.5 -42.5t-102.5 -15q-77 0 -136 25.5t-105 76.5l80 96q30 -35 67.5 -55t90.5 -20t87 28t34 78q0 46 -35.5 76 t-107.5 30h-74v102h66q64 0 98 23.5t34 66.5q0 38 -25.5 58t-72.5 20t-83.5 -17.5t-64.5 -49.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0418",
    unicode: "\u0418",
    horizAdvX: 758,
    d: "M214 212l362 498h105v-710h-137v487l-357 -487h-110v710h137v-498z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0419",
    unicode: "\u0419",
    horizAdvX: 758,
    d: "M573 916q0 -31 -13.5 -56.5t-36.5 -43.5t-55.5 -27.5t-71.5 -9.5t-72 9.5t-56 27.5t-36.5 43.5t-13.5 56.5h82q0 -13 7.5 -25t21 -21t30.5 -14t37 -5q38 0 64 18.5t31 46.5h82zM214 212l362 498h105v-710h-137v487l-357 -487h-110v710h137v-498z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041A",
    unicode: "\u041A",
    horizAdvX: 653,
    d: "M214 418h56l216 292h156l-255 -343l278 -367h-154l-228 294h-69v-294h-137v710h137v-292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041B",
    unicode: "\u041B",
    horizAdvX: 694,
    d: "M302 481q-11 -137 -30 -230t-52 -150.5t-82 -82.5t-120 -25l-8 124q34 3 59.5 17t44 55t31.5 117.5t24 203.5l17 200h430v-710h-137v589h-168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041C",
    unicode: "\u041C",
    horizAdvX: 871,
    d: "M656 0v470l-183 -350h-75l-183 350v-470h-138v710h148l210 -404l212 404h147v-710h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041D",
    unicode: "\u041D",
    horizAdvX: 751,
    d: "M674 710v-710h-137v303h-322v-303h-138v710h138v-287h322v287h137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041E",
    unicode: "\u041E",
    horizAdvX: 756,
    d: "M378 -5q-78 0 -141.5 30.5t-109 81t-70.5 115.5t-25 133q0 71 26.5 136t73 115t110.5 79.5t139 29.5q77 0 140.5 -31.5t108.5 -82.5t70 -116t25 -132q0 -71 -26 -135.5t-72 -114t-110 -79t-139 -29.5zM172 355q0 -46 14 -89t40.5 -76t65 -53t87.5 -20q50 0 88.5 20.5 t65 54.5t40 76.5t13.5 86.5q0 46 -14.5 89t-41 76t-65 52.5t-86.5 19.5q-50 0 -89 -20.5t-65 -54t-39.5 -76t-13.5 -86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041F",
    unicode: "\u041F",
    horizAdvX: 740,
    d: "M77 710h585v-710h-137v589h-311v-589h-137v710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0420",
    unicode: "\u0420",
    horizAdvX: 626,
    d: "M77 0v710h301q49 0 90.5 -20.5t71.5 -54t47 -76t17 -85.5q0 -45 -16 -87.5t-45 -75.5t-70 -53t-90 -20h-168v-238h-138zM215 359h160q38 0 63.5 31t25.5 84q0 27 -8 48.5t-21 36.5t-30.5 22.5t-35.5 7.5h-154v-230z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0421",
    unicode: "\u0421",
    horizAdvX: 686,
    d: "M31 360q0 65 23.5 128.5t68.5 113.5t110 81t148 31q98 0 169.5 -43t106.5 -112l-106 -73q-14 30 -34 50.5t-43 32.5t-48 17.5t-49 5.5q-52 0 -90.5 -21t-64 -54.5t-38.5 -76t-13 -84.5q0 -47 15 -90.5t42.5 -76.5t66 -53t84.5 -20q24 0 50 6t49.5 19t43.5 33.5t32 49.5 l113 -65q-17 -40 -48.5 -70.5t-71 -51.5t-84.5 -32t-88 -11q-76 0 -139 32t-108.5 83.5t-71 117t-25.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0422",
    unicode: "\u0422",
    horizAdvX: 619,
    d: "M605 589h-227v-589h-137v589h-227v121h591v-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0423",
    unicode: "\u0423",
    horizAdvX: 636,
    d: "M192 -7q-11 0 -24 1.5t-27 4.5t-27.5 8t-23.5 12l18 114q11 -6 30.5 -13.5t40.5 -7.5q29 0 50.5 16.5t37.5 59.5l-261 522h149l174 -383l162 383h145l-250 -540q-22 -48 -43 -81.5t-43.5 -55t-48.5 -31t-59 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0424",
    unicode: "\u0424",
    horizAdvX: 783,
    d: "M327 54q-149 15 -225 97.5t-76 211.5q0 128 74.5 212t226.5 101v93h133v-93q149 -17 222.5 -101t73.5 -212q0 -130 -74.5 -211.5t-221.5 -97.5v-89h-133v89zM460 179q83 13 122.5 60.5t39.5 126.5t-39.5 125.5t-122.5 57.5v-370zM327 549q-86 -11 -126.5 -56.5 t-40.5 -126.5q0 -80 40.5 -127t126.5 -60v370z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0425",
    unicode: "\u0425",
    horizAdvX: 646,
    d: "M147 710l177 -264l176 264h149l-253 -360l245 -350h-149l-168 254l-169 -254h-150l245 350l-253 360h150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0426",
    unicode: "\u0426",
    horizAdvX: 753,
    d: "M605 0h-527v710h137v-589h277v589h137v-589h106v-298h-130v177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0427",
    unicode: "\u0427",
    horizAdvX: 635,
    d: "M422 710h136v-710h-136v277q-15 -6 -31 -11t-35 -8.5t-42 -5t-52 -1.5q-63 0 -106 18.5t-69.5 51.5t-38 77.5t-11.5 96.5v215h136v-176q0 -41 6.5 -71t22 -49t40.5 -28t62 -9q41 0 71 7.5t47 18.5v307z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0428",
    unicode: "\u0428",
    horizAdvX: 985,
    d: "M908 710v-710h-831v710h137v-589h210v589h137v-589h210v589h137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0429",
    unicode: "\u0429",
    horizAdvX: 1033,
    d: "M885 0h-807v710h137v-589h209v589h138v-589h209v589h138v-589h105v-298h-129v177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042A",
    unicode: "\u042A",
    horizAdvX: 760,
    d: "M13 710h340v-250h136q54 0 99.5 -15t78.5 -44t51 -71.5t18 -97.5q0 -56 -18 -99t-50.5 -72.5t-77 -45t-97.5 -15.5h-277v594h-203v116zM353 117h128q57 0 86 31t29 85q0 51 -29.5 83.5t-85.5 32.5h-128v-232z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042B",
    unicode: "\u042B",
    horizAdvX: 898,
    d: "M77 710h137v-250h136q54 0 99.5 -15t78.5 -44t51 -71.5t18 -97.5q0 -56 -18 -99t-50.5 -72.5t-77 -45t-96.5 -15.5h-278v710zM683 0v709h138v-709h-138zM214 117h128q58 0 87 31t29 85q0 51 -30 83.5t-86 32.5h-128v-232z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042C",
    unicode: "\u042C",
    horizAdvX: 621,
    d: "M77 710h137v-250h136q54 0 99.5 -15t78.5 -44t51 -71.5t18 -97.5q0 -56 -18 -99t-50.5 -72.5t-77 -45t-96.5 -15.5h-278v710zM214 117h128q58 0 87 31t29 85q0 51 -30 83.5t-86 32.5h-128v-232z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042D",
    unicode: "\u042D",
    horizAdvX: 698,
    d: "M317 -6q-48 0 -94 11t-86 32t-70.5 51.5t-47.5 70.5l113 65q13 -29 33.5 -49.5t45 -33.5t51 -19t51.5 -6q43 0 78.5 15t62 41t44 61t23.5 74h-288v111h285q-7 34 -23 65.5t-41 55.5t-59.5 38.5t-79.5 14.5q-24 0 -50 -5.5t-50 -17.5t-45 -32.5t-34 -50.5l-106 73 q35 69 105.5 112t175.5 43q86 0 152 -31t111 -81t68.5 -113.5t23.5 -128.5q0 -68 -25 -133.5t-71 -117t-110 -83.5t-143 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042E",
    unicode: "\u042E",
    horizAdvX: 1007,
    d: "M642 -5q-65 0 -120 22.5t-97 62.5t-68.5 95.5t-34.5 122.5h-107v-298h-137v710h137v-291h108q9 67 37 121.5t70.5 93.5t97 60t117.5 21q74 0 134.5 -27.5t103.5 -76.5t66.5 -115t23.5 -143q0 -82 -25 -148t-69 -112.5t-104.5 -72t-132.5 -25.5zM459 355q0 -112 48.5 -175 t136.5 -63q46 0 81.5 17t59.5 48.5t36.5 75.5t12.5 97q0 112 -51 174.5t-140 62.5q-45 0 -79 -17t-57.5 -48t-35.5 -74.5t-12 -97.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042F",
    unicode: "\u042F",
    horizAdvX: 660,
    d: "M446 0v263h-113l-160 -263h-152l174 280q-61 25 -98 80t-37 127q0 45 17 85t47 71t71.5 49t90.5 18h297v-710h-137zM446 592h-145q-20 0 -38 -7.5t-32.5 -21t-23 -33t-8.5 -43.5q0 -48 28.5 -77t70.5 -29h148v211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0430",
    unicode: "\u0430",
    horizAdvX: 576,
    d: "M204 -10q-38 0 -71 12.5t-57 35t-37.5 52.5t-13.5 66q0 37 16.5 68.5t46 53.5t70.5 34.5t90 12.5q35 0 68.5 -6t59.5 -17v30q0 52 -29.5 80t-87.5 28q-42 0 -82 -15t-82 -44l-41 85q101 67 218 67q113 0 175.5 -55.5t62.5 -160.5v-163q0 -21 7.5 -30t24.5 -10v-114 q-34 -7 -59 -7q-38 0 -58.5 17t-25.5 45l-3 29q-35 -46 -85 -70t-107 -24zM242 88q34 0 64.5 12t47.5 32q22 17 22 38v60q-24 9 -52 14.5t-54 5.5q-52 0 -85 -23.5t-33 -59.5q0 -34 26 -56.5t64 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0431",
    unicode: "\u0431",
    horizAdvX: 608,
    d: "M320 583q-63 -14 -99.5 -54t-49.5 -115q31 38 75 58.5t99 20.5q48 0 90 -19t73.5 -52t50 -78t18.5 -97q0 -54 -18.5 -101t-53 -81.5t-84.5 -54.5t-113 -20q-130 0 -197 81.5t-67 238.5q0 89 17 155.5t51.5 113t86 75.5t119.5 44l194 43l9 -113zM181 250q0 -33 10 -60 t27 -46.5t41 -30.5t53 -11q57 0 92 39.5t35 104.5q0 60 -36 97.5t-95 37.5q-56 0 -91.5 -36t-35.5 -95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0432",
    unicode: "\u0432",
    horizAdvX: 557,
    d: "M374 524q29 0 53 -10.5t41.5 -28.5t27 -42t9.5 -51q0 -34 -18 -68.5t-59 -51.5q46 -13 72.5 -44.5t26.5 -85.5q0 -72 -50 -107t-138 -35h-275v524h310zM311 305q28 0 45 16t17 46q0 25 -14.5 42.5t-43.5 17.5h-118v-122h114zM329 97q29 0 46.5 19t17.5 46q0 28 -17 46.5 t-46 18.5h-133v-130h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0433",
    unicode: "\u0433",
    horizAdvX: 431,
    d: "M415 413h-219v-413h-133v524h352v-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0434",
    unicode: "\u0434",
    horizAdvX: 629,
    d: "M15 116h28q24 3 39.5 15.5t27 40t19 73.5t15.5 117l18 162h367v-408h70v-266h-119v150h-350v-150h-115v266zM396 116v296h-117l-10 -79q-10 -81 -24.5 -132t-36.5 -85h188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0435",
    unicode: "\u0435",
    d: "M304 -10q-63 0 -114 21.5t-87 58.5t-55.5 86t-19.5 103q0 56 19 105.5t55 87t87.5 59.5t115.5 22t114.5 -22t86 -59t54 -86t18.5 -102q0 -13 -0.5 -25t-2.5 -20h-405q3 -31 15 -55t31 -41t43 -26t50 -9q40 0 75.5 19.5t48.5 51.5l115 -32q-29 -60 -92.5 -98.5 t-151.5 -38.5zM440 306q-5 59 -43.5 94.5t-93.5 35.5q-27 0 -50.5 -9.5t-41.5 -26.5t-29.5 -41t-13.5 -53h272z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0436",
    unicode: "\u0436",
    horizAdvX: 832,
    d: "M167 524l130 -207h51v207h137v-207h52l129 207h151l-169 -253l185 -271h-157l-131 206h-60v-206h-136v206h-61l-131 -206h-157l184 271l-168 253h151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0437",
    unicode: "\u0437",
    horizAdvX: 440,
    d: "M34 467q39 34 85 50t94 16q35 0 66 -8.5t54.5 -25.5t37 -42.5t13.5 -58.5q0 -42 -22.5 -73.5t-63.5 -39.5q57 -11 86 -46.5t29 -88.5q0 -36 -15.5 -65.5t-42.5 -50.5t-64.5 -32.5t-81.5 -11.5q-61 0 -111 20t-81 56l64 86q20 -25 49.5 -37.5t64.5 -12.5q42 0 65.5 17 t23.5 49q0 36 -26.5 55.5t-89.5 19.5h-41v77h40q48 0 73.5 18.5t25.5 47.5q0 25 -18.5 38t-48.5 13q-26 0 -55 -11.5t-53 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0438",
    unicode: "\u0438",
    horizAdvX: 606,
    d: "M196 191l248 333h99v-524h-133v324l-245 -324h-102v524h133v-333z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0439",
    unicode: "\u0439",
    horizAdvX: 606,
    d: "M478 730q-2 -63 -47 -98.5t-118 -35.5t-118 35.5t-47 98.5h74q1 -38 24.5 -56t66.5 -18q86 0 92 74h73zM196 191l248 333h99v-524h-133v324l-245 -324h-102v524h133v-333z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043A",
    unicode: "\u043A",
    horizAdvX: 539,
    d: "M384 524h144l-204 -254l220 -270h-152l-162 202h-35v-202h-132v524h132v-208h30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043B",
    unicode: "\u043B",
    horizAdvX: 573,
    d: "M8 114q29 2 47.5 12t31 37t21 74.5t17.5 124.5l18 162h367v-524h-133v412h-117l-10 -79q-12 -99 -29 -163.5t-43.5 -102.5t-65.5 -53.5t-96 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043C",
    unicode: "\u043C",
    horizAdvX: 711,
    d: "M356 245l155 279h137v-524h-128v315l-133 -236h-63l-133 236v-315h-128v524h138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043D",
    unicode: "\u043D",
    d: "M196 326h208v198h133v-524h-133v212h-208v-212h-133v524h133v-198z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043E",
    unicode: "\u043E",
    horizAdvX: 606,
    d: "M303 -10q-64 0 -115 22t-86.5 59.5t-54.5 86.5t-19 103q0 55 19 104t54.5 86.5t86.5 59.5t115 22t114.5 -22t86 -59.5t54.5 -86.5t19 -104q0 -54 -19 -103t-54 -86.5t-86 -59.5t-115 -22zM166 261q0 -35 10.5 -63.5t29 -49.5t43.5 -32.5t54 -11.5t54 11.5t43.5 32.5 t29 50t10.5 64q0 34 -10.5 63t-29 50t-43.5 32.5t-54 11.5t-54 -12t-43.5 -33t-29 -50t-10.5 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043F",
    unicode: "\u043F",
    horizAdvX: 584,
    d: "M522 0h-133v408h-193v-408h-133v524h459v-524z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0440",
    unicode: "\u0440",
    horizAdvX: 635,
    d: "M377 -10q-62 0 -108 27.5t-72 74.5v-305h-134v737h117v-90q29 46 75 72.5t106 26.5q53 0 98 -21.5t77.5 -58t51 -86t18.5 -104.5q0 -57 -17 -107t-47.5 -87t-72.5 -58t-92 -21zM332 104q30 0 55.5 13t43.5 35t28 51t10 60q0 33 -11 61.5t-30.5 49.5t-46 33t-57.5 12 q-19 0 -39 -6.5t-37 -18.5t-30.5 -28t-20.5 -35v-123q18 -45 55 -74.5t80 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0441",
    unicode: "\u0441",
    horizAdvX: 564,
    d: "M28 262q0 55 19 104t55 86t87 59t115 22q86 0 146.5 -37t90.5 -97l-131 -40q-17 29 -45 44.5t-62 15.5q-29 0 -54 -11.5t-43.5 -32t-29 -49.5t-10.5 -64t11 -64t29.5 -50t43.5 -32.5t53 -11.5q36 0 66.5 18t42.5 44l131 -40q-27 -60 -89 -98t-149 -38q-64 0 -115 22 t-87 59.5t-55.5 87t-19.5 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0442",
    unicode: "\u0442",
    horizAdvX: 494,
    d: "M314 0h-133v408h-164v116h460v-116h-163v-408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0443",
    unicode: "\u0443",
    horizAdvX: 550,
    d: "M76 -94q17 -10 32.5 -14t29.5 -4q25 0 43 24.5t32 87.5l-207 524h138l142 -408l126 408h126l-206 -592q-30 -86 -73.5 -123t-106.5 -37q-23 0 -41 4t-35 15v115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0444",
    unicode: "\u0444",
    horizAdvX: 717,
    d: "M428 528q63 -8 111.5 -30.5t81.5 -57.5t50 -80.5t17 -99.5q0 -110 -67.5 -180t-192.5 -85v-208h-134v207q-129 14 -197.5 84t-68.5 182q0 54 17 100t51 81t83.5 57.5t114.5 30.5v201h134v-202zM294 418q-69 -11 -102 -50.5t-33 -105.5t32 -107t103 -52v315zM428 104 q67 12 98 52t31 106q0 65 -31.5 104.5t-97.5 51.5v-314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0445",
    unicode: "\u0445",
    horizAdvX: 531,
    d: "M144 524l113 -164l8 -18l10 18l112 164h138l-187 -263l190 -261h-138l-116 163l-9 17l-8 -17l-115 -163h-138l189 261l-186 263h137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0446",
    unicode: "\u0446",
    horizAdvX: 608,
    d: "M63 524h133v-408h174v408h133v-408h86v-266h-118v150h-408v524z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0447",
    unicode: "\u0447",
    horizAdvX: 513,
    d: "M450 0h-131v187q-23 -8 -47.5 -12t-61.5 -4q-45 0 -78 14.5t-55 39t-33 57.5t-11 71v171h129v-151q0 -52 21 -74t59 -22q28 0 46.5 5.5t30.5 14.5v227h131v-524z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0448",
    unicode: "\u0448",
    horizAdvX: 817,
    d: "M63 0v524h133v-408h146v408h133v-408h146v408h133v-524h-691z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0449",
    unicode: "\u0449",
    horizAdvX: 859,
    d: "M63 524h133v-408h146v408h133v-408h146v408h133v-408h87v-266h-119v150h-659v524z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044A",
    unicode: "\u044A",
    horizAdvX: 614,
    d: "M292 358h102q42 0 78.5 -11.5t63.5 -34t42.5 -56t15.5 -76.5q0 -44 -15 -77.5t-41 -56.5t-61.5 -34.5t-77.5 -11.5h-240v413h-143v111h276v-166zM384 105q35 0 55 18.5t20 54.5t-21 55.5t-53 19.5h-93v-148h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044B",
    unicode: "\u044B",
    horizAdvX: 737,
    d: "M63 524h133v-166h88q43 0 79.5 -11.5t63.5 -34t42.5 -56t15.5 -76.5q0 -44 -15 -77.5t-41.5 -56.5t-62 -34.5t-77.5 -11.5h-226v524zM542 524h132v-524h-132v524zM275 105q34 0 54 18.5t20 54.5t-21 55.5t-53 19.5h-79v-148h79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044C",
    unicode: "\u044C",
    horizAdvX: 518,
    d: "M63 524h133v-166h102q42 0 78.5 -11.5t63.5 -34t42.5 -56t15.5 -76.5q0 -44 -15 -77.5t-41 -56.5t-61.5 -34.5t-77.5 -11.5h-240v524zM288 105q35 0 55 18.5t20 54.5t-21 55.5t-53 19.5h-93v-148h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044D",
    unicode: "\u044D",
    horizAdvX: 551,
    d: "M249 -9q-77 0 -139.5 32t-91.5 92l101 57q19 -35 56 -54t73 -19q51 0 87.5 32.5t47.5 87.5h-199v88h199q-12 52 -49 85t-91 33q-35 0 -69.5 -16t-57.5 -52l-91 60q29 51 85.5 84t135.5 33q64 0 115.5 -23t87.5 -61t55 -86.5t19 -100.5t-19.5 -101t-55.5 -87t-86.5 -61 t-112.5 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044E",
    unicode: "\u044E",
    horizAdvX: 785,
    d: "M265 324q8 48 29.5 87t53 66.5t72 42t87.5 14.5q56 0 102 -20.5t78.5 -56.5t50 -86.5t17.5 -110.5q0 -63 -19 -113.5t-52 -85t-78.5 -53t-99.5 -18.5q-50 0 -91 15.5t-72.5 44t-52 68.5t-27.5 90h-68v-208h-133v524h133v-200h70zM388 262q0 -78 31.5 -116.5t85.5 -38.5 q57 0 89 40.5t32 115.5q0 76 -33 115t-87 39q-56 0 -87 -40.5t-31 -114.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044F",
    unicode: "\u044F",
    horizAdvX: 539,
    d: "M152 199q-47 17 -74 54t-27 97q0 40 14 72.5t39 55t59.5 35t74.5 12.5h238v-525h-132v177h-71l-109 -177h-144zM344 279v140h-90q-26 0 -47 -18.5t-21 -52.5q0 -32 19.5 -50.5t46.5 -18.5h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0450",
    unicode: "\u0450",
    d: "M304 -10q-63 0 -114 21.5t-87 58.5t-55.5 86t-19.5 103q0 56 19 105.5t55 87t87.5 59.5t115.5 22t114.5 -22t86 -59t54 -86t18.5 -102q0 -13 -0.5 -25t-2.5 -20h-405q3 -31 15 -55t31 -41t43 -26t50 -9q40 0 75.5 19.5t48.5 51.5l115 -32q-29 -60 -92.5 -98.5 t-151.5 -38.5zM440 306q-5 59 -43.5 94.5t-93.5 35.5q-27 0 -50.5 -9.5t-41.5 -26.5t-29.5 -41t-13.5 -53h272zM175 730h124l55 -119l-86 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0451",
    unicode: "\u0451",
    d: "M151 604v119h111v-119h-111zM343 604v119h111v-119h-111zM304 -10q-63 0 -114 21.5t-87 58.5t-55.5 86t-19.5 103q0 56 19 105.5t55 87t87.5 59.5t115.5 22t114.5 -22t86 -59t54 -86t18.5 -102q0 -13 -0.5 -25t-2.5 -20h-405q3 -31 15 -55t31 -41t43 -26t50 -9 q40 0 75.5 19.5t48.5 51.5l115 -32q-29 -60 -92.5 -98.5t-151.5 -38.5zM440 306q-5 59 -43.5 94.5t-93.5 35.5q-27 0 -50.5 -9.5t-41.5 -26.5t-29.5 -41t-13.5 -53h272z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0452",
    unicode: "\u0452",
    horizAdvX: 608,
    d: "M550 -4q0 -42 -14 -77.5t-38.5 -61t-58 -39.5t-73.5 -14q-37 0 -71 12t-60 35l58 91q10 -10 25 -16t32 -6q29 0 47.5 18.5t18.5 47.5v263q0 61 -23 91t-62 30q-47 0 -83 -38.5t-51 -97.5v-234h-134v564h-77v84h77v82h134v-82h215v-84h-215v-199q26 59 75.5 91t112.5 32 q47 0 79 -16.5t51 -44.5t27 -65.5t8 -79.5v-286z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0453",
    unicode: "\u0453",
    horizAdvX: 432,
    d: "M268 585l-86 26l54 119h125zM415 413h-219v-413h-133v524h352v-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0454",
    unicode: "\u0454",
    horizAdvX: 552,
    d: "M303 -9q-62 0 -113 21.5t-87 59t-55.5 86.5t-19.5 105q0 54 19 103t55 86.5t87.5 59.5t116.5 22q78 0 135.5 -33t85.5 -84l-97 -66q-10 19 -24.5 33t-31.5 23t-35 13.5t-34 4.5q-28 0 -50.5 -9.5t-40 -26t-29.5 -37.5t-18 -45h200v-88h-199q11 -53 47.5 -86.5t87.5 -33.5 q18 0 36.5 5t35.5 14.5t30.5 24t21.5 32.5l107 -60q-12 -30 -36 -53t-55.5 -38.5t-67.5 -24t-72 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0455",
    unicode: "\u0455",
    horizAdvX: 497,
    d: "M259 -10q-66 0 -129 21t-108 60l50 84q48 -34 93.5 -51.5t90.5 -17.5q40 0 63 15t23 43t-27 41t-88 30q-51 14 -87 27t-58 29.5t-32 38t-10 51.5q0 40 15.5 72t43.5 54.5t65.5 34.5t81.5 12q59 0 110.5 -17t94.5 -55l-54 -81q-40 30 -77.5 44t-74.5 14q-34 0 -57 -14 t-23 -45q0 -14 5.5 -23t17.5 -16t31.5 -13.5t48.5 -13.5q54 -14 92.5 -28t63 -32t36 -41.5t11.5 -56.5q0 -77 -57 -121.5t-155 -44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0456",
    unicode: "\u0456",
    horizAdvX: 259,
    d: "M63 0v524h134v-524h-134zM63 597v133h134v-133h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0457",
    unicode: "\u0457",
    horizAdvX: 259,
    d: "M-22 604v119h111v-119h-111zM170 604v119h111v-119h-111zM63 0v524h134v-524h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0458",
    unicode: "\u0458",
    horizAdvX: 264,
    d: "M19 -196q-38 0 -72 11.5t-61 35.5l58 91q11 -11 27 -16.5t32 -5.5q26 0 45 18.5t19 47.5v538h134v-528q0 -42 -14 -77.5t-38.5 -61t-58 -39.5t-71.5 -14zM67 597v133h134v-133h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0459",
    unicode: "\u0459",
    horizAdvX: 830,
    d: "M8 114q29 2 47.5 12t31.5 37t21.5 74.5t16.5 124.5l18 162h368v-187h111q39 0 73 -11t58.5 -32.5t38.5 -52.5t14 -71q0 -42 -13.5 -73.5t-37.5 -53t-56.5 -32.5t-71.5 -11h-249v412h-117l-10 -79q-12 -99 -29 -163.5t-44 -102.5t-66 -53.5t-96 -17.5zM610 106q27 0 43 16 t16 47q0 32 -16 48.5t-42 16.5h-100v-128h99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045A",
    unicode: "\u045A",
    horizAdvX: 842,
    d: "M63 524h133v-191h198v191h133v-187h107q39 0 73 -11t58.5 -32.5t38.5 -52.5t14 -71q0 -42 -13.5 -73.5t-37.5 -53t-56.5 -32.5t-71.5 -11h-245v217h-198v-217h-133v524zM623 106q27 0 42.5 16t15.5 47q0 32 -16 48.5t-41 16.5h-97v-128h96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045B",
    unicode: "\u045B",
    horizAdvX: 608,
    d: "M416 249q0 61 -23 91t-63 30q-45 0 -81.5 -36.5t-51.5 -97.5v-236h-134v564h-77v84h77v82h134v-82h215v-84h-215v-197q25 57 74.5 89t113.5 32q47 0 79 -16t51 -44t27 -65.5t8 -80.5v-282h-134v249z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045C",
    unicode: "\u045C",
    horizAdvX: 539,
    d: "M314 585l-86 26l54 119h125zM384 524h144l-204 -254l220 -270h-152l-162 202h-35v-202h-132v524h132v-208h30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045D",
    unicode: "\u045D",
    horizAdvX: 593,
    d: "M196 191l248 333h99v-524h-133v324l-245 -324h-102v524h133v-333zM174 730h124l55 -119l-86 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045E",
    unicode: "\u045E",
    horizAdvX: 550,
    d: "M89 -105q17 -5 29.5 -6t22.5 -1t19 3t17 14.5t17 33.5t19 61l-207 524h138l142 -408l126 408h126l-221 -628q-43 -124 -164 -124q-15 0 -31 1.5t-33 6.5v115zM451 730q-2 -63 -47 -98.5t-118 -35.5t-118 35.5t-47 98.5h74q1 -38 24.5 -56t66.5 -18q86 0 92 74h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045F",
    unicode: "\u045F",
    horizAdvX: 571,
    d: "M222 0h-159v524h133v-408h179v408h133v-524h-161v-150h-125v150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0490",
    unicode: "\u0490",
    horizAdvX: 523,
    d: "M77 710h315l7 165h112v-286h-296v-589h-138v710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0491",
    unicode: "\u0491",
    horizAdvX: 432,
    d: "M63 524h240l8 149h104v-261h-219v-412h-133v524z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B0",
    unicode: "\u04B0",
    horizAdvX: 629,
    d: "M541 230v-87h-158v-143h-137v143h-157v87h157v20l-256 460h150l175 -342l177 342h148l-257 -459v-21h158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B1",
    unicode: "\u04B1",
    horizAdvX: 541,
    d: "M207 0h-141v87h135v4l-203 433h145l127 -321l134 321h139l-206 -433v-4h136v-87h-142v-213h-124v213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ddotbelow",
    unicode: "\u1E0C",
    horizAdvX: 716,
    d: "M281 -196v126h121v-126h-121zM74 0v710h258q87 0 152.5 -28t109.5 -76t66 -112.5t22 -137.5q0 -81 -24.5 -146.5t-70.5 -112t-110.5 -72t-144.5 -25.5h-258zM543 356q0 51 -14 94t-41 74t-66.5 48t-89.5 17h-120v-468h120q51 0 90.5 18t66 49.5t40.5 74.5t14 93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ddotbelow",
    unicode: "\u1E0D",
    horizAdvX: 645,
    d: "M265 -196v126h121v-126h-121zM278 -10q-54 0 -100 21t-79 58t-51.5 86.5t-18.5 106.5t17.5 106t48.5 86t74 58t94 21q58 0 104.5 -28t72.5 -73v298h134v-576q0 -21 7 -30t24 -10v-114q-35 -7 -57 -7q-36 0 -59 18t-26 47l-3 33q-29 -50 -78.5 -75.5t-103.5 -25.5z M313 104q19 0 39 6.5t37 18.5t30.5 28t20.5 35v125q-8 22 -22.5 40.5t-33 32t-39 21.5t-40.5 8q-30 0 -55.5 -13t-43.5 -35.5t-28 -51.5t-10 -60q0 -33 11 -61t30 -49t45.5 -33t58.5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hdotbelow",
    unicode: "\u1E24",
    horizAdvX: 745,
    d: "M671 710v-710h-137v303h-322v-303h-138v710h138v-287h322v287h137zM311 -196v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hdotbelow",
    unicode: "\u1E25",
    horizAdvX: 604,
    d: "M548 0h-134v294q0 62 -23 91.5t-65 29.5q-18 0 -38 -8t-38 -22.5t-33 -34.5t-22 -44v-306h-134v730h134v-303q29 51 78.5 78.5t109.5 27.5q51 0 83 -17.5t50 -46.5t25 -66t7 -76v-327zM245 -196v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ndotaccent",
    unicode: "\u1E44",
    horizAdvX: 763,
    d: "M321 789v126h121v-126h-121zM212 455v-455h-138v710h107l370 -466v465h138v-709h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ndotaccent",
    unicode: "\u1E45",
    horizAdvX: 604,
    d: "M256 604v126h121v-126h-121zM548 0h-134v294q0 63 -22 92t-61 29q-20 0 -41 -8t-39.5 -22.5t-33.5 -34.5t-22 -44v-306h-134v524h121v-97q29 50 84 78t124 28q49 0 80 -18t48 -47t23.5 -66t6.5 -75v-327z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdotbelow",
    unicode: "\u1E5A",
    horizAdvX: 665,
    d: "M74 0v710h314q49 0 90.5 -20.5t71.5 -54t47 -76t17 -85.5q0 -69 -34.5 -125.5t-93.5 -81.5l162 -267h-155l-145 238h-136v-238h-138zM212 359h173q19 0 35.5 9t28.5 24.5t19 36.5t7 45q0 25 -8 46t-21.5 36.5t-31 24t-35.5 8.5h-167v-230zM275 -196v126h121v-126h-121z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdotbelow",
    unicode: "\u1E5B",
    horizAdvX: 387,
    d: "M373 408q-61 -1 -109 -23.5t-69 -67.5v-317h-134v524h123v-112q14 27 33 48.5t41 37.5t44.5 24.5t43.5 8.5h16.5t10.5 -1v-122zM68 -196v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sdotbelow",
    unicode: "\u1E62",
    horizAdvX: 613,
    d: "M497 524q-7 7 -25.5 19t-45 23.5t-57.5 19.5t-63 8q-57 0 -85 -21t-28 -59q0 -22 10.5 -36.5t30.5 -25.5t50.5 -20t70.5 -19q52 -14 94.5 -30t72 -40t45.5 -57.5t16 -82.5q0 -57 -21.5 -97.5t-58 -65.5t-84 -36.5t-99.5 -11.5q-80 0 -158 24t-140 68l61 119 q9 -9 32.5 -23.5t55.5 -29t71 -24.5t80 -10q114 0 114 73q0 23 -13 39t-37 28t-58 22t-76 22q-51 14 -88.5 30.5t-62.5 39t-37.5 52t-12.5 70.5q0 54 20 96t55.5 70t82.5 42.5t101 14.5q75 0 138 -23.5t110 -55.5zM243 -196v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sdotbelow",
    unicode: "\u1E63",
    horizAdvX: 497,
    d: "M259 -10q-66 0 -129 21t-108 60l50 84q48 -34 93.5 -51.5t90.5 -17.5q40 0 63 15t23 43t-27 41t-88 30q-51 14 -87 27t-58 29.5t-32 38t-10 51.5q0 40 15.5 72t43.5 54.5t65.5 34.5t81.5 12q59 0 110.5 -17t94.5 -55l-54 -81q-40 30 -77.5 44t-74.5 14q-34 0 -57 -14 t-23 -45q0 -14 5.5 -23t17.5 -16t31.5 -13.5t48.5 -13.5q54 -14 92.5 -28t63 -32t36 -41.5t11.5 -56.5q0 -77 -57 -121.5t-155 -44.5zM188 -196v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tdotbelow",
    unicode: "\u1E6C",
    horizAdvX: 619,
    d: "M247 -196v126h121v-126h-121zM605 589h-227v-589h-137v589h-227v121h591v-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tdotbelow",
    unicode: "\u1E6D",
    horizAdvX: 384,
    d: "M161 -196v126h121v-126h-121zM375 27q-27 -12 -66 -24t-82 -12q-28 0 -52.5 7t-43 22.5t-29.5 40t-11 59.5v301h-69v103h69v170h134v-170h110v-103h-110v-256q0 -28 14.5 -39.5t35.5 -11.5t41 7t32 12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 1053,
    d: "M319 708h127l80 -235l80 235h128l-121 -323l90 -227l201 552h150l-289 -710h-116l-123 298l-123 -298h-116l-287 710h148l202 -552l88 227zM398 916h124l55 -119l-86 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 839,
    d: "M711 524h127l-219 -524h-110l-90 230l-89 -230h-110l-218 524h126l156 -398l64 170l-92 227h108l55 -161l56 161h108l-91 -227l63 -170zM292 730h124l55 -119l-86 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 1053,
    d: "M561 770l-86 26l54 119h125zM319 708h127l80 -235l80 235h128l-121 -323l90 -227l201 552h150l-289 -710h-116l-123 298l-123 -298h-116l-287 710h148l202 -552l88 227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 839,
    d: "M454 585l-86 26l54 119h125zM711 524h127l-219 -524h-110l-90 230l-89 -230h-110l-218 524h126l156 -398l64 170l-92 227h108l55 -161l56 161h108l-91 -227l63 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 1053,
    d: "M374 790v119h111v-119h-111zM566 790v119h111v-119h-111zM319 708h127l80 -235l80 235h128l-121 -323l90 -227l201 552h150l-289 -710h-116l-123 298l-123 -298h-116l-287 710h148l202 -552l88 227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 839,
    d: "M268 604v119h111v-119h-111zM460 604v119h111v-119h-111zM711 524h127l-219 -524h-110l-90 230l-89 -230h-110l-218 524h126l156 -398l64 170l-92 227h108l55 -161l56 161h108l-91 -227l63 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotbelow",
    unicode: "\u1E92",
    horizAdvX: 627,
    d: "M30 104l401 485h-390v121h549v-104l-388 -485h391v-121h-563v104zM259 -196v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotbelow",
    unicode: "\u1E93",
    horizAdvX: 493,
    d: "M26 82l292 348h-280v94h421v-82l-290 -348h295v-94h-438v82zM184 -196v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotbelow",
    unicode: "\u1EB8",
    horizAdvX: 601,
    d: "M567 121v-121h-493v710h484v-121h-346v-171h299v-112h-299v-185h355zM259 -196v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotbelow",
    unicode: "\u1EB9",
    d: "M304 -10q-63 0 -114 21.5t-87 58.5t-55.5 86t-19.5 103q0 56 19 105.5t55 87t87.5 59.5t115.5 22t114.5 -22t86 -59t54 -86t18.5 -102q0 -13 -0.5 -25t-2.5 -20h-405q3 -31 15 -55t31 -41t43 -26t50 -9q40 0 75.5 19.5t48.5 51.5l115 -32q-29 -60 -92.5 -98.5 t-151.5 -38.5zM440 306q-5 59 -43.5 94.5t-93.5 35.5q-27 0 -50.5 -9.5t-41.5 -26.5t-29.5 -41t-13.5 -53h272zM242 -196v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etilde",
    unicode: "\u1EBC",
    horizAdvX: 601,
    d: "M567 121v-121h-493v710h484v-121h-346v-171h299v-112h-299v-185h355zM389 787q-23 0 -40 7t-31.5 15.5t-29 15.5t-30.5 7q-17 0 -26.5 -7t-14.5 -16t-6 -16.5t-1 -8.5h-74q0 9 6 30.5t19.5 43t36 38t55.5 16.5q23 0 39.5 -7.5t31 -16t29 -16t32.5 -7.5t28.5 7t16 16t7 17 t1.5 10h74q0 -7 -6 -28t-20.5 -43t-38 -39.5t-58.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etilde",
    unicode: "\u1EBD",
    d: "M304 -10q-63 0 -114 21.5t-87 58.5t-55.5 86t-19.5 103q0 56 19 105.5t55 87t87.5 59.5t115.5 22t114.5 -22t86 -59t54 -86t18.5 -102q0 -13 -0.5 -25t-2.5 -20h-405q3 -31 15 -55t31 -41t43 -26t50 -9q40 0 75.5 19.5t48.5 51.5l115 -32q-29 -60 -92.5 -98.5 t-151.5 -38.5zM440 306q-5 59 -43.5 94.5t-93.5 35.5q-27 0 -50.5 -9.5t-41.5 -26.5t-29.5 -41t-13.5 -53h272zM366 602q-23 0 -40 7t-31.5 15.5t-29 15.5t-30.5 7q-17 0 -26.5 -7t-14.5 -16t-6 -16.5t-1 -8.5h-74q0 9 6 30.5t19.5 43t36 38t55.5 16.5q23 0 39.5 -7.5 t31 -16t29 -16t32.5 -7.5t28.5 7t16 16t7 17t1.5 10h74q0 -7 -6 -28t-20.5 -43t-38 -39.5t-58.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotbelow",
    unicode: "\u1ECA",
    horizAdvX: 286,
    d: "M74 0v710h138v-710h-138zM80 -196v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idotbelow",
    unicode: "\u1ECB",
    horizAdvX: 255,
    d: "M61 0v524h134v-524h-134zM61 597v133h134v-133h-134zM66 -196v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odotbelow",
    unicode: "\u1ECC",
    horizAdvX: 756,
    d: "M316 -196v126h121v-126h-121zM377 -5q-78 0 -141.5 30.5t-109 81t-70.5 115.5t-25 133q0 71 26.5 136t73 115t110.5 79.5t139 29.5q77 0 140.5 -31.5t108.5 -82.5t70 -116t25 -132q0 -71 -26 -135.5t-72 -114t-110 -79t-139 -29.5zM171 355q0 -46 14 -89t40.5 -76t65 -53 t87.5 -20q50 0 88.5 20.5t65 54.5t40 76.5t13.5 86.5q0 46 -14.5 89t-41 76t-65 52.5t-86.5 19.5q-50 0 -89 -20.5t-65 -54t-39.5 -76t-13.5 -86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odotbelow",
    unicode: "\u1ECD",
    horizAdvX: 606,
    d: "M243 -196v126h121v-126h-121zM303 -10q-64 0 -115 22t-86.5 59.5t-54.5 86.5t-19 103q0 55 19 104t54.5 86.5t86.5 59.5t115 22t114.5 -22t86 -59.5t54.5 -86.5t19 -104q0 -54 -19 -103t-54 -86.5t-86 -59.5t-115 -22zM166 261q0 -35 10.5 -63.5t29 -49.5t43.5 -32.5 t54 -11.5t54 11.5t43.5 32.5t29 50t10.5 64q0 34 -10.5 63t-29 50t-43.5 32.5t-54 11.5t-54 -12t-43.5 -33t-29 -50t-10.5 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udotbelow",
    unicode: "\u1EE4",
    horizAdvX: 750,
    d: "M374 117q49 0 82.5 20t54 52t29 73.5t8.5 85.5v362h137v-362q0 -73 -17.5 -137t-55 -112t-96.5 -76t-141 -28q-85 0 -144.5 29.5t-96.5 78t-53.5 112.5t-16.5 133v362h138v-362q0 -45 8.5 -86.5t29 -73.5t53.5 -51.5t81 -19.5zM313 -196v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udotbelow",
    unicode: "\u1EE5",
    horizAdvX: 618,
    d: "M221 -10q-81 0 -123 52t-42 154v328h134v-299q0 -121 87 -121q39 0 75.5 23.5t59.5 71.5v325h134v-370q0 -21 7.5 -30t24.5 -10v-114q-20 -4 -33.5 -5t-24.5 -1q-36 0 -58.5 16.5t-26.5 45.5l-3 42q-35 -54 -90 -81t-121 -27zM236 -196v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 660,
    d: "M154 710l175 -342l178 342h149l-258 -462v-248h-137v250l-257 460h150zM202 916h124l55 -119l-86 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 550,
    d: "M72 -102q17 -5 33 -7.5t27 -2.5q13 0 24 5t20 17.5t18 34.5t19 55l-207 524h138l142 -408l126 408h126l-220 -628q-19 -55 -65 -90t-114 -35q-16 0 -32.5 2.5t-34.5 8.5v116zM159 730h124l55 -119l-86 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ytilde",
    unicode: "\u1EF8",
    horizAdvX: 660,
    d: "M154 710l175 -342l178 342h149l-258 -462v-248h-137v250l-257 460h150zM392 787q-23 0 -40 7t-31.5 15.5t-29 15.5t-30.5 7q-17 0 -26.5 -7t-14.5 -16t-6 -16.5t-1 -8.5h-74q0 9 6 30.5t19.5 43t36 38t55.5 16.5q23 0 39.5 -7.5t31 -16t29 -16t32.5 -7.5t28.5 7t16 16 t7 17t1.5 10h74q0 -7 -6 -28t-20.5 -43t-38 -39.5t-58.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ytilde",
    unicode: "\u1EF9",
    horizAdvX: 550,
    d: "M72 -102q17 -5 33 -7.5t27 -2.5q13 0 24 5t20 17.5t18 34.5t19 55l-207 524h138l142 -408l126 408h126l-220 -628q-19 -55 -65 -90t-114 -35q-16 0 -32.5 2.5t-34.5 8.5v116zM349 602q-23 0 -40 7t-31.5 15.5t-29 15.5t-30.5 7q-17 0 -26.5 -7t-14.5 -16t-6 -16.5 t-1 -8.5h-74q0 9 6 30.5t19.5 43t36 38t55.5 16.5q23 0 39.5 -7.5t31 -16t29 -16t32.5 -7.5t28.5 7t16 16t7 17t1.5 10h74q0 -7 -6 -28t-20.5 -43t-38 -39.5t-58.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "enspace",
    unicode: "\u2002",
    horizAdvX: 602
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emspace",
    unicode: "\u2003",
    horizAdvX: 929
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 603,
    d: "M58 214v121h488v-121h-488z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 928,
    d: "M58 214v121h812v-121h-812z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 246,
    d: "M173 730l-22 -122h40v-135h-135v137l36 120h81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 237,
    d: "M70 479l22 122h-40v135h135v-137l-36 -120h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 250,
    d: "M75 -131l23 131h-40v146h134v-148l-35 -129h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 434,
    d: "M173 730l-22 -122h40v-135h-135v137l36 120h81zM361 730l-22 -122h40v-135h-135v137l36 120h81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 425,
    d: "M70 479l22 122h-40v135h135v-137l-36 -120h-81zM258 479l22 122h-40v135h135v-137l-36 -120h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 432,
    d: "M75 -131l23 131h-40v146h134v-148l-35 -129h-82zM258 -131l22 131h-40v146h135v-148l-36 -129h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 461,
    d: "M167 -130v341h-132v120h132v444h127v-444h131v-120h-131v-341h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 474,
    d: "M174 -130v232h-132v120h132v112h-132v121h132v320h127v-320h131v-121h-131v-112h131v-120h-131v-232h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 363,
    d: "M286 350q0 -22 -8.5 -41t-22.5 -33.5t-33 -22.5t-41 -8q-21 0 -40 8t-33.5 22.5t-22.5 33.5t-8 41q0 21 8 40t22.5 33.5t33.5 22.5t40 8q22 0 41 -8t33 -22.5t22.5 -33.5t8.5 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 602,
    d: "M58 0v144h110v-144h-110zM246 0v144h110v-144h-110zM434 0v144h110v-144h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1169,
    d: "M205 417q-35 0 -65 12t-52 32.5t-35 48t-13 59.5q0 31 13 59t35 48t52 32t65 12q34 0 64 -12t52.5 -32t35 -48t12.5 -59q0 -32 -12.5 -59.5t-35 -48t-52.5 -32.5t-64 -12zM205 484q15 0 27.5 7t22.5 18.5t15.5 27t5.5 32.5q0 35 -21 59.5t-50 24.5q-30 0 -50.5 -25 t-20.5 -59q0 -18 5.5 -33.5t15.5 -27t23 -18t27 -6.5zM591 -10q-35 0 -65 12t-52 32t-35 47.5t-13 59.5t13 59.5t35 48t52 32.5t65 12q34 0 64.5 -12t52.5 -32.5t35 -48t13 -59.5t-13 -59.5t-35 -47.5t-52.5 -32t-64.5 -12zM591 57q15 0 27.5 7t22.5 18.5t15.5 26.5t5.5 32 q0 18 -6 33.5t-15.5 27t-22.5 18t-27 6.5q-15 0 -27.5 -7t-22.5 -18.5t-15.5 -27t-5.5 -32.5t5.5 -32.5t15.5 -27t22.5 -18t27.5 -6.5zM972 -10q-35 0 -65 12t-52 32t-35 47.5t-13 59.5t13 59.5t35 48t52 32.5t65 12q34 0 64.5 -12t52.5 -32.5t35 -48t13 -59.5t-13 -59.5 t-35 -47.5t-52.5 -32t-64.5 -12zM972 57q15 0 27.5 7t22.5 18.5t15.5 26.5t5.5 32q0 18 -6 33.5t-15.5 27t-22.5 18t-27 6.5q-15 0 -27.5 -7t-22.5 -18.5t-15.5 -27t-5.5 -32.5q0 -35 21 -59.5t50 -24.5zM96 47l282 329l260 342l61 -54l-273 -323l-269 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 358,
    d: "M35 288l264 189v-109l-157 -109l157 -103v-110l-264 177v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 358,
    d: "M322 223l-264 -177v110l158 103l-158 109v109l264 -189v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 200,
    d: "M-202 47l282 329l260 342l61 -54l-273 -323l-269 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 487,
    d: "M244 388q-53 0 -93 20t-66.5 51t-40 68.5t-13.5 73.5q0 38 15 76t42.5 69t67 50t88.5 19q52 0 91.5 -20.5t66 -52t40 -69.5t13.5 -72q0 -39 -14.5 -77t-42 -68t-66.5 -49t-88 -19zM113 601q0 -23 8 -47t24.5 -43.5t41 -31.5t57.5 -12q34 0 58.5 13t40.5 33t23.5 43.5 t7.5 44.5q0 24 -8.5 47.5t-25 43t-40.5 31.5t-56 12q-34 0 -59 -13t-41 -32.5t-23.5 -43.5t-7.5 -45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 410,
    d: "M242 394v92h-221v77l246 252h54v-251h61v-78h-61v-92h-79zM98 564h147v153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 394,
    d: "M203 666q35 0 65 -10t52 -27.5t34.5 -42.5t12.5 -55q0 -32 -14 -58.5t-38 -45t-57 -29t-72 -10.5q-53 0 -95.5 19t-65.5 52l47 53q20 -23 50 -35.5t68 -12.5q41 0 68.5 17.5t27.5 52.5q0 18 -8 32t-21 23t-29 13.5t-31 4.5q-26 0 -52 -13t-38 -33h-70q5 27 13 61t16.5 69 t16 67.5t11.5 56.5h242v-79h-184l-25 -88q12 8 31 13t45 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 423,
    d: "M395 531q0 -31 -14 -58t-38 -46.5t-57 -31t-72 -11.5q-82 0 -131 51t-49 145q0 114 51.5 174.5t139.5 60.5q46 0 85.5 -16.5t63.5 -48.5l-46 -55q-15 20 -44 32t-62 12q-51 0 -82 -28.5t-32 -80.5q15 20 47 30.5t64 10.5q39 0 71 -11t55.5 -29.5t36.5 -44t13 -55.5z M216 457q21 0 40 6t33.5 16t22.5 23t8 28t-8 28t-22.5 23t-33.5 15.5t-40 5.5q-22 0 -41 -5.5t-33.5 -15.5t-22.5 -22.5t-8 -27.5t8.5 -28.5t23 -23.5t33.5 -16t40 -6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 388,
    d: "M263 736h-239v79h364l-248 -421h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 420,
    d: "M388 516q0 -28 -14.5 -51.5t-38.5 -40.5t-56.5 -26.5t-68.5 -9.5q-38 0 -70.5 10t-56.5 27.5t-37.5 41.5t-13.5 51q0 39 25.5 63t59.5 38q-27 11 -48 30.5t-21 50.5q0 26 14.5 47t37.5 36t52 23.5t58 8.5t58 -8t52 -23t37.5 -36t14.5 -47q0 -29 -20 -50t-50 -32 q38 -15 62 -40t24 -63zM307 525q0 13 -8.5 24t-22 18.5t-31 11.5t-35.5 4q-19 0 -37 -4.5t-31.5 -12t-21.5 -18t-8 -23.5q0 -14 9 -24.5t23 -18t31.5 -11.5t35.5 -4t35.5 4.5t31 12t21.5 18t8 23.5zM128 693q0 -11 7.5 -19.5t19 -14t26 -8.5t29.5 -3q14 0 28.5 3t26.5 9 t19.5 14t7.5 19q0 21 -25 33t-57 12q-33 0 -57.5 -12t-24.5 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 423,
    d: "M28 667q0 31 14 58t38 47t57 31.5t72 11.5q82 0 131 -52t49 -146q0 -113 -51 -173t-140 -60q-46 0 -85.5 16.5t-64.5 48.5l47 54q16 -20 44 -32t62 -12q51 0 82 28.5t33 80.5q-16 -20 -48 -30.5t-64 -10.5q-38 0 -70.5 11t-56 29.5t-36.5 44t-13 55.5zM207 741 q-21 0 -39.5 -6t-33 -16t-22.5 -23t-8 -28t8 -27.5t22.5 -22.5t33.5 -15.5t40 -5.5q43 0 73 20.5t30 49.5q0 15 -8 28.5t-22.5 23.5t-33.5 16t-40 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 487,
    d: "M244 -90q-53 0 -93 20t-66.5 51t-40 69t-13.5 73q0 38 15 76.5t42.5 69t67 49.5t88.5 19q52 0 91.5 -20.5t66 -52t40 -69.5t13.5 -72q0 -38 -14.5 -76t-42 -68.5t-66.5 -49.5t-88 -19zM113 123q0 -23 8 -47t24.5 -43.5t41 -31.5t57.5 -12q34 0 58.5 13t40.5 33t23.5 43.5 t7.5 44.5q0 24 -8.5 47.5t-25 43t-40.5 31.5t-56 12q-34 0 -59 -13t-41 -32.5t-23.5 -43.5t-7.5 -45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 332,
    d: "M314 -7v-78h-266v78h97v262q-6 -7 -19 -15.5t-29 -16.5t-33.5 -13.5t-31.5 -5.5v80q18 0 38 8.5t36.5 19t27.5 19.5t11 10h80v-348h89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 421,
    d: "M30 -85q0 41 6.5 71.5t22 54t41 40.5t62.5 32q23 9 46.5 18t42 19.5t30.5 24.5t12 34q0 27 -22 41t-64 14q-44 0 -75 -16t-48 -33l-51 58q8 10 24 22t39.5 22.5t54 17.5t68.5 7q81 0 122.5 -35.5t41.5 -98.5q0 -32 -13 -55t-33 -39t-43 -25.5t-43 -15.5 q-51 -16 -81 -36.5t-30 -43.5h244v-78h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 407,
    d: "M192 -90q-63 0 -106.5 20.5t-57.5 58.5l43 58q11 -20 41 -38.5t78 -18.5q42 0 72 13t30 38q0 29 -39.5 43t-108.5 14h-24v72h23q61 0 98 12t37 40q0 12 -8 21t-20 14.5t-27 8.5t-30 3q-40 0 -67.5 -13.5t-45.5 -36.5l-51 64q23 29 68 44t95 15q37 0 68 -9t54 -24.5 t36 -36.5t13 -45q0 -35 -25 -58t-70 -31q49 -7 77 -37.5t28 -71.5q0 -31 -15.5 -53.5t-40.5 -37t-58 -21.5t-67 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 409,
    d: "M242 -84v92h-221v78l246 251h54v-251h61v-78h-61v-92h-79zM98 86h147v154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 394,
    d: "M203 189q35 0 65 -10t52 -28t34.5 -43t12.5 -55q0 -32 -14 -58t-38 -45t-57.5 -29.5t-72.5 -10.5q-53 0 -95.5 19.5t-65.5 51.5l48 53q20 -22 50 -35t68 -13q40 0 67.5 18t27.5 53q0 18 -8 31.5t-20.5 22.5t-28.5 13.5t-31 4.5q-26 0 -52 -12.5t-39 -32.5h-70q5 27 13 61 t16.5 68.5t16 67t11.5 56.5h243v-79h-185l-24 -87q12 7 31 12.5t45 5.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 424,
    d: "M396 56q0 -30 -14 -57t-38 -46.5t-57 -31t-72 -11.5q-83 0 -132 51.5t-49 145.5q0 113 52 173t140 60q46 0 85 -16t64 -48l-46 -55q-16 20 -44.5 32t-61.5 12q-51 0 -82 -28.5t-33 -80.5q16 20 47.5 30t63.5 10q39 0 71.5 -10.5t56 -29.5t36.5 -44.5t13 -55.5zM217 -17 q21 0 39.5 6t33 15.5t22.5 23t8 28.5q0 30 -30 51t-74 21q-21 0 -40 -5.5t-33.5 -15.5t-22.5 -23t-8 -28t8.5 -28.5t23 -23t33.5 -15.5t40 -6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 389,
    d: "M263 258h-239v79h364l-248 -421h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 420,
    d: "M388 39q0 -28 -14.5 -51.5t-38.5 -41t-56.5 -27t-68.5 -9.5q-38 0 -70.5 10t-56.5 27.5t-37.5 41.5t-13.5 52q0 39 25.5 62.5t59.5 37.5q-27 11 -48 30.5t-21 50.5q0 26 14.5 47t37.5 36t52 23.5t58 8.5t58 -8t52 -23t37.5 -36t14.5 -46q0 -30 -20 -51t-50 -32 q38 -16 62 -40.5t24 -61.5zM307 47q0 13 -8.5 24t-22 18.5t-31 11.5t-35.5 4q-19 0 -37 -4t-31.5 -11.5t-21.5 -18.5t-8 -24q0 -14 9 -24.5t23 -18t31.5 -11.5t35.5 -4t35.5 4.5t31 12t21.5 18t8 23.5zM128 215q0 -11 7.5 -19t19 -14t26 -9t29.5 -3q14 0 28.5 3t26.5 9 t19.5 14.5t7.5 19.5q0 20 -25 32t-57 12q-33 0 -57.5 -12t-24.5 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 425,
    d: "M29 194q0 31 14 57.5t38 46t57 31t71 11.5q83 0 132 -51.5t49 -145.5q0 -113 -51.5 -173t-139.5 -60q-46 0 -85.5 16.5t-64.5 48.5l47 55q15 -21 43.5 -33t62.5 -12q51 0 82 28.5t32 80.5q-15 -20 -47 -30.5t-65 -10.5q-38 0 -70 11t-55.5 29.5t-36.5 44.5t-13 56z M208 267q-21 0 -40 -6t-33 -16t-22 -23t-8 -28t8 -27.5t22.5 -22.5t33.5 -15.5t40 -5.5t39.5 5.5t33 15.5t22.5 22.5t8 27.5t-8.5 28t-22.5 23t-33 16t-40 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colonmonetary",
    unicode: "\u20A1",
    horizAdvX: 570,
    d: "M210 6q-42 14 -75 39.5t-56 59.5t-35 74t-12 83t12 83.5t34.5 74t56 59t75.5 39.5v127h62v-114q8 1 17 1.5t19 0.5q6 0 12 -0.5t12 -0.5v113h62v-124q52 -15 90 -46.5t60 -75.5l-130 -40q-17 29 -45 44.5t-63 15.5q-29 0 -54 -11.5t-43.5 -32t-29 -49.5t-10.5 -64t11 -64 t29.5 -50t43.5 -32.5t54 -11.5q35 0 65.5 18t43.5 44l130 -40q-20 -44 -59 -76.5t-93 -48.5v-121h-62v111q-6 0 -12 -0.5t-12 -0.5q-10 0 -19 0.5t-17 1.5v-112h-62v126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "franc",
    unicode: "\u20A3",
    horizAdvX: 609,
    d: "M112 0v104h-80v91h80v515h477v-121h-340v-183h283v-112h-283v-99h112v-91h-112v-104h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lira",
    unicode: "\u20A4",
    horizAdvX: 533,
    d: "M44 430h66q-12 26 -21 52t-9 55q0 37 16 69.5t44 56.5t65.5 38t80.5 14q61 0 115.5 -28t92.5 -77l-71 -82q-25 35 -63.5 56.5t-74.5 21.5q-38 0 -61.5 -23.5t-23.5 -58.5q0 -23 9.5 -46t21.5 -48h178v-83h-142q7 -19 10 -45h132v-83h-140q-17 -53 -76 -115q21 7 39.5 9.5 t36.5 2.5q36 0 68.5 -8.5t66.5 -8.5q18 0 35.5 4t39.5 12l33 -100q-24 -14 -55 -22t-60 -8q-23 0 -45.5 4.5t-45.5 10t-46.5 10t-47.5 4.5q-26 0 -60.5 -6t-66.5 -16l-29 95q76 64 97 132h-109v83h115q-3 22 -12 45h-103v83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A6",
    unicode: "\u20A6",
    horizAdvX: 861,
    d: "M823 402h-84v-109h84v-83h-84v-210h-112l-169 210h-196v-210h-138v210h-86v83h86v109h-86v82h86v226h107l179 -226h191v225h138v-225h84v-82zM262 293h130l-88 109h-42v-109zM562 293h39v109h-126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 1150,
    d: "M40 296h175l-36 88h-139v82h106l-98 244h148l89 -244h171l-89 242h127l80 -235l80 235h128l-91 -242h172l89 244h150l-99 -244h107v-82h-141l-36 -88h177v-83h-211l-86 -213h-116l-123 298l-123 -298h-116l-87 213h-208v83zM696 296h105l32 88h-172zM347 296h104l34 88 h-170zM398 158l21 55h-41zM751 158l20 55h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 798,
    d: "M126 441q12 54 40.5 103.5t72 87t101 60t127.5 22.5q98 0 169.5 -43t106.5 -112l-106 -73q-14 30 -34 50.5t-43 32.5t-48 17.5t-49 5.5q-39 0 -70.5 -12t-55.5 -32.5t-41 -48t-26 -58.5h256l-30 -74h-239v-11q0 -21 3 -40h234l-30 -74h-183q26 -56 73.5 -91t110.5 -35 q24 0 50 6t49.5 19t43.5 33.5t32 49.5l113 -65q-17 -40 -48.5 -70.5t-71 -51.5t-84.5 -32t-88 -11q-59 0 -110.5 20t-93.5 53.5t-72.5 78.5t-47.5 96h-104l31 74h56q-3 21 -3 44v7h-70l30 74h49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 535,
    d: "M498 477h-100q0 -72 -37 -128.5t-100 -81.5l176 -267h-155l-224 350h111q39 0 64.5 36t25.5 91h-218v82h191q-14 18 -31.5 28.5t-36.5 10.5h-123v112h457v-83h-157q26 -32 41 -68h116v-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2113",
    unicode: "\u2113",
    horizAdvX: 329,
    d: "M212 91q11 0 25.5 3.5t26.5 8.5l18 -89q-22 -9 -52 -15t-53 -6q-56 0 -87.5 29t-31.5 81v507q0 28 11 51.5t30.5 41t46 27.5t56.5 10q61 0 98 -36t37 -94q0 -41 -15.5 -93.5t-41 -106.5t-58.5 -103.5t-68 -83.5v-70q0 -29 16 -45.5t42 -16.5zM248 586q0 67 -45 67 q-21 0 -35 -17t-14 -44v-247q19 26 36 58t30 64.5t20.5 63.5t7.5 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 1155,
    d: "M220 455v-455h-137v710h107l370 -466v465h137v-709h-111zM957 339q-44 0 -78.5 15.5t-58.5 41t-36.5 59.5t-12.5 71q0 38 12.5 72t36.5 59.5t58.5 40.5t78.5 15q43 0 77.5 -15t58.5 -40.5t37 -59.5t13 -72q0 -37 -12.5 -71t-36.5 -59.5t-58.5 -41t-78.5 -15.5zM870 525 q0 -45 25 -73.5t62 -28.5t61.5 29t24.5 74t-24.5 73.5t-61.5 28.5t-62 -28.5t-25 -74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "servicemark",
    unicode: "\u2120",
    horizAdvX: 790,
    d: "M598 710h129v-299h-87v187l-65 -145h-70l-65 145v-187h-87v299h128l58 -157zM269 618q-20 13 -43 21.5t-47 8.5q-43 0 -43 -21q0 -11 11 -19t49 -15q61 -11 89 -32t28 -63q0 -45 -34.5 -68t-91.5 -23q-38 0 -76.5 10.5t-67.5 28.5l35 64q22 -14 50.5 -24.5t57.5 -10.5 q44 0 44 19q0 11 -14 18t-52 16q-57 14 -83 33.5t-26 57.5q0 45 35 70.5t89 25.5q32 0 62.5 -8.5t59.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 829,
    d: "M339 625h-95v-214h-87v214h-95v87h277v-87zM629 710h129v-299h-87v187l-64 -145h-71l-64 145v-187h-87v299h128l58 -157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u2126",
    horizAdvX: 774,
    d: "M38 102h165q-72 41 -113.5 110.5t-41.5 157.5q0 68 25.5 130.5t71 110t107.5 76t135 28.5t135 -28.5t107.5 -76t71.5 -110t26 -130.5q0 -88 -42 -157.5t-114 -110.5h166v-102h-307v102q37 13 66.5 41t50.5 64t32.5 78.5t11.5 84.5q0 41 -14 81t-40.5 71.5t-64.5 50.5 t-85 19t-85 -19t-64 -50.5t-40 -71.5t-14 -81q0 -42 11 -84.5t32 -78.5t51 -64t67 -41v-102h-307v102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "estimated",
    unicode: "\u212E",
    horizAdvX: 608,
    d: "M310 36q71 0 118.5 21.5t76.5 50.5l31 -35q-37 -35 -92.5 -59t-133.5 -24q-62 0 -112.5 22t-86.5 59t-56 86t-20 103q0 55 20 105t56.5 87t87 59t111.5 22t111.5 -22.5t87 -61t56.5 -91t20 -112.5h-425v-141q27 -32 66 -50.5t84 -18.5zM310 487q-45 0 -84 -19.5 t-66 -55.5v-117h301v116q-28 37 -67 56.5t-84 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 958,
    d: "M135 47l282 329l260 342l61 -54l-273 -323l-269 -348zM288 384v-78h-229v78h78v261q-5 -7 -16 -15.5t-24.5 -16.5t-27.5 -13.5t-26 -5.5v80q16 0 32.5 8.5t30 19t22.5 19.5t9 10h81v-347h70zM742 -5q-63 0 -106.5 20t-57.5 59l43 58q11 -20 41 -39t78 -19q42 0 72 13 t30 39q0 29 -39.5 42.5t-108.5 13.5h-24v72h23q61 0 98 12.5t37 39.5q0 12 -8 21t-20 14.5t-27 8.5t-30 3q-40 0 -67.5 -13.5t-45.5 -35.5l-51 63q23 29 68 44.5t95 15.5q37 0 68 -9t54 -24.5t36 -36.5t13 -45q0 -36 -25 -59t-70 -31q49 -7 77 -37t28 -71q0 -31 -15.5 -53.5 t-40.5 -37t-58 -21.5t-67 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 984,
    d: "M40 305q0 41 7 71.5t22 53.5t39.5 40.5t60.5 32.5l46 18t41.5 20t30 24.5t11.5 33.5q0 26 -21.5 40.5t-62.5 14.5q-43 0 -73.5 -16t-47.5 -33l-50 57q8 10 23.5 22t39 22.5t53.5 17.5t67 7q79 0 120 -35t41 -98q0 -33 -13 -55.5t-32.5 -38t-42.5 -25t-42 -15.5 q-50 -15 -69.5 -36.5t-19.5 -44.5h207v-78h-335zM202 47l282 329l260 342l61 -54l-273 -323l-269 -348zM768 -5q-63 0 -106.5 20t-57.5 59l43 58q11 -20 41 -39t78 -19q42 0 72 13t30 39q0 29 -39.5 42.5t-108.5 13.5h-24v72h23q61 0 98 12.5t37 39.5q0 12 -8 21t-20 14.5 t-27 8.5t-30 3q-40 0 -67.5 -13.5t-45.5 -35.5l-51 63q23 29 68 44.5t95 15.5q37 0 68 -9t54 -24.5t36 -36.5t13 -45q0 -36 -25 -59t-70 -31q49 -7 77 -37t28 -71q0 -31 -15.5 -53.5t-40.5 -37t-58 -21.5t-67 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 954,
    d: "M148 47l282 329l260 342l61 -54l-273 -323l-269 -348zM288 384v-78h-229v78h78v261q-5 -7 -16 -15.5t-24.5 -16.5t-27.5 -13.5t-26 -5.5v80q16 0 32.5 8.5t30 19t22.5 19.5t9 10h81v-347h70zM920 123q0 -28 -14.5 -51.5t-38.5 -40.5t-56.5 -26.5t-68.5 -9.5 q-38 0 -70.5 10t-56.5 27.5t-37.5 41.5t-13.5 51q0 39 25.5 62.5t59.5 38.5q-27 11 -48 30.5t-21 50.5q0 25 14.5 46t37.5 36t52 23.5t58 8.5t58 -8t52 -23t37.5 -36t14.5 -46q0 -29 -20 -50t-50 -32q38 -16 62 -40.5t24 -62.5zM839 132q0 13 -8.5 24t-22 18.5t-31 11.5 t-35.5 4q-19 0 -37 -4.5t-31.5 -12t-21.5 -18.5t-8 -24t9 -23.5t23 -18t31.5 -11.5t35.5 -4t35.5 4t31 11.5t21.5 18.5t8 24zM660 300q0 -11 7.5 -19.5t19 -14t26 -8.5t29.5 -3q14 0 28.5 3t26.5 9t19.5 14t7.5 19q0 20 -25 32.5t-57 12.5q-33 0 -57.5 -12.5t-24.5 -32.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 963,
    d: "M204 298q-63 0 -106.5 20.5t-57.5 58.5l43 59q11 -20 41 -38.5t78 -18.5q42 0 72 12.5t30 38.5q0 29 -39.5 42.5t-108.5 13.5h-24v73h23q61 0 98 12t37 40q0 12 -8 20.5t-20 14t-27 8.5t-30 3q-40 0 -67.5 -13.5t-45.5 -35.5l-51 64q23 29 68 44t95 15q37 0 68 -9 t54 -24.5t36 -36.5t13 -46q0 -35 -25 -58t-70 -31q49 -7 77 -37t28 -71q0 -31 -15.5 -53.5t-40.5 -37.5t-58 -22t-67 -7zM180 47l282 329l260 342l61 -54l-273 -323l-269 -348zM929 123q0 -28 -14.5 -51.5t-38.5 -40.5t-56.5 -26.5t-68.5 -9.5q-38 0 -70.5 10t-56.5 27.5 t-37.5 41.5t-13.5 51q0 39 25.5 62.5t59.5 38.5q-27 11 -48 30.5t-21 50.5q0 25 14.5 46t37.5 36t52 23.5t58 8.5t58 -8t52 -23t37.5 -36t14.5 -46q0 -29 -20 -50t-50 -32q38 -16 62 -40.5t24 -62.5zM848 132q0 13 -8.5 24t-22 18.5t-31 11.5t-35.5 4q-19 0 -37 -4.5 t-31.5 -12t-21.5 -18.5t-8 -24t9 -23.5t23 -18t31.5 -11.5t35.5 -4t35.5 4t31 11.5t21.5 18.5t8 24zM669 300q0 -11 7.5 -19.5t19 -14t26 -8.5t29.5 -3q14 0 28.5 3t26.5 9t19.5 14t7.5 19q0 20 -25 32.5t-57 12.5q-33 0 -57.5 -12.5t-24.5 -32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 976,
    d: "M212 582q35 0 65 -10t52 -28t34.5 -43t12.5 -55q0 -32 -14 -58t-38 -45t-57.5 -29.5t-72.5 -10.5q-53 0 -95.5 19.5t-65.5 52.5l48 53q20 -23 50 -35.5t68 -12.5q40 0 67.5 17.5t27.5 52.5q0 18 -8 31.5t-20.5 22.5t-28.5 13.5t-31 4.5q-26 0 -52 -12.5t-39 -32.5h-70 q5 27 13 61t16.5 68.5t16 67t11.5 56.5h243v-79h-185l-24 -87q12 8 31 13t45 5zM180 47l282 329l260 342l61 -54l-273 -323l-269 -348zM942 123q0 -28 -14.5 -51.5t-38.5 -40.5t-56.5 -26.5t-68.5 -9.5q-38 0 -70.5 10t-56.5 27.5t-37.5 41.5t-13.5 51q0 39 25.5 62.5 t59.5 38.5q-27 11 -48 30.5t-21 50.5q0 25 14.5 46t37.5 36t52 23.5t58 8.5t58 -8t52 -23t37.5 -36t14.5 -46q0 -29 -20 -50t-50 -32q38 -16 62 -40.5t24 -62.5zM861 132q0 13 -8.5 24t-22 18.5t-31 11.5t-35.5 4q-19 0 -37 -4.5t-31.5 -12t-21.5 -18.5t-8 -24t9 -23.5 t23 -18t31.5 -11.5t35.5 -4t35.5 4t31 11.5t21.5 18.5t8 24zM682 300q0 -11 7.5 -19.5t19 -14t26 -8.5t29.5 -3q14 0 28.5 3t26.5 9t19.5 14t7.5 19q0 20 -25 32.5t-57 12.5q-33 0 -57.5 -12.5t-24.5 -32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 928,
    d: "M94 47l282 329l260 342l61 -54l-273 -323l-269 -348zM893 123q0 -28 -14.5 -51.5t-38.5 -40.5t-56.5 -26.5t-68.5 -9.5q-38 0 -70.5 10t-56.5 27.5t-37.5 41.5t-13.5 51q0 39 25.5 62.5t59.5 38.5q-27 11 -48 30.5t-21 50.5q0 25 14.5 46t37.5 36t52 23.5t58 8.5t58 -8 t52 -23t37.5 -36t14.5 -46q0 -29 -20 -50t-50 -32q38 -16 62 -40.5t24 -62.5zM812 132q0 13 -8.5 24t-22 18.5t-31 11.5t-35.5 4q-19 0 -37 -4.5t-31.5 -12t-21.5 -18.5t-8 -24t9 -23.5t23 -18t31.5 -11.5t35.5 -4t35.5 4t31 11.5t21.5 18.5t8 24zM633 300q0 -11 7.5 -19.5 t19 -14t26 -8.5t29.5 -3q14 0 28.5 3t26.5 9t19.5 14t7.5 19q0 20 -25 32.5t-57 12.5q-33 0 -57.5 -12.5t-24.5 -32.5zM279 651h-239v79h364l-248 -420h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 573,
    d: "M250 -10q-50 0 -92.5 16t-73.5 44.5t-48 66.5t-17 83q0 49 21 92.5t56.5 75.5t82 51t96.5 19q47 0 81 -17.5t51 -49.5q0 9 0.5 18t0.5 17q0 107 -32 152.5t-92 45.5q-32 0 -64.5 -11t-51.5 -30l-74 78q38 35 90 54.5t111 19.5q115 0 175.5 -79.5t60.5 -245.5 q0 -96 -20 -170.5t-57 -125.5t-88.5 -77.5t-115.5 -26.5zM258 94q25 0 49 11t42 29t29 42t11 51q0 47 -32 78t-79 31q-26 0 -50 -10t-42 -27.5t-28.5 -41t-10.5 -50.5q0 -24 8.5 -44.5t23.5 -35.5t35.5 -24t43.5 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u2206",
    horizAdvX: 628,
    d: "M622 104v-104h-615v104l252 606h112zM485 121l-170 436l-168 -436h338z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 724,
    d: "M482 594h-240v-684h-130v684h-80v116h661v-116h-80v-684h-131v684z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 563,
    d: "M519 607h-319v-4l182 -234l-197 -249v-4h342v-116h-495v91l214 265l-207 267v87h480v-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 527,
    d: "M62 274v107h403v-107h-403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 618,
    d: "M-15 56l572 662l76 -64l-571 -661z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 225,
    d: "M58 242v151h110v-151h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 538,
    d: "M8 379h198l67 -279l112 690h120l-152 -790h-161l-82 285h-102v94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 716,
    d: "M209 535q30 0 52.5 -7t40 -19t31 -27.5t25.5 -33.5q12 18 25 33.5t30.5 27.5t40.5 19t53 7q38 0 69 -14.5t53 -40t34 -59t12 -70.5q0 -38 -13 -71.5t-35.5 -58t-53.5 -39t-67 -14.5q-29 0 -51 6.5t-39.5 17t-31 24.5t-24.5 30q-22 -32 -56 -55t-95 -23q-32 0 -62.5 14.5 t-54 40t-38 58.5t-14.5 71t13 71.5t35.5 58t53.5 39t67 14.5zM218 270q37 0 59 23.5t39 56.5q-17 34 -38.5 58t-59.5 24q-14 0 -27.5 -4.5t-24.5 -14t-18 -24.5t-7 -37t7 -37.5t18 -25.5t24.5 -14.5t27.5 -4.5zM498 270q28 0 51.5 19t23.5 63q0 43 -23.5 61.5t-51.5 18.5 q-20 0 -34.5 -7t-26 -18.5t-20 -27t-16.5 -33.5q17 -32 38.5 -54t58.5 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 357,
    d: "M94 691q-3 59 30 94t96 35q30 0 65.5 -7.5t64.5 -19.5l-24 -96q-12 5 -25 9t-24 4q-25 0 -39.5 -16t-12.5 -45l38 -687q4 -62 -29.5 -95.5t-96.5 -33.5q-29 0 -64.5 7.5t-64.5 19.5l24 96q12 -5 25 -9t24 -4q25 0 39 16t12 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 449,
    d: "M396 357q-14 -26 -40 -47t-66 -21q-23 0 -40 7t-32 15.5t-29 15.5t-30 7q-20 0 -30 -7.5t-15 -17.5l-61 44q14 26 38 46t63 20q23 0 39.5 -7.5t31 -16t29 -16t32.5 -7.5q20 0 32 8t18 17zM396 199q-14 -24 -40 -44.5t-66 -20.5q-23 0 -40 7t-32 15t-29 15t-30 7 q-20 0 -30 -7.5t-15 -16.5l-61 44q14 25 38 45.5t63 20.5q23 0 39.5 -7.5t31 -16t29 -16t32.5 -7.5q20 0 32 7.5t18 17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 464,
    d: "M75 404h189l63 125l51 -27l-50 -98h60v-87h-104l-42 -82h146v-87h-190l-62 -122l-50 26l48 96h-59v87h103l42 82h-145v87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 471,
    d: "M50 28v108h353v-108h-353zM51 436l350 165v-128l-200 -80l200 -74v-130l-350 155v92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 471,
    d: "M67 28v108h354v-108h-354zM420 344l-350 -155v130l200 74l-200 80v128l350 -165v-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 563,
    d: "M356 730l186 -364l-186 -366h-148l-186 366l186 364h148zM422 354l-141 280l-132 -259l141 -283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "commaaccent",
    unicode: "\uF6C3",
    horizAdvX: 201,
    d: "M73 -213l27 72h-39v94h113v-94l-40 -72h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s_t",
    unicode: "\uFB06",
    horizAdvX: 865,
    d: "M856 27q-27 -12 -66.5 -24t-80.5 -12q-28 0 -53 7t-43.5 22.5t-29.5 40t-11 59.5v301h-68v103h68q0 43 -3 72.5t-11.5 47.5t-23.5 26t-40 8q-50 0 -72.5 -25.5t-22.5 -62.5q0 -19 5 -37.5t12 -34.5t15.5 -28t14.5 -19l-53 -84q-42 29 -78.5 40.5t-68.5 11.5 q-35 0 -61 -13t-26 -46q0 -18 9 -29.5t24.5 -19t35.5 -12t42 -8.5q49 -9 86 -20.5t62.5 -29t38.5 -42.5t13 -61q0 -42 -16 -73.5t-44.5 -52.5t-66.5 -31.5t-82 -10.5q-32 0 -65.5 5.5t-65 14.5t-60 21.5t-49.5 27.5l51 91q98 -64 185 -64q36 0 63 13t27 45q0 18 -9.5 29 t-26 18t-38.5 11.5t-46 10.5q-45 10 -80 21.5t-59 28t-36 40t-12 57.5q0 42 17 74.5t44.5 54.5t63 33.5t72.5 11.5q13 0 29.5 -1.5t34 -5t34.5 -10t32 -15.5q-11 22 -18 42.5t-7 49.5q0 30 10 56t32.5 45.5t57.5 31t85 11.5q62 0 98 -14t54 -41t22.5 -67t4.5 -92h110v-103 h-110v-256q0 -28 14.5 -39.5t37.5 -11.5q20 0 39.5 7t32.5 12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.denominator",
    horizAdvX: 410,
    d: "M242 0v93h-221v77l246 252h54v-251h61v-78h-61v-93h-79zM98 171h147v153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numerator",
    horizAdvX: 298,
    d: "M277 384v-78h-229v78h78v261q-5 -7 -16 -15.5t-24.5 -16.5t-27.5 -13.5t-26 -5.5v80q16 0 32.5 8.5t30 19t22.5 19.5t9 10h81v-347h70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.denominator",
    horizAdvX: 422,
    d: "M30 0q0 41 7 71.5t22.5 53.5t40.5 40.5t62 32.5q23 9 46.5 18t42 20t30.5 24.5t12 33.5q0 26 -22 40.5t-64 14.5q-44 0 -75 -16.5t-48 -33.5l-51 58q8 10 24 22t39.5 22.5t54 17.5t68.5 7q81 0 122.5 -35t41.5 -98q0 -32 -13 -54.5t-33 -38t-43 -25t-43 -15.5 q-51 -16 -77 -37.5t-30 -44.5h240v-78h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numerator",
    horizAdvX: 407,
    d: "M192 298q-63 0 -106.5 20.5t-57.5 58.5l43 59q11 -20 41 -38.5t78 -18.5q42 0 72 12.5t30 38.5q0 29 -39.5 42.5t-108.5 13.5h-24v73h23q61 0 98 12t37 40q0 12 -8 20.5t-20 14t-27 8.5t-30 3q-40 0 -67.5 -13.5t-45.5 -35.5l-51 64q23 29 68 44t95 15q37 0 68 -9 t54 -24.5t36 -36.5t13 -46q0 -35 -25 -58t-70 -31q49 -7 77 -37t28 -71q0 -31 -15.5 -53.5t-40.5 -37.5t-58 -22t-67 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron.alt",
    horizAdvX: 255,
    d: "M133 585l-86 26l54 119h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelow",
    horizAdvX: 221,
    d: "M50 -196v126h121v-126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.denominator",
    horizAdvX: 407,
    d: "M192 -5q-63 0 -106.5 20t-57.5 59l43 58q11 -20 41 -39t78 -19q42 0 72 13t30 39q0 29 -39.5 42.5t-108.5 13.5h-24v72h23q61 0 98 12.5t37 39.5q0 12 -8 21t-20 14.5t-27 8.5t-30 3q-40 0 -67.5 -13.5t-45.5 -35.5l-51 63q23 29 68 44.5t95 15.5q37 0 68 -9t54 -24.5 t36 -36.5t13 -45q0 -36 -25 -59t-70 -31q49 -7 77 -37t28 -71q0 -31 -15.5 -53.5t-40.5 -37t-58 -21.5t-67 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numerator",
    horizAdvX: 416,
    d: "M30 305q0 41 7 71.5t22.5 53.5t40.5 40.5t61 32.5q23 9 46.5 18t42.5 20t31 24.5t12 33.5q0 26 -22 40.5t-64 14.5q-44 0 -75 -16t-48 -33l-51 57q8 10 24 22t39.5 22.5t54 17.5t68.5 7q81 0 122.5 -35t41.5 -98q0 -33 -13.5 -55.5t-33 -38t-43 -25t-42.5 -15.5 q-51 -15 -71 -36.5t-20 -44.5h211v-78h-341z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.denominator",
    horizAdvX: 420,
    d: "M388 123q0 -28 -14.5 -51.5t-38.5 -40.5t-56.5 -26.5t-68.5 -9.5q-38 0 -70.5 10t-56.5 27.5t-37.5 41.5t-13.5 51q0 39 25.5 62.5t59.5 38.5q-27 11 -48 30.5t-21 50.5q0 25 14.5 46t37.5 36t52 23.5t58 8.5t58 -8t52 -23t37.5 -36t14.5 -46q0 -29 -20 -50t-50 -32 q38 -16 62 -40.5t24 -62.5zM307 132q0 13 -8.5 24t-22 18.5t-31 11.5t-35.5 4q-19 0 -37 -4.5t-31.5 -12t-21.5 -18.5t-8 -24t9 -23.5t23 -18t31.5 -11.5t35.5 -4t35.5 4t31 11.5t21.5 18.5t8 24zM128 300q0 -11 7.5 -19.5t19 -14t26 -8.5t29.5 -3q14 0 28.5 3t26.5 9 t19.5 14t7.5 19q0 20 -25 32.5t-57 12.5q-33 0 -57.5 -12.5t-24.5 -32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numerator",
    horizAdvX: 394,
    d: "M203 582q35 0 65 -10t52 -28t34.5 -43t12.5 -55q0 -32 -14 -58t-38 -45t-57.5 -29.5t-72.5 -10.5q-53 0 -95.5 19.5t-65.5 52.5l48 53q20 -23 50 -35.5t68 -12.5q40 0 67.5 17.5t27.5 52.5q0 18 -8 31.5t-20.5 22.5t-28.5 13.5t-31 4.5q-26 0 -52 -12.5t-39 -32.5h-70 q5 27 13 61t16.5 68.5t16 67t11.5 56.5h243v-79h-185l-24 -87q12 8 31 13t45 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numerator",
    horizAdvX: 389,
    d: "M263 651h-239v79h364l-248 -420h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R.sc",
    horizAdvX: 594,
    d: "M68 0v559h275q43 0 79 -16.5t62.5 -43t41 -60.5t14.5 -68q0 -53 -30 -97t-81 -65l146 -209h-138l-130 183h-118v-183h-121zM189 289h151q33 0 55.5 23.5t22.5 58.5q0 18 -7 33t-18.5 26t-26.5 17t-31 6h-146v-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lnum",
    horizAdvX: 604,
    d: "M560 210q0 -50 -20.5 -90t-56 -69t-82.5 -44.5t-100 -15.5t-100 16.5t-82 46.5t-55 71t-20 90q0 30 10 55.5t26 46.5t35.5 37t39.5 26q-37 18 -63 54t-26 79q0 48 21.5 84.5t56 61.5t76 38t82.5 13q40 0 82.5 -12.5t76.5 -37.5t56 -61.5t22 -84.5q0 -21 -7 -41.5 t-19.5 -38t-29.5 -31.5t-36 -23q22 -11 42 -27.5t36 -38t25.5 -47.5t9.5 -57zM424 218q0 25 -10.5 45t-28 33.5t-39.5 20.5t-45 7q-24 0 -46 -7.5t-38.5 -21.5t-26.5 -33.5t-10 -43.5t10.5 -43.5t27.5 -33.5t39 -21.5t45 -7.5q24 0 46 8t39 22t27 33.5t10 42.5zM202 509 q0 -21 9 -36.5t23.5 -26t32 -16t35.5 -5.5q17 0 35 5.5t32.5 16.5t23.5 26.5t9 36.5q0 37 -29.5 59t-71.5 22q-41 0 -70 -22.5t-29 -59.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numerator",
    horizAdvX: 420,
    d: "M388 432q0 -28 -14.5 -51.5t-38.5 -41t-56.5 -27t-68.5 -9.5q-38 0 -70.5 10t-56.5 27.5t-37.5 41.5t-13.5 52q0 39 25.5 62.5t59.5 37.5q-27 11 -48 30.5t-21 50.5q0 26 14.5 47t37.5 36t52 23.5t58 8.5t58 -8t52 -23t37.5 -36t14.5 -46q0 -30 -20 -51t-50 -32 q38 -15 62 -40t24 -62zM307 440q0 13 -8.5 24t-22 19t-31 12t-35.5 4q-19 0 -37 -4.5t-31.5 -12t-21.5 -18.5t-8 -24t9 -23.5t23 -18t31.5 -11.5t35.5 -4t35.5 4t31 11.5t21.5 18t8 23.5zM128 609q0 -11 7.5 -19.5t19 -14t26 -8.5t29.5 -3q14 0 28.5 3t26.5 8.5t19.5 14 t7.5 19.5q0 21 -25 33t-57 12q-33 0 -57.5 -12.5t-24.5 -32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S.sc",
    horizAdvX: 532,
    d: "M428 402q-8 7 -24.5 16.5t-38 17.5t-47 14t-51.5 6q-94 0 -94 -53q0 -15 8.5 -25.5t25.5 -18t42.5 -14.5t59.5 -15q44 -11 80 -24t61 -32t38.5 -45.5t13.5 -65.5q0 -47 -18.5 -79t-49.5 -52.5t-71.5 -29.5t-84.5 -9q-68 0 -135 19t-119 52l54 105q10 -10 29.5 -22 t46.5 -22t59 -16.5t67 -6.5q45 0 68.5 13t23.5 36q0 16 -11 27t-31 20t-48.5 16.5t-63.5 16.5q-86 22 -127.5 56.5t-41.5 99.5q0 43 17.5 76t47.5 55t70 33.5t85 11.5q63 0 117.5 -19t93.5 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I.sc",
    horizAdvX: 257,
    d: "M68 0v559h121v-559h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w.alt",
    horizAdvX: 871,
    d: "M536 0l-101 316l-100 -316h-144l-181 524h139l120 -364l104 364h126l104 -364l120 364h137l-179 -524h-145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y.alt",
    horizAdvX: 551,
    d: "M538 524l-254 -737h-155q0 1 9.5 26t23 59t27.5 70t24 58l-207 524h138l142 -408l126 408h126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E.sc",
    horizAdvX: 535,
    d: "M499 106v-106h-431v559h423v-106h-302v-119h261v-99h-261v-129h310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.denominator",
    horizAdvX: 487,
    d: "M244 -5q-53 0 -93 20t-66.5 51t-40 68.5t-13.5 73.5q0 38 15 76t42.5 68.5t67 49.5t88.5 19q52 0 91.5 -20.5t66 -51.5t40 -69t13.5 -72q0 -39 -14.5 -77t-42 -68t-66.5 -49t-88 -19zM113 208q0 -24 8 -47.5t24.5 -43t41 -31.5t57.5 -12q34 0 58.5 13t40.5 32.5 t23.5 43.5t7.5 45q0 24 -8.5 47.5t-25 43t-40.5 31.5t-56 12q-34 0 -59 -13t-41 -33t-23.5 -43.5t-7.5 -44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lnum",
    horizAdvX: 701,
    d: "M350 -10q-76 1 -133.5 34.5t-96.5 86t-58.5 116t-19.5 123.5q0 64 21.5 128.5t61.5 116t97 83.5t128 32q76 0 134 -34.5t97 -87.5t58.5 -116.5t19.5 -121.5q0 -65 -21.5 -129t-61.5 -115.5t-97 -83.5t-129 -32zM181 350q1 -42 11.5 -84t31 -76.5t52 -56t74.5 -21.5 q45 0 77 23t52.5 58.5t30.5 77t10 79.5q0 42 -11 84t-32 76.5t-53 56t-74 21.5q-44 0 -76 -23t-52.5 -58.5t-30.5 -77.5t-10 -79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numerator",
    horizAdvX: 487,
    d: "M244 303q-53 0 -93 20t-66.5 51t-40 69t-13.5 73q0 38 15 76.5t42.5 69t67 49.5t88.5 19q52 0 91.5 -20.5t66 -52t40 -69.5t13.5 -72q0 -38 -14.5 -76t-42 -68.5t-66.5 -49.5t-88 -19zM113 516q0 -23 8 -47t24.5 -43t41 -31t57.5 -12q34 0 58.5 13t40.5 32.5t23.5 43 t7.5 44.5q0 24 -8.5 48t-25 43.5t-40.5 31.5t-56 12q-34 0 -59 -13t-41 -33t-23.5 -44t-7.5 -45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T.sc",
    horizAdvX: 550,
    d: "M533 453h-197v-453h-121v453h-198v106h516v-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.denominator",
    horizAdvX: 394,
    d: "M203 273q35 0 65 -10t52 -28t34.5 -43t12.5 -55q0 -32 -14 -58t-38 -44.5t-57 -29t-72 -10.5q-53 0 -95.5 19t-65.5 52l47 53q20 -23 50 -36t68 -13q41 0 68.5 18t27.5 53q0 18 -8 31.5t-21 22.5t-29 13.5t-31 4.5q-26 0 -52 -12.5t-38 -32.5h-70q5 27 13 61t16.5 68.5 t16 67.5t11.5 57h242v-80h-184l-25 -87q12 8 31 13t45 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lnum",
    horizAdvX: 569,
    d: "M297 459q50 0 93 -17t74.5 -47t49 -72t17.5 -92q0 -54 -19.5 -98t-54.5 -76t-83 -49.5t-105 -17.5q-78 0 -139 33t-94 91l77 80q29 -39 70.5 -62t86.5 -23q54 0 88.5 32.5t34.5 86.5q0 25 -8.5 46.5t-24 37t-36.5 24t-46 8.5q-32 0 -61 -15t-46 -41h-117q0 3 4 22.5 t10 50t13 68t15 76.5q18 91 40 205h350v-122h-253l-28 -159q12 14 35 22t57 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U.sc",
    horizAdvX: 654,
    d: "M326 103q42 0 70.5 14.5t45.5 38.5t24 54.5t7 62.5v286h121v-286q0 -58 -15.5 -108.5t-47.5 -88t-83 -59t-121 -21.5q-73 0 -123.5 22.5t-82.5 61t-46.5 88.5t-14.5 105v286h121v-286q0 -33 7.5 -63.5t24.5 -54.5t44.5 -38t68.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lnum",
    horizAdvX: 586,
    d: "M325 0v161h-299v120l341 429h92v-428h88v-121h-88v-161h-134zM161 282h179v226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B.sc",
    horizAdvX: 596,
    d: "M562 143q0 -35 -16 -62t-43 -45t-63 -27t-76 -9h-296v559h329q32 0 57.5 -12.5t43.5 -33t28 -46t10 -52.5q0 -40 -22.5 -75.5t-64.5 -52.5q52 -14 82.5 -50.5t30.5 -93.5zM440 168q0 27 -20 47t-50 20h-181v-133h175q32 0 54 18.5t22 47.5zM189 455v-125h157 q29 0 49.5 16t20.5 47q0 29 -19 45.5t-46 16.5h-162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numerator",
    horizAdvX: 410,
    d: "M242 310v91h-221v78l246 251h54v-251h61v-78h-61v-91h-79zM98 479h147v154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V.sc",
    horizAdvX: 595,
    d: "M131 559l167 -389l166 389h127l-242 -559h-102l-243 559h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.alt",
    horizAdvX: 1109,
    d: "M1100 710l-223 -710h-142l-182 485l-178 -485h-143l-222 710h155l152 -504l161 504h149l166 -503l150 503h157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J.sc",
    horizAdvX: 438,
    d: "M39 124q12 -6 41 -15.5t67 -9.5q36 0 58 10.5t33 32t14.5 55t3.5 78.5v284h121v-284q0 -64 -7 -116.5t-31 -89.5t-69.5 -57t-122.5 -20q-80 0 -135 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.sc",
    horizAdvX: 926,
    d: "M281 557h112l69 -181l71 181h112l-106 -257l73 -155l180 414h132l-252 -559h-102l-107 225l-107 -225h-102l-252 559h131l182 -414l70 155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j.alt",
    horizAdvX: 255,
    d: "M61 517h134v-730h-134v730zM61 726h133v-129h-133v129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K.sc",
    horizAdvX: 594,
    d: "M68 0v559h121v-261l267 261h127l-238 -249l252 -310h-127l-198 242l-83 -74v-168h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X.sc",
    horizAdvX: 576,
    d: "M134 559l154 -198l154 198h131l-221 -283l214 -276h-131l-147 190l-146 -190h-133l215 276l-222 283h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C.sc",
    horizAdvX: 593,
    d: "M32 284q0 51 20 101t58 89t93 63.5t126 24.5q83 0 143.5 -33.5t89.5 -88.5l-93 -65q-11 23 -27.5 38t-36 24t-40 13t-39.5 4q-43 0 -75 -15.5t-53.5 -40t-32.5 -56t-11 -62.5q0 -35 12.5 -67t35.5 -56.5t55 -39t71 -14.5q20 0 41 4.5t40.5 14t36 25t26.5 37.5l100 -59 q-14 -31 -41 -55.5t-60.5 -41t-71.5 -25t-75 -8.5q-65 0 -118.5 25t-92 66t-60 92.5t-21.5 105.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y.sc",
    horizAdvX: 577,
    d: "M135 559l153 -261l154 261h132l-226 -366v-193h-120v194l-224 365h131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l.alt",
    horizAdvX: 261,
    d: "M63 730h134v-730h-134v730z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L.sc",
    horizAdvX: 486,
    d: "M68 0v559h121v-453h286v-106h-407z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z.sc",
    horizAdvX: 562,
    d: "M33 91l349 362h-339v106h480v-91l-338 -362h340v-106h-492v91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.denominator",
    horizAdvX: 425,
    d: "M29 278q0 31 14 57.5t38 46.5t57 31.5t71 11.5q83 0 132 -51.5t49 -145.5q0 -113 -51.5 -173t-139.5 -60q-46 0 -85.5 16t-64.5 48l47 55q15 -21 43.5 -32.5t62.5 -11.5q51 0 82 28t32 80q-15 -19 -47 -30t-65 -11q-38 0 -70 11t-55.5 29.5t-36.5 44.5t-13 56zM208 352 q-21 0 -40 -6t-33 -16.5t-22 -23.5t-8 -28t8 -27.5t22.5 -22.5t33.5 -15.5t40 -5.5t39.5 5.5t33 15.5t22.5 22.5t8 27.5t-8.5 28t-22.5 23.5t-33 16.5t-40 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lnum",
    horizAdvX: 607,
    d: "M40 468q0 52 20 97t55 78.5t82.5 52.5t102.5 19q60 0 108.5 -22t82 -63.5t52 -102t18.5 -137.5q0 -97 -19.5 -171.5t-55 -125.5t-86.5 -77t-114 -26q-67 0 -123.5 29.5t-95.5 83.5l77 84q24 -38 61.5 -59t82.5 -21q67 0 107 53t42 150q-21 -36 -60 -57t-89 -21 q-53 0 -98 18t-78.5 50t-52.5 75t-19 93zM299 603q-27 0 -50.5 -11t-41 -29t-28 -42.5t-10.5 -51.5t10.5 -50.5t28 -41.5t41.5 -28t51 -10t51 10t41.5 27.5t28 41t10.5 50.5t-10.5 51.5t-28.5 43t-42 29.5t-51 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt",
    horizAdvX: 635,
    d: "M277 -10q-54 0 -99.5 21t-78.5 58t-51.5 86.5t-18.5 106.5t18 106.5t49.5 86t74.5 57.5t93 21q59 0 105 -27.5t72 -74.5v86h134v-517h-134v85q-26 -45 -66.5 -70t-97.5 -25zM441 316q-18 46 -54.5 74.5t-80.5 28.5q-30 0 -55.5 -13.5t-44 -36t-28.5 -51t-10 -59.5 q0 -32 10.5 -60.5t29.5 -49.5t45.5 -33t57.5 -12q45 0 77.5 24t52.5 64v124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numerator",
    horizAdvX: 423,
    d: "M28 583q0 31 14 57.5t38 46.5t57 31.5t72 11.5q82 0 131 -51.5t49 -145.5q0 -113 -51 -173.5t-140 -60.5q-46 0 -85.5 17t-64.5 48l47 55q16 -21 44 -33t62 -12q51 0 82 29t33 80q-16 -19 -48 -29.5t-64 -10.5q-38 0 -70.5 11t-56 29.5t-36.5 44t-13 55.5zM207 657 q-21 0 -39.5 -6t-33 -16t-22.5 -23.5t-8 -28.5t8 -27.5t22.5 -22.5t33.5 -15.5t40 -5.5t40 5.5t33 15.5t22 22.5t8 27.5t-8 28.5t-22.5 23.5t-33.5 16t-40 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt2",
    horizAdvX: 565,
    d: "M381 0v73q-30 -42 -76 -62.5t-101 -20.5q-38 0 -71 12.5t-57 35t-37.5 52.5t-13.5 66q0 40 18 71.5t49 53.5t71 33t85 11q42 0 75 -7t53 -16v30q0 51 -29.5 79.5t-87.5 28.5q-42 0 -82 -15t-82 -44l-41 85q48 32 102.5 49.5t115.5 17.5q115 0 176.5 -56.5t61.5 -159.5 v-317h-129zM354 132q22 17 22 38v60q-25 10 -53 15t-53 5q-22 0 -43.5 -5t-38 -15.5t-26.5 -26t-10 -36.5q0 -35 26.5 -57t63.5 -22q30 0 61.5 10.5t50.5 33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M.sc",
    horizAdvX: 763,
    d: "M574 0v349l-160 -256h-66l-159 256v-349h-121v559h131l183 -302l183 302h129v-559h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N.sc",
    horizAdvX: 673,
    d: "M189 335v-335h-121v559h94l322 -344v344h121v-559h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.denominator",
    horizAdvX: 333,
    d: "M314 78v-78h-266v78h97v262q-6 -7 -19 -16t-29 -16.5t-33.5 -13t-31.5 -5.5v79q18 0 38 8.5t36.5 19t27.5 19.5t11 10h80v-347h89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lnum",
    horizAdvX: 490,
    d: "M468 121v-121h-402v121h138v462q-8 -12 -26.5 -26.5t-42 -28t-48 -22.5t-44.5 -9v124q27 0 55 14.5t51.5 32t38.5 32.5t16 17h137v-596h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F.sc",
    horizAdvX: 510,
    d: "M68 0v559h417v-106h-296v-130h247v-99h-247v-224h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O.sc",
    horizAdvX: 653,
    d: "M326 -4q-66 0 -120 24t-93 64t-60 91t-21 105q0 55 22 106t61.5 90t94 62.5t118.5 23.5q66 0 120 -24.5t92.5 -64.5t59.5 -91.5t21 -104.5q0 -55 -22 -106t-61.5 -90t-93.5 -62t-118 -23zM154 279q0 -34 12 -65.5t34 -56t54 -39.5t73 -15q42 0 73.5 15.5t53.5 40.5 t33 56.5t11 64.5q0 34 -12 65.5t-34.5 55.5t-54 38.5t-71.5 14.5q-41 0 -73 -15.5t-54 -40t-33.5 -56t-11.5 -63.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q.alt",
    horizAdvX: 634,
    d: "M259 -10q-50 0 -92 21.5t-72.5 58.5t-47.5 86.5t-17 106.5t18.5 106t51.5 85.5t78 57.5t97 21q60 0 106 -27.5t75 -72.5v91h117v-737h-134v305q-29 -51 -75 -76.5t-105 -25.5zM309 104q43 0 75 24t55 62v124q-6 22 -19.5 41t-31.5 33.5t-39 22.5t-42 8q-31 0 -56.5 -13 t-44 -35.5t-29 -51.5t-10.5 -60q0 -33 10.5 -61t29 -49t44.5 -33t58 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.alt",
    horizAdvX: 721,
    d: "M381 -5q-77 0 -141 30.5t-110.5 81.5t-72 116.5t-25.5 135.5q0 69 24.5 133t69.5 113.5t108.5 79.5t142.5 30q91 0 160.5 -39.5t110.5 -109.5l-109 -86q-8 15 -22.5 34.5t-35.5 37t-48.5 29.5t-63.5 12q-48 0 -84.5 -20.5t-62 -54t-38.5 -76.5t-13 -87q0 -42 12.5 -84.5 t37 -76.5t61.5 -55.5t86 -21.5q34 0 64.5 11.5t54.5 31t40 44t23 51.5h-155v120h304v-11t-0.5 -22t-0.5 -22.5v-11.5q-3 -63 -26.5 -120t-65 -100t-99 -68t-126.5 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c_t",
    horizAdvX: 947,
    d: "M938 27q-27 -12 -66 -24t-83 -12q-27 0 -51.5 7t-43 22.5t-29.5 40t-11 59.5v301h-69v103h69q0 36 -2.5 65t-11 48.5t-25.5 30t-47 10.5q-47 0 -67 -27.5t-20 -66.5q0 -24 7 -51t16.5 -52t19.5 -47t17 -35l-131 -40q-18 30 -46 45t-63 15q-30 0 -55 -12.5t-43 -34 t-27.5 -50t-9.5 -61.5q0 -34 10.5 -62.5t29 -49.5t44 -33t54.5 -12q32 0 63.5 16.5t44.5 45.5l131 -40q-28 -62 -91.5 -99t-147.5 -37q-65 0 -116 22.5t-86.5 60t-54.5 87t-19 102.5t18.5 102t53.5 86.5t87 60t119 22.5q48 0 80.5 -10t64.5 -30q-11 23 -19 47t-8 50 q0 69 46 108.5t136 39.5q68 0 105 -18.5t54 -48.5t20 -68.5t3 -78.5h110v-103h-110v-256q0 -28 14.5 -39.5t36.5 -11.5q20 0 40 7t32 12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.sc",
    horizAdvX: 620,
    d: "M477 57q-70 -61 -162 -61q-59 0 -110.5 23.5t-90 63.5t-60.5 91.5t-22 108.5q0 58 22 109t61 89t92.5 60t115.5 22q84 0 144 -33t90 -89l-92 -68q-21 39 -60 60.5t-86 21.5q-37 0 -67.5 -14t-52 -38t-33.5 -56t-12 -68q0 -38 13 -70t36 -55t54.5 -36.5t68.5 -13.5 q83 0 151 71v27h-124v88h224v-290h-100v57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.denominator",
    horizAdvX: 388,
    d: "M263 342h-239v80h364l-248 -422h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lnum",
    horizAdvX: 563,
    d: "M356 588h-322v122h534l-353 -710h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.denominator",
    horizAdvX: 424,
    d: "M396 141q0 -31 -14 -57.5t-38 -46t-57 -31t-72 -11.5q-83 0 -132 51t-49 145q0 113 52 173.5t140 60.5q46 0 85 -16.5t64 -48.5l-46 -55q-16 21 -44.5 32.5t-61.5 11.5q-51 0 -82 -28t-33 -80q16 20 47.5 30t63.5 10q39 0 71.5 -11t56 -29.5t36.5 -44t13 -55.5zM217 67 q21 0 39.5 6t33 16t22.5 23t8 28q0 30 -30 51t-74 21q-21 0 -40 -5.5t-33.5 -15.5t-22.5 -22.5t-8 -27.5t8.5 -28.5t23 -23.5t33.5 -16t40 -6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lnum",
    horizAdvX: 607,
    d: "M567 237q0 -52 -20 -97t-55 -78.5t-82.5 -52.5t-102.5 -19q-60 0 -108.5 22t-82.5 64t-52 102.5t-18 137.5q0 97 19 171.5t55 125t87 76.5t114 26q67 0 123.5 -29t95.5 -83l-77 -84q-24 38 -62 59t-82 21q-67 0 -107 -53t-42 -150q21 36 59.5 57t89.5 21q52 0 97.5 -18 t79 -50t52.5 -75.5t19 -93.5zM308 103q26 0 50 10.5t42 29t28.5 43t10.5 51.5t-10.5 50.5t-28.5 41.5t-41.5 28t-50.5 10t-51 -10t-42 -28t-28 -41.5t-10 -50.5t10.5 -51.5t28.5 -42.5t41.5 -29t50.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numerator",
    horizAdvX: 423,
    d: "M395 446q0 -31 -14 -57.5t-38 -46.5t-57 -31.5t-72 -11.5q-82 0 -131 51.5t-49 145.5q0 113 51.5 173.5t139.5 60.5q46 0 85.5 -16.5t63.5 -47.5l-46 -56q-15 21 -44 33t-62 12q-51 0 -82 -28.5t-32 -80.5q15 20 47 30t64 10q39 0 71 -11t55.5 -29.5t36.5 -44t13 -55.5z M216 372q21 0 40 6t33.5 16t22.5 23.5t8 28.5q0 30 -30.5 50.5t-73.5 20.5q-22 0 -41 -5.5t-33.5 -15t-22.5 -22.5t-8 -28t8.5 -28.5t23 -23.5t33.5 -16t40 -6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D.sc",
    horizAdvX: 634,
    d: "M68 0v559h226q76 0 133 -22t95.5 -59.5t58 -88t19.5 -108.5q0 -64 -22 -116t-62 -88.5t-96.5 -56.5t-125.5 -20h-226zM477 281q0 76 -47.5 124t-135.5 48h-105v-347h105q45 0 79 13t57 36.5t35 55.5t12 70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t.alt",
    horizAdvX: 379,
    d: "M104 0v403h-78v121h78v170h138v-170h121v-121h-121v-403h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lnum",
    horizAdvX: 585,
    d: "M273 -9q-87 0 -147.5 36t-84.5 103l71 88q3 -14 14 -31.5t30.5 -34t48 -27.5t66.5 -11q26 0 49.5 6.5t41.5 18.5t28.5 29.5t10.5 40.5q0 51 -54 76t-151 25h-33v112h33q40 0 74 5.5t59 17t39 29.5t14 43q0 22 -9.5 38t-24.5 26t-33.5 15t-36.5 5q-30 0 -55 -7.5t-44 -19 t-32.5 -26t-21.5 -28.5l-86 97q17 24 43 43t58 32t67 20t70 7q54 0 99.5 -15t78.5 -41.5t51.5 -62t18.5 -76.5q0 -60 -36 -98.5t-98 -52.5q34 -6 61.5 -22.5t47 -41t30 -55t10.5 -63.5q0 -51 -23 -88.5t-60.5 -62t-85.5 -37t-98 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d.alt",
    horizAdvX: 634,
    d: "M440 0v82q-26 -44 -67 -68t-95 -24t-100 21t-79 58t-51.5 86.5t-18.5 106.5t17.5 106t48.5 86t74 58t93 21q59 0 105 -28t73 -73v298h134v-730h-134zM440 317q-17 45 -55.5 73.5t-80.5 28.5q-30 0 -55 -13.5t-43 -35.5t-28 -51t-10 -60q0 -33 11 -61t30.5 -49t45.5 -33 t57 -12q20 0 40 6.5t37.5 18.5t31 28t19.5 35v125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lnum",
    horizAdvX: 608,
    d: "M41 0q0 69 9.5 120.5t31 90.5t56.5 68t86 54q33 16 65 30.5t58 33.5t42 43.5t16 59.5q0 45 -27.5 71.5t-77.5 26.5q-28 0 -53.5 -8t-47.5 -20.5t-40 -27.5t-31 -29l-84 88q13 16 38 36.5t59.5 38.5t78.5 30.5t97 12.5q58 0 102.5 -16t75 -44.5t46 -68.5t15.5 -88 q0 -46 -14 -79.5t-37.5 -59.5t-55 -45.5t-67.5 -36.5q-38 -19 -68.5 -36.5t-52 -36.5t-33 -40t-11.5 -47h340v-121h-516z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A.sc",
    horizAdvX: 593,
    d: "M3 0l244 559h99l243 -559h-128l-56 131h-217l-56 -131h-129zM297 412l-82 -176h161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P.sc",
    horizAdvX: 552,
    d: "M68 0v559h263q43 0 79.5 -16.5t62.5 -43t41 -60.5t15 -68q0 -36 -14 -70t-39.5 -60t-61 -42t-78.5 -16h-147v-183h-121zM189 289h139q34 0 56 21t22 61q0 41 -25.5 61.5t-57.5 20.5h-134v-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u.alt",
    horizAdvX: 607,
    d: "M417 0v90q-29 -51 -80 -75.5t-108 -24.5q-47 0 -80 14.5t-53.5 41.5t-30 65t-9.5 85v328h134v-299q0 -26 4.5 -48.5t15 -38.5t28 -25t43.5 -9q38 0 73.5 25t57.5 70v325h134v-524h-129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H.sc",
    horizAdvX: 658,
    d: "M590 559v-559h-121v232h-280v-232h-121v559h121v-220h280v220h121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q.sc",
    horizAdvX: 653,
    d: "M482 38q-33 -20 -72 -31t-84 -11q-66 0 -120 24t-93 64t-60 91t-21 105q0 55 22 106.5t61.5 90.5t94 62.5t118.5 23.5q66 0 120 -24.5t92.5 -65t59.5 -92t21 -104.5q0 -52 -20 -100t-55 -86l87 -91h-114zM327 104q42 0 76 17l-90 94h116l37 -40q32 47 32 105 q0 34 -12 65.5t-34.5 56t-54 39t-71.5 14.5q-41 0 -73 -15.5t-54 -40.5t-33.5 -56.5t-11.5 -63.5q0 -34 12 -65.5t34 -56t54 -39t73 -14.5z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "A.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "Y.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "J.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "V.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "T.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "y.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "w.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0394",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0142",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "v",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "#",
    u2: "4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "$",
    u2: "7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "$",
    u2: "3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "Y.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "W.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "V.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "T.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "y.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0166",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "X",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "six.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "Y.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "V.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "four.lnum",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "U.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "zero.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "y.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u04B1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0431",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0424",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0259",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u018F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012B",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0129",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "(",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ")",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "A.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "J.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "S.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0455",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u044F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0434",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0430",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0414",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0410",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0408",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0394",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0259",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u018F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u012B",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0129",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "two.lnum",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "three.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "seven.lnum",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "one.lnum",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "A.sc",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "six.lnum",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "Y.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "J.sc",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "V.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "four.lnum",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "U.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "zero.lnum",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "S.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0455",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0447",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0437",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0436",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0434",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0431",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0430",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u042F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0424",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0414",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0410",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0408",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03BC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0394",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0259",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u018F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u012B",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0129",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "9",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "5",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "4",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 247
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\xB0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\\\\\\\\",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ")",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xF7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\\\\\\\\",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "+",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    g2: "W.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\xF7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\xB0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\\\\\\\\",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "V",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    g2: "W.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xB0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\\\\\\\\",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    g2: "W.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xB0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\\\\\\\\",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "+",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2212",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xF7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "+",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2212",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xF7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xD7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xB7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xA2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "=",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "+",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "V",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\xB0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\\\\\\\\",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    g2: "seven.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "Y.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "V.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "T.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "A.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "J.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u02BC",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0166",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "x",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0142",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0131",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u012B",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "A.sc",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Z.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Y.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "X.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "W.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "J.sc",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "V.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "U.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "T.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "y.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "w.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "S.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "f_f_l",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "f_f_i",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "f_f",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0259",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u018F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0131",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u012B",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0129",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xDF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "@",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "7",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "5",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "4",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "3",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "2",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "&",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u012B",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0129",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0104",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0166",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "A.sc",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "J.sc",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u02BC",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0259",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "4",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: " ",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_l",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_i",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_i",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0165",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0159",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0131",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0129",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "A.sc",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "J.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "U.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "S.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u02BC",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0259",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u018F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0131",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012B",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0129",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xA9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "@",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "4",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: " ",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0159",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0131",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u012B",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0129",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "Y.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "W.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "V.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "U.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "y.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "w.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u02BC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0259",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u018F",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u012B",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0129",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xAE",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xA9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: " ",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0159",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0131",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u012B",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0129",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0131",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u012B",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0129",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "Y.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.alt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "V.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "T.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "zero.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "y.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "w.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u04B1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u04B0",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u044A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0447",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0442",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u042A",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0427",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0424",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0422",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0416",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u018F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0166",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "v",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "V",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0135",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012D",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012B",
    k: -106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0129",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEF",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEE",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEC",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u0135",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "W",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0135",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "j",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "W",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u02BC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0259",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF0",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "X",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: " ",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0259",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xF0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0135",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "j",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA1",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA3",
    g2: "four.lnum",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0135",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "j",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u0166",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    g2: "four.lnum",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "3",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "seven.lnum",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "one.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "3",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0166",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "A.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "t.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Z.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "l.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Y.sc",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "X.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "J.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.alt",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "V.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "U.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "T.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "y.alt",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "w.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "S.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0259",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u018F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0166",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0142",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0141",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0135",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u012F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0126",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0110",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xF0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xD0",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "v",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "j",
    k: -86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC6",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC8",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC9",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCA",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCB",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    g2: "seven.lnum",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "A.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "J.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "W.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2122",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\\\\\\\\",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "*",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ")",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "y.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "x",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\\\\\\\\",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "X",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "W.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "y.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "x",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "v",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "V",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "seven.lnum",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "one.lnum",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "3",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "j",
    k: -89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "j",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0108",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2122",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u201D",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2019",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0133",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xFE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "}",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "k",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "i",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "h",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "b",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "]",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\\\\\\\\",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: ")",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0112",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0114",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0116",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\u01FC",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\xC6",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011A",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011C",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011D",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011F",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0121",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0123",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "A.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "d.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "q.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "a.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0121",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xF0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "q",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "g",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "d",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2122",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u201D",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2019",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "}",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "]",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\\\\\\\\",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "*",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: ")",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u2122",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\\\\\\\\",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "*",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: ")",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "j",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "j",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "j",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u012B",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u0104",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0166",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0166",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "j",
    k: -76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0166",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2122",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\\\\\\\\",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "j",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\u01FC",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\xC6",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015C",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_l",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_i",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_i",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "j",
    k: -126
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_l",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_i",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_i",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Q.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "H.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "u.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "P.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "A.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "d.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "D.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "O.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "F.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "N.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "M.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt2",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Z.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "L.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Y.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "C.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "X.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "K.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "W.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "V.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "B.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "U.sc",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "E.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "w.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "I.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "S.sc",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "R.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\uFB06",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_l",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_i",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u203A",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2039",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u1ECC",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FA",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01F4",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u018F",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0153",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0152",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0150",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014E",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0122",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0120",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011E",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010A",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0108",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0106",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0104",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0102",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0100",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD8",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD6",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD5",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD4",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD3",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD2",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC7",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC5",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC4",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC3",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC2",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC1",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC0",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xBB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xA9",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "z",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "y",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "x",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "w",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "v",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "u",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "s",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "r",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "q",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "p",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "o",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "n",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "m",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "g",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "f",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "e",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "d",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "c",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "a",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "Q",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "O",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "G",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "A",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ";",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ":",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "/",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "j",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u012B",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F5",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FC",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0218",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_l",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_i",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_i",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021B",
    u2: "j",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "A.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "t.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Z.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "l.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Y.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "X.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "W.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "J.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "V.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "U.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "y.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "w.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "S.sc",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "v",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03C0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\\\\\\\\",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "?",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "*",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BC",
    u2: "\\\\\\\\",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C0",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0445",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0442",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u042A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0427",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0425",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0414",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0410",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\\\\\\\\",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "?",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "*",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u044F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u042A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0425",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0424",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0422",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0447",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0445",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0442",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0422",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0414",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0410",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0455",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0437",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0436",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0434",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0431",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0430",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0408",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0442",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u042A",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0422",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\\\\\\\\",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "*",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B0",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0455",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u044D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u044A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0447",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0442",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0431",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0430",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u042D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u042A",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0427",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0424",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0422",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0405",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\\\\\\\\",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "?",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "*",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u044F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u044A",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0445",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0442",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0425",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0414",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0410",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "?",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04B1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04B0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u044F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0445",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0436",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0434",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u042A",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0425",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0422",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0414",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0458",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044A",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0447",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0442",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0431",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0424",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04B1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04B0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u044F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0445",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0437",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0436",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0434",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u042A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0425",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0422",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0434",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0425",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0417",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0416",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0414",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0410",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0408",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "/",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0434",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0425",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0424",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0422",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0417",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B1",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0455",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044F",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044D",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044A",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0447",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0445",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0442",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0437",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0436",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0434",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0431",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0430",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042F",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0424",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0414",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0410",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0408",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "/",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04B0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0434",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0425",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0422",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0417",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0416",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0414",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0410",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0408",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\\\\\\\\",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "/",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044A",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0447",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0442",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0431",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u042D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0424",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0458",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0458",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u04B1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u044A",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u0442",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\\\\\\\\",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "*",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04B1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u044A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0442",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0437",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0436",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0434",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\\\\\\\\",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "?",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "*",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0445",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0442",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "?",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "*",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0458",
    k: -119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\\\\\\\\",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u044A",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0445",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0442",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0434",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\\\\\\\\",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "?",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u04B1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\\\\\\\\",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u044F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0434",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0430",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0431",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0430",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0458",
    k: -119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0458",
    k: -119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\u0458",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\\\\\\\\",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "*",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0434",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\\\\\\\\",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "*",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "\\\\\\\\",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0458",
    u2: "\u0458",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "\\\\\\\\",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "*",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u04B1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u044F",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u044D",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u044A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0447",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0445",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0442",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0437",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0436",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0434",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0431",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0430",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u042F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0424",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0414",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0410",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "/",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u044F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u044D",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u0437",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u0434",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u0431",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u0430",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "j",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB8",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBC",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECA",
    u2: "j",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECB",
    u2: "j",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0166",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0166",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "four.denominator",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    g2: "seven.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "A.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "J.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "seven.lnum",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "one.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "3",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0135",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012D",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012B",
    k: -95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0129",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEF",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.numerator",
    u2: "\u2044",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "V.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u02BC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "?",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "X.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "V.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u02BC",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\\\\\\\\",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u0259",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xF0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "X",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "/",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u02BC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u0259",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xF0",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "X",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "/",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: " ",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "S.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    u2: "\u02BC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "seven.lnum",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "one.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\\\\\\\\",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "/",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J.sc",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "@",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "/",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\\\\\\\\",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "V",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Z.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "X.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "V.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u02BC",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\\\\\\\\",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "X",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J.sc",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "S.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "\u02BC",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "@",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "/",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: ")",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "U.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u02BC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0259",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u018F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0159",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0131",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u012B",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0129",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xF0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xDF",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xAE",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xA9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "@",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "9",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "5",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "4",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "/",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "&",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: " ",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "J.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\\\\\\\\",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "V",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J.sc",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "S.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "\u02BC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "@",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "/",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "j",
    k: -65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    u2: "\u02BC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "A.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "V.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u02BC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\\\\\\\\",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "?",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "S.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "\u02BC",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "@",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "/",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: ")",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y.sc",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "V.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T.sc",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2122",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2120",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u02BC",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xBA",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xB7",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAE",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAA",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA9",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\\\\\\\\",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "V",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "?",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "*",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: " ",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    g2: "seven.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: "/",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "v",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\\\\\\\\",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "X",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "?",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "*",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "four.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "zero.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\xB0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\\\\\\\\",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "+",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J.sc",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: " ",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q.alt",
    u2: "j",
    k: -64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u2122",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u02BC",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u0166",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "X",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "V.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u02BC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\\\\\\\\",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "*",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "six.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "seven.lnum",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "four.lnum",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "zero.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\u2212",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xF7",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xD7",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xB7",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xA2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\\\\\\\\",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "=",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "/",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "+",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "#",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lnum",
    g2: "seven.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "X.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "V.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u02BC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\\\\\\\\",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "X",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "*",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: ")",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u0259",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xF0",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "V",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "@",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "/",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: " ",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    g2: "four.lnum",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    u2: "\xF7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    u2: "+",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y.sc",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "V.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "S.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2122",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2120",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u02BC",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xBA",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAE",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAA",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\\\\\\\\",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "V",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "?",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "*",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "X.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J.sc",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\u02BC",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\\\\\\\\",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "X",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "V",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "/",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: ")",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "J,Jcircumflex",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "AE,AEacute",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quoteright,quotedblright",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quotedbl,quotesingle",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "AE,AEacute",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quoteright,quotedblright",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J,Jcircumflex",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "space",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "slash",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "zero",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "three",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "five",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "nine",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "at",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "eth",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0394",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotleft,guilsinglleft",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotright,guilsinglright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "S.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four.lnum",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0408",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0410",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0430",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0414",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0409,uni041B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0434",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni043B,uni0459",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0455",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "J,Jcircumflex",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni0409,uni041B",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni043B,uni0459",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quotedbl,quotesingle",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J,Jcircumflex",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "three",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "four",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0394",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0408",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "two",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "x",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T.sc",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Z.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one.lnum",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven.lnum",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0416",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0422",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni040E,uni0423",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0425",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0427",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni042A",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0402,uni040B",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0436",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0437",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0442",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0443,uni045E",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0445",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0447",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni044A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni04B0",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni04B1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quotedbl,quotesingle",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "seven",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "v",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y.alt",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V.sc",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.alt",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y.sc",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0422",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni040E,uni0423",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0427",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni042A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0402,uni040B",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0442",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0443,uni045E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0447",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni044A",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni04B0",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni04B1",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Schwa",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteleft,quotedblleft",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "zero.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0404,uni041E,uni0421",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0424",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "J,Jcircumflex",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "AE,AEacute",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0409,uni041B",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni043B,uni0459",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0443,uni045E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0404,uni041E,uni0421",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni03A9,Omega",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "quotedbl,quotesingle",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "AE,AEacute",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "AE,AEacute",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "AE,AEacute",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "J,Jcircumflex",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "AE,AEacute",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "quotedbl,quotesingle",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni0422",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni042A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni0402,uni040B",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni04B0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quoteright,quotedblright",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quotedbl,quotesingle",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "AE,AEacute",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quoteright,quotedblright",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0409,uni041B",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0402,uni040B",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0443,uni045E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0404,uni041E,uni0421",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "periodcentered",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "J,Jcircumflex",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "AE,AEacute",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "eth",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0394",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "S.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0408",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0410",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0430",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0414",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0409,uni041B",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0434",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni043B,uni0459",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0455",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "Schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J,Jcircumflex",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "AE,AEacute",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "space",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "slash",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "at",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "eth",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotleft,guilsinglleft",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotright,guilsinglright",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "S.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0408",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0410",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0430",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0414",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0409,uni041B",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0434",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni043B,uni0459",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0455",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "Schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0404,uni041E,uni0421",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quotedbl,quotesingle",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0434",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni043B,uni0459",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0422",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni040E,uni0423",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni042A",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0402,uni040B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0442",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni044A",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni04B0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quotedbl,quotesingle",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J,Jcircumflex",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quoteright,quotedblright",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0394",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J.sc",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0408",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0414",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0409,uni041B",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0434",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni043B,uni0459",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni044D",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "v",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "x",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y.sc",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0416",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0422",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni040E,uni0423",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0427",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni042A",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0402,uni040B",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0436",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0437",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0442",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0443,uni045E",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0445",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni044A",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni04B0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni04B1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "pi",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni042F",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "J,Jcircumflex",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "AE,AEacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "AE,AEacute",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0404,uni041E,uni0421",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quotedbl,quotesingle",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteright,quotedblright",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "space",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "zero",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "at",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eth",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "schwa",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "seven",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Schwa",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteleft,quotedblleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "asterisk",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "six",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "question",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "backslash",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "copyright",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordfeminine",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "registered",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordmasculine",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "apostrophe",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "servicemark",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "trademark",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "J.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "X",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "apostrophe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J,Jcircumflex",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "slash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "four",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "V",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "X",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "x",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "backslash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "apostrophe",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "eth",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "schwa",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "guillemotleft,guilsinglleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "seven",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "v",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Y.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Schwa",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "apostrophe",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "U.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J,Jcircumflex",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "AE,AEacute",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotleft,guilsinglleft",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotright,guilsinglright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "colon,semicolon",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "AE,AEacute",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "apostrophe",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "eth",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J,Jcircumflex",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "AE,AEacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "slash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "eth",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "apostrophe",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "space",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "zero",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "eth",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "guillemotleft,guilsinglleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "T.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Y.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Schwa",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "copyright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "registered",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "apostrophe",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "U.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quotedbl,quotesingle",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "AE,AEacute",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteright,quotedblright",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "space",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "eth",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "guillemotleft,guilsinglleft",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "seven",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "v",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w.alt",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y.alt",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V.sc",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.alt",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.sc",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Schwa",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteleft,quotedblleft",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "asterisk",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "question",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "backslash",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "copyright",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordfeminine",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "registered",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordmasculine",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "apostrophe",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "servicemark",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "trademark",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "periodcentered",
    k: 159
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J,Jcircumflex",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "AE,AEacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "slash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "four",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "V",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "X",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "backslash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "apostrophe",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "parenright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "J,Jcircumflex",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "AE,AEacute",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "eth",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "schwa",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "apostrophe",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "seven",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "x",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "ordfeminine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "apostrophe",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J,Jcircumflex",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "AE,AEacute",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "space",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "slash",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "zero",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "three",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "four",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "five",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "nine",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "at",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "eth",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "schwa",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "S.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "one",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "two",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "seven",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "v",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "x",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w.alt",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y.alt",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "T.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "V.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "W.sc",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "X.sc",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Y.sc",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Z.sc",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Schwa",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "six",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "copyright",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "registered",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "apostrophe",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "U.sc",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "colon,semicolon",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "ampersand",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "eight",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J,Jcircumflex",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "AE,AEacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "slash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "four",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "eth",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "apostrophe",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "AE,AEacute",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotleft,guilsinglleft",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotright,guilsinglright",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "AE,AEacute",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "space",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "slash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "zero",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "three",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "four",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "five",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "nine",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "at",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eth",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "schwa",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A.sc",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "one",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "two",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Schwa",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "six",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "copyright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "registered",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "apostrophe",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "U.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "colon,semicolon",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ampersand",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eight",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "guillemotleft,guilsinglleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J,Jcircumflex",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "AE,AEacute",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "space",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "slash",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "zero",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "three",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "four",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "five",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "nine",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "at",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eth",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "schwa",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotright,guilsinglright",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S.sc",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J.sc",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A.sc",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "one",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "two",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "v",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "x",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "V.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "W.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "X.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Y.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Schwa",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "six",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "copyright",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "registered",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "apostrophe",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "U.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "colon,semicolon",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ampersand",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eight",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "zero",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "eth",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "schwa",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "V.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "W.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "Y.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "Schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "copyright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "registered",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "apostrophe",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "U.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quotedbl,quotesingle",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "J,Jcircumflex",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteright,quotedblright",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteleft,quotedblleft",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J,Jcircumflex",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "AE,AEacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotright,guilsinglright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J,Jcircumflex",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "AE,AEacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "backslash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "apostrophe",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quotedbl,quotesingle",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "J,Jcircumflex",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteright,quotedblright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "V",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteleft,quotedblleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "asterisk",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "question",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "backslash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "apostrophe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "servicemark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "trademark",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "parenright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "bracketright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "braceright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "eth",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "guillemotleft,guilsinglleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "v",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "asterisk",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "question",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "backslash",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "apostrophe",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "apostrophe",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "X",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "x",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "question",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "backslash",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "apostrophe",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "J,Jcircumflex",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "AE,AEacute",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "space",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "slash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "at",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "eth",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotleft,guilsinglleft",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotright,guilsinglright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "V",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "X",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W.alt",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "backslash",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "apostrophe",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "trademark",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "parenright",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteright,quotedblright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "asterisk",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "backslash",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "apostrophe",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "apostrophe",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "eth",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "schwa",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "guillemotleft,guilsinglleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "AE,AEacute",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "space",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "asterisk",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "backslash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "copyright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordfeminine",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "registered",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordmasculine",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "apostrophe",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "servicemark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "periodcentered",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "asterisk",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "question",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "backslash",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "apostrophe",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "trademark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "J,Jcircumflex",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteright,quotedblright",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "V",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "asterisk",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "question",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "backslash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "apostrophe",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "servicemark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "trademark",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "parenright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "J,Jcircumflex",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "AE,AEacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "space",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "slash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "at",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "eth",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "schwa",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "X",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "apostrophe",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "backslash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "apostrophe",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "eth",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "schwa",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "backslash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "apostrophe",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "V",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "backslash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "J,Jcircumflex",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "AE,AEacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "J,Jcircumflex",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "AE,AEacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "space",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "slash",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "at",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "eth",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "X",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "backslash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "apostrophe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "J,Jcircumflex",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "AE,AEacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "space",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "slash",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "at",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "eth",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "X",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "backslash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "apostrophe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "parenright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "eth",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "apostrophe",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "J,Jcircumflex",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "AE,AEacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "J,Jcircumflex",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "AE,AEacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "J,Jcircumflex",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "AE,AEacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "X",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "backslash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "J,Jcircumflex",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "AE,AEacute",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotright,guilsinglright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "quotedbl,quotesingle",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "quoteright,quotedblright",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "guillemotleft,guilsinglleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "uni03A9,Omega",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A9,Omega",
    g2: "uni0394",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A9,Omega",
    g2: "backslash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "pi",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "pi",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "backslash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "apostrophe",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J,Jcircumflex",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "AE,AEacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotright,guilsinglright",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J,Jcircumflex",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J,Jcircumflex",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "guillemotright,guilsinglright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J,Jcircumflex",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "guillemotright,guilsinglright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J,Jcircumflex",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "AE,AEacute",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotright,guilsinglright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quotedbl,quotesingle",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "AE,AEacute",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteright,quotedblright",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotright,guilsinglright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteleft,quotedblleft",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J,Jcircumflex",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "AE,AEacute",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotright,guilsinglright",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quotedbl,quotesingle",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J,Jcircumflex",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteright,quotedblright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteleft,quotedblleft",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "asterisk",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "question",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "backslash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "apostrophe",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "parenright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J,Jcircumflex",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteright,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quotedbl,quotesingle",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteright,quotedblright",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteleft,quotedblleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J,Jcircumflex",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "AE,AEacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "uni0409,uni041B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "uni043B,uni0459",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quotedbl,quotesingle",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni040E,uni0423",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni0402,uni040B",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni0443,uni045E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quoteleft,quotedblleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "quotedbl,quotesingle",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "quoteright,quotedblright",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni040E,uni0423",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0402,uni040B",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0443,uni045E",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "quoteleft,quotedblleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0404,uni041E,uni0421",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni0409,uni041B",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni040E,uni0423",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni0443,uni045E",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni0409,uni041B",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni043B,uni0459",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni040E,uni0423",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni0402,uni040B",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni0443,uni045E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "guillemotleft,guilsinglleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0430",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni044D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni044F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0455",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0442",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0443,uni045E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni044A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni04B1",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0404,uni041E,uni0421",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0424",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni042D",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0405",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0417",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0443,uni045E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0404,uni041E,uni0421",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "slash",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "guillemotleft,guilsinglleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0442",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0443,uni045E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0447",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni044A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni04B1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0404,uni041E,uni0421",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0431",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "slash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0408",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0410",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0414",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0409,uni041B",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0434",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni043B,uni0459",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni044F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0416",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0422",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni040E,uni0423",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0425",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni042A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0402,uni040B",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0436",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0437",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0445",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni04B0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni042F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "parenright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni042D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0417",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni0409,uni041B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni043B,uni0459",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0421",
    g2: "uni0409,uni041B",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0421",
    g2: "uni0404,uni041E,uni0421",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "guillemotleft,guilsinglleft",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "guillemotright,guilsinglright",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0409,uni041B",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni043B,uni0459",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0443,uni045E",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0404,uni041E,uni0421",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "colon,semicolon",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "slash",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "guillemotleft,guilsinglleft",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "guillemotright,guilsinglright",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0408",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0410",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0430",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0414",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0409,uni041B",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0434",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni043B,uni0459",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni044D",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni044F",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0455",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0436",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0437",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0443,uni045E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0445",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0447",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni04B1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0404,uni041E,uni0421",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0424",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0431",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni042F",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "colon,semicolon",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni042D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0405",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0417",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "exclam",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni0409,uni041B",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni043B,uni0459",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni040E,uni0423",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni0402,uni040B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "guillemotleft,guilsinglleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0443,uni045E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0404,uni041E,uni0421",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quotedbl,quotesingle",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quoteright,quotedblright",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0409,uni041B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0422",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni040E,uni0423",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0425",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni042A",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0402,uni040B",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0442",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0443,uni045E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0445",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni044A",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni04B0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni04B1",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quoteleft,quotedblleft",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "asterisk",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "question",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "backslash",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quotedbl,quotesingle",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quoteright,quotedblright",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0409,uni041B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni040E,uni0423",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0402,uni040B",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0443,uni045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quoteleft,quotedblleft",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0404",
    g2: "uni0409,uni041B",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0404",
    g2: "uni0404,uni041E,uni0421",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0405",
    g2: "uni0409,uni041B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0405",
    g2: "uni0443,uni045E",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "slash",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "guillemotleft,guilsinglleft",
    k: 126
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "guillemotright,guilsinglright",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0408",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0410",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0430",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0414",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0409,uni041B",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0434",
    k: 183
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni043B,uni0459",
    k: 175
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 189
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni044D",
    k: 158
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni044F",
    k: 174
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0455",
    k: 158
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0436",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0437",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0442",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0443,uni045E",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0445",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0447",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni044A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni04B1",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0404,uni041E,uni0421",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0424",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0431",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni042F",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "colon,semicolon",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni042D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0443,uni045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0447",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni04B1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0404,uni041E,uni0421",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0456,uni0457,uni0458",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni0409,uni041B",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni043B,uni0459",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni040E,uni0423",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni0402,uni040B",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni0443,uni045E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0455",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "guillemotleft,guilsinglleft",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "guillemotright,guilsinglright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0409,uni041B",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni043B,uni0459",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0443,uni045E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0404,uni041E,uni0421",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "colon,semicolon",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0431",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0431",
    g2: "uni043B,uni0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0431",
    g2: "uni0443,uni045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "uni043B,uni0459",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "slash",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "guillemotleft,guilsinglleft",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "guillemotright,guilsinglright",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni0430",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni0434",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni043B,uni0459",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni044F",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0443,uni045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0447",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni04B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0431",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "question",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "backslash",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0434",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni043B,uni0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0442",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0445",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni044A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni04B1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "question",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "backslash",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0436",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0436",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0436",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "uni043B,uni0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "uni0443,uni045E",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0438,uni0439,uni043B,uni043C,uni043D,uni043F,uni0447,uni0448,uni044B,uni044F,uni045D,uni045F",
    g2: "backslash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "guillemotleft,guilsinglleft",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni0431",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "backslash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "quoteright,quotedblright",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0434",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni043B,uni0459",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni044D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni044F",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0436",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0437",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0442",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0443,uni045E",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0445",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni044A",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni04B1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "quoteleft,quotedblleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "asterisk",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "question",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "backslash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "parenright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "guillemotleft,guilsinglleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "uni043B,uni0459",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "uni0443,uni045E",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "guillemotleft,guilsinglleft",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "guillemotright,guilsinglright",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "uni043B,uni0459",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "slash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0430",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0434",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni043B,uni0459",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni044D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni044F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0455",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0437",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0431",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "backslash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "parenright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0445",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0445",
    g2: "guillemotleft,guilsinglleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0445",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "quotedbl,quotesingle",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "quoteright,quotedblright",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0442",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0443,uni045E",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0447",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni044A",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni04B1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "quoteleft,quotedblleft",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "asterisk",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "question",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "backslash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "quoteright,quotedblright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "uni0443,uni045E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "quoteleft,quotedblleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "uni043B,uni0459",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "uni0443,uni045E",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "uni043B,uni0459",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "uni0443,uni045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "quoteright,quotedblright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "uni0443,uni045E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "quoteleft,quotedblleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "guillemotleft,guilsinglleft",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "uni043B,uni0459",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 19
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRalewayBold);
export default __webpack_public_path__ + "static/media/Raleway-Bold.1f675731352251cc4b2205c3a21bff64.svg";
export { ForwardRef as ReactComponent };